// @ts-nocheck
import React, { useState, useEffect, useCallback } from "react";
import { getCached, setCached, swrLoad, invalidate } from "./pages/dataCache";
import KanbanPage from "./pages/KanbanPage";
import EquipmentPage from "./pages/EquipmentPage";
import InventoryPage from "./pages/InventoryPage";
import WorkOrdersPage from "./pages/WorkOrdersPage";
import ProgramsPage from "./pages/development/ProgramsTab";
import HRPage from "./pages/HRPage";
import MessagingPage from "./pages/MessagingPage";
import CustomersPage from "./pages/CustomersPage";
import SalesPage from "./pages/SalesPage";
import SprintPage from "./pages/development/SprintReviewTab";
import DocumentsPage from "./pages/DocumentsPage";
import TeamWinsPage from "./pages/TeamWinsPage";
import MetricsPage from "./pages/MetricsPage";
import ImportPage from "./pages/ImportPage";
import LabelDesignerPage from "./pages/LabelDesignerPage";
import EpicorReportsPage from "./pages/EpicorReportsPage";
import MaterialTrackerPage from "./pages/MaterialTrackerPage";
import CornholePage from "./pages/CornholePage";

// ─── Icons (inline SVG components) ─────────────────────────────────────────
const Icon = ({ d, size = 20, color = "currentColor", ...props }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d={d}/></svg>
);
const Icons = {
  Home: (p) => <Icon d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10" {...p}/>,
  Rocket: (p) => <Icon d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0 M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" {...p}/>,
  Calendar: (p) => <Icon d="M19 4H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2z M16 2v4 M8 2v4 M3 10h18" {...p}/>,
  Kanban: (p) => <Icon d="M6 5v11 M18 5v6 M12 5v14 M2 5h4 M8 5h8 M16 5h4" {...p}/>,
  Wrench: (p) => <Icon d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" {...p}/>,
  Package: (p) => <Icon d="M16.5 9.4l-9-5.19 M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z M3.27 6.96L12 12.01l8.73-5.05 M12 22.08V12" {...p}/>,
  File: (p) => <Icon d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8" {...p}/>,
  Bell: (p) => <Icon d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 01-3.46 0" {...p}/>,
  Plus: (p) => <Icon d="M12 5v14 M5 12h14" {...p}/>,
  Users: (p) => <Icon d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2 M9 11a4 4 0 100-8 4 4 0 000 8z M23 21v-2a4 4 0 00-3-3.87 M16 3.13a4 4 0 010 7.75" {...p}/>,
  Chart: (p) => <Icon d="M18 20V10 M12 20V4 M6 20v-6" {...p}/>,
  Trophy: (p) => <Icon d="M6 9H4.5a2.5 2.5 0 010-5H6 M18 9h1.5a2.5 2.5 0 000-5H18 M4 22h16 M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20 7 22h10c0-2-1-3.25-2.03-3.79A1.07 1.07 0 0114 17v-2.34 M18 2H6v7a6 6 0 0012 0V2z" {...p}/>,
  Search: (p) => <Icon d="M11 19a8 8 0 100-16 8 8 0 000 16z M21 21l-4.35-4.35" {...p}/>,
  Clock: (p) => <Icon d="M12 22a10 10 0 100-20 10 10 0 000 20z M12 6v6l4 2" {...p}/>,
  Check: (p) => <Icon d="M20 6L9 17l-5-5" {...p}/>,
  Alert: (p) => <Icon d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z M12 9v4 M12 17h.01" {...p}/>,
  ArrowRight: (p) => <Icon d="M5 12h14 M12 5l7 7-7 7" {...p}/>,
  Settings: (p) => <Icon d="M12 15a3 3 0 100-6 3 3 0 000 6z" {...p}/>,
  Clipboard: (p) => <Icon d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2 M9 2h6a1 1 0 011 1v1a1 1 0 01-1 1H9a1 1 0 01-1-1V3a1 1 0 011-1z" {...p}/>,
  MessageSquare: (p) => <Icon d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" {...p}/>,
  Send: (p) => <Icon d="M22 2L11 13 M22 2l-7 20-4-9-9-4 20-7z" {...p}/>,
  Shield: (p) => <Icon d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" {...p}/>,
  Upload: (p) => <Icon d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4 M17 8l-5-5-5 5 M12 3v12" {...p}/>,
  Download: (p) => <Icon d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4 M7 10l5 5 5-5 M12 15V3" {...p}/>,
  Eye: (p) => <Icon d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z M12 9a3 3 0 100 6 3 3 0 000-6z" {...p}/>,
  Database: (p) => <Icon d="M12 2C6.48 2 2 4.02 2 6.5v11C2 19.98 6.48 22 12 22s10-2.02 10-4.5v-11C22 4.02 17.52 2 12 2z M2 6.5C2 8.98 6.48 11 12 11s10-2.02 10-4.5 M2 12c0 2.48 4.48 4.5 10 4.5s10-2.02 10-4.5" {...p}/>,
  X: (p) => <Icon d="M18 6L6 18 M6 6l12 12" {...p}/>,
  Moon: (p) => <Icon d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" {...p}/>,
  Sun: (p) => <Icon d="M12 17a5 5 0 100-10 5 5 0 000 10z M12 1v2 M12 21v2 M4.22 4.22l1.42 1.42 M18.36 18.36l1.42 1.42 M1 12h2 M21 12h2 M4.22 19.78l1.42-1.42 M18.36 5.64l1.42-1.42" {...p}/>,
};

// ─── Mock Data ──────────────────────────────────────────────────────────────
const MOCK = {
  user: { name: "Jay M", role: "Engineering Manager", initials: "JM" },
  programs: [
    { id: 1, code: "FPD", name: "Friction Product Development", health: "green", status: "Active", completion: 34, lead: "Jay M", children: [
      { id: 2, code: "FPD-TAR", name: "Thick Aftermarket Replacement", health: "green", status: "Active", completion: 45 },
      { id: 3, code: "FPD-MDW", name: "Mid-Tier Drag Washer", health: "yellow", status: "Active", completion: 22 },
      { id: 4, code: "FPD-CBC", name: "Carbon Brush Composite", health: "green", status: "Planning", completion: 5 },
    ]},
  ],
  sprint: { name: "Sprint 24-08", days_remaining: 6, total_tasks: 18, done: 11, blocked: 2, in_progress: 5 },
  myTasks: [
    { id: 1, title: "Finalize TAR-200 material spec", status: "in_progress", priority: "high", due: "Feb 22", program: "FPD-TAR" },
    { id: 2, title: "Review MDW friction test results", status: "in_progress", priority: "medium", due: "Feb 24", program: "FPD-MDW" },
    { id: 3, title: "Submit CBC sample order to Shimano", status: "todo", priority: "high", due: "Feb 25", program: "FPD-CBC" },
    { id: 4, title: "Update BOM for TAR-200 rev C", status: "todo", priority: "medium", due: "Feb 26", program: "FPD-TAR" },
    { id: 5, title: "Calibrate pin-on-disc tribometer", status: "blocked", priority: "urgent", due: "Feb 21", program: "FPD" },
  ],
  helpRequests: [
    { id: 1, from: "Aaron Roy", context: "Need help interpreting wear rate data on MDW-100 samples", status: "pending", time: "2h ago" },
  ],
  upcomingBookings: [
    { id: 1, equipment: "Pin-on-Disc Tribometer", date: "Feb 21", time: "9:00 AM - 12:00 PM" },
    { id: 2, equipment: "Instron 5969", date: "Feb 24", time: "1:00 PM - 4:00 PM" },
  ],
  workOrders: [
    { id: 1, number: "WO-2026-0042", title: "Prepare MDW-100 test coupons", status: "in_progress", assigned: "Rianna Sousa" },
    { id: 2, number: "WO-2026-0043", title: "Run TAR-200 compression test", status: "submitted", assigned: "Sam Rosa" },
  ],
  recentDocs: [
    { id: 1, name: "TAR-200 Material Spec v2.1.pdf", updated: "2h ago", owner: "Jay M" },
    { id: 2, name: "MDW Friction Test Protocol.docx", updated: "1d ago", owner: "John Gaffney" },
    { id: 3, name: "FPD Q1 2026 Status Report.pptx", updated: "3d ago", owner: "Jay M" },
  ],
};

// ─── Theme ──────────────────────────────────────────────────────────────────
const darkTheme = {
  bg: "#0B1120", surface: "#111827", surfaceHover: "#1a2332",
  border: "#1E293B", borderLight: "#334155",
  text: "#E2E8F0", textMuted: "#94A3B8", textDim: "#64748B",
  accent: "#3B82F6", accentGlow: "rgba(59, 130, 246, 0.15)",
  green: "#10B981", yellow: "#F59E0B", red: "#EF4444",
  purple: "#8B5CF6", orange: "#F97316",
  cardShadow: "none", mode: "dark",
};
const lightTheme = {
  bg: "#F1F5F9", surface: "#FFFFFF", surfaceHover: "#F8FAFC",
  border: "#E2E8F0", borderLight: "#CBD5E1",
  text: "#1E293B", textMuted: "#475569", textDim: "#94A3B8",
  accent: "#3B82F6", accentGlow: "rgba(59, 130, 246, 0.08)",
  green: "#10B981", yellow: "#F59E0B", red: "#EF4444",
  purple: "#8B5CF6", orange: "#F97316",
  cardShadow: "0 1px 3px rgba(0,0,0,0.08)", mode: "light",
};
let themeMode = (typeof localStorage !== 'undefined' && localStorage.getItem('engportal-theme')) || 'dark';
let theme = themeMode === 'light' ? lightTheme : darkTheme;
(window as any).__ENGPORTAL_THEME = theme;
// Expose theme to CSS (used by the Development module's programs.css and any
// variable-driven styles) so plain CSS can track light/dark like the JS theme.
try { if (typeof document !== 'undefined') document.documentElement.setAttribute('data-theme', themeMode); } catch (e) {}

const healthColor = (h) => h === "green" ? theme.green : h === "yellow" ? theme.yellow : theme.red;
const priorityColor = (p) => p === "urgent" ? theme.red : p === "high" ? theme.orange : p === "medium" ? theme.yellow : theme.textDim;
const statusColor = (s) => s === "in_progress" ? theme.accent : s === "blocked" ? theme.red : s === "done" ? theme.green : theme.textDim;

// ─── Reusable Components ────────────────────────────────────────────────────
const Card = ({ children, style, onClick, hover = false }) => (
  <div style={{
    background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 12,
    padding: 20, transition: "all 0.2s", cursor: onClick ? "pointer" : "default",
    ...(hover ? { ":hover": { borderColor: theme.accent } } : {}), ...style
  }} onClick={onClick} onMouseEnter={e => { if (hover) { e.currentTarget.style.borderColor = theme.accent; e.currentTarget.style.background = theme.surfaceHover; }}}
     onMouseLeave={e => { if (hover) { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.background = theme.surface; }}}>
    {children}
  </div>
);

const Badge = ({ color, children }) => (
  <span style={{
    background: `${color}22`, color, fontSize: 11, fontWeight: 600,
    padding: "3px 8px", borderRadius: 6, letterSpacing: 0.3, textTransform: "uppercase"
  }}>{children}</span>
);

const ProgressBar = ({ value, color = theme.accent, height = 6 }) => (
  <div style={{ background: theme.border, borderRadius: height, height, width: "100%", overflow: "hidden" }}>
    <div style={{ background: color, height: "100%", width: `${Math.min(value, 100)}%`, borderRadius: height, transition: "width 0.6s ease" }} />
  </div>
);

const QuickAction = ({ icon, label, count, color, onClick }) => (
  <div onClick={onClick} style={{
    display: "flex", flexDirection: "column", alignItems: "center", gap: 8,
    padding: "16px 12px", borderRadius: 12, cursor: "pointer", transition: "all 0.2s",
    background: theme.surface, border: `1px solid ${theme.border}`, minWidth: 100, position: "relative"
  }} onMouseEnter={e => { e.currentTarget.style.borderColor = color; e.currentTarget.style.background = theme.surfaceHover; e.currentTarget.style.transform = "translateY(-2px)"; }}
     onMouseLeave={e => { e.currentTarget.style.borderColor = theme.border; e.currentTarget.style.background = theme.surface; e.currentTarget.style.transform = "translateY(0)"; }}>
    <div style={{ color, opacity: 0.9 }}>{icon}</div>
    <span style={{ color: theme.text, fontSize: 12, fontWeight: 500, textAlign: "center" }}>{label}</span>
    {count !== undefined && <span style={{ position: "absolute", top: 8, right: 8, background: color, color: "#fff", fontSize: 10, fontWeight: 700, padding: "2px 6px", borderRadius: 10, minWidth: 18, textAlign: "center" }}>{count}</span>}
  </div>
);

const SectionHeader = ({ icon, title, action }) => (
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <div style={{ color: theme.accent }}>{icon}</div>
      <h3 style={{ color: theme.text, fontSize: 15, fontWeight: 600, margin: 0, letterSpacing: -0.3 }}>{title}</h3>
    </div>
    {action}
  </div>
);

const TextLink = ({ children, onClick }) => (
  <span onClick={onClick} style={{ color: theme.accent, fontSize: 12, cursor: "pointer", fontWeight: 500 }}
    onMouseEnter={e => e.target.style.textDecoration = "underline"}
    onMouseLeave={e => e.target.style.textDecoration = "none"}>
    {children}
  </span>
);

// ─── Modal ──────────────────────────────────────────────────────────────────
const Modal = ({ open, onClose, title, children, width = 520 }) => {
  if (!open) return null;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center" }}
         onClick={onClose}>
      <div style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.6)", backdropFilter: "blur(4px)" }} />
      <div onClick={e => e.stopPropagation()} style={{
        background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 16,
        width, maxWidth: "90vw", maxHeight: "85vh", overflow: "auto", position: "relative", padding: 24,
        boxShadow: "0 25px 50px rgba(0,0,0,0.5)"
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h2 style={{ color: theme.text, fontSize: 18, fontWeight: 600, margin: 0 }}>{title}</h2>
          <button onClick={onClose} style={{ background: "none", border: "none", color: theme.textDim, fontSize: 22, cursor: "pointer", padding: "4px 8px" }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
};

const FormField = ({ label, children, required }) => (
  <div style={{ marginBottom: 16 }}>
    <label style={{ display: "block", color: theme.textMuted, fontSize: 12, fontWeight: 600, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 }}>
      {label} {required && <span style={{ color: theme.red }}>*</span>}
    </label>
    {children}
  </div>
);

const inputStyle = {
  width: "100%", padding: "10px 14px", background: theme.bg, border: `1px solid ${theme.border}`,
  borderRadius: 8, color: theme.text, fontSize: 14, outline: "none", boxSizing: "border-box",
};

const selectStyle = { ...inputStyle, appearance: "auto" };

const btnPrimary = {
  background: theme.accent, color: "#fff", border: "none", borderRadius: 8,
  padding: "10px 20px", fontSize: 14, fontWeight: 600, cursor: "pointer", transition: "all 0.2s",
};

const btnSecondary = {
  background: "transparent", color: theme.textMuted, border: `1px solid ${theme.border}`, borderRadius: 8,
  padding: "10px 20px", fontSize: 14, fontWeight: 500, cursor: "pointer",
};

// ─── Quick Entry Forms (with state and API calls) ───────────────────────────
const QuickWorkOrderForm = ({ open, onClose }) => {
  const [form, setForm] = React.useState({ title: '', work_type: 'material_prep', priority: 'normal', program: '', assigned_to: '', needed_by: '', quantity: '', description: '' });
  const [files, setFiles] = React.useState([]);
  const [saving, setSaving] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const fileRef = React.useRef(null);
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const handleSubmit = async () => {
    if (!form.title) return alert('Title is required');
    setSaving(true);
    try {
      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
      const res = await fetch('/api/workorders/', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
        body: JSON.stringify({
          title: form.title, work_type: form.work_type, priority: form.priority,
          description: form.description, needed_by: form.needed_by || null,
          quantity: form.quantity ? parseFloat(form.quantity) : null,
        }),
      });
      if (res.ok) {
        const wo = await res.json();
        // Upload attachments if any
        for (const f of files) {
          const fd = new FormData();
          fd.append('file', f);
          fd.append('title', f.name);
          fd.append('work_order', wo.id);
          await fetch('/api/workorders/' + wo.id + '/attach/', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'X-CSRFToken': csrfToken }, body: fd,
          });
        }
        setSuccess(true);
        setTimeout(() => { setSuccess(false); onClose(); setForm({ title: '', work_type: 'material_prep', priority: 'normal', program: '', assigned_to: '', needed_by: '', quantity: '', description: '' }); setFiles([]); }, 1200);
      } else { const err = await res.text(); alert('Error: ' + err); }
    } catch (e) { alert('Network error: ' + e.message); }
    setSaving(false);
  };

  const removeFile = (i) => setFiles(prev => prev.filter((_, idx) => idx !== i));

  if (success) return <Modal open={open} onClose={onClose} title="Work Order Created">
    <div style={{ textAlign: 'center', padding: 40 }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>✓</div>
      <div style={{ color: theme.green, fontSize: 18, fontWeight: 600 }}>Work Order Created!</div>
    </div>
  </Modal>;

  return (
    <Modal open={open} onClose={onClose} title="Quick Work Order" width={560}>
      <FormField label="Title" required><input style={inputStyle} value={form.title} onChange={e => set('title', e.target.value)} placeholder="e.g. Prepare MDW test coupons" /></FormField>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
        <FormField label="Work Type"><select style={selectStyle} value={form.work_type} onChange={e => set('work_type', e.target.value)}>
          <option value="material_prep">Material Prep</option><option value="testing">Testing</option><option value="manufacturing">Manufacturing</option><option value="analysis">Analysis</option><option value="calibration">Calibration</option><option value="prototype">Prototype</option><option value="quality">Quality</option><option value="maintenance">Maintenance</option><option value="other">Other</option>
        </select></FormField>
        <FormField label="Priority"><select style={selectStyle} value={form.priority} onChange={e => set('priority', e.target.value)}>
          <option value="low">Low</option><option value="normal">Normal</option><option value="high">High</option><option value="urgent">Urgent</option>
        </select></FormField>
        <FormField label="Needed By"><input style={inputStyle} type="date" value={form.needed_by} onChange={e => set('needed_by', e.target.value)} /></FormField>
        <FormField label="Quantity"><input style={inputStyle} type="number" value={form.quantity} onChange={e => set('quantity', e.target.value)} placeholder="Optional" /></FormField>
      </div>
      <FormField label="Description & Specifications"><textarea style={{ ...inputStyle, height: 80, resize: "vertical" }} value={form.description} onChange={e => set('description', e.target.value)} placeholder="Detailed instructions, loading conditions, trial sheet references..." /></FormField>
      <FormField label="Attachments (worksheets, trial data, reference docs)">
        <div onClick={() => fileRef.current?.click()}
          onDragOver={e => e.preventDefault()}
          onDrop={e => { e.preventDefault(); setFiles(prev => [...prev, ...Array.from(e.dataTransfer.files)]); }}
          style={{ border: `2px dashed ${theme.border}`, borderRadius: 8, padding: files.length ? 10 : 20, textAlign: 'center', cursor: 'pointer' }}>
          <input ref={fileRef} type="file" multiple style={{ display: 'none' }} onChange={e => setFiles(prev => [...prev, ...Array.from(e.target.files)])} />
          {files.length === 0 ? (
            <><div style={{ color: theme.textDim, fontSize: 13 }}>Drop files here or click to upload</div><div style={{ color: theme.textDim, fontSize: 11, marginTop: 4 }}>Worksheets, trial sheets, loading specs, reference data</div></>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {files.map((f, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 8px', background: theme.bg, borderRadius: 6, textAlign: 'left' }}>
                  <span style={{ color: theme.text, fontSize: 12, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
                  <span style={{ color: theme.textDim, fontSize: 10 }}>{(f.size/1024).toFixed(0)}KB</span>
                  <button onClick={e => { e.stopPropagation(); removeFile(i); }} style={{ background: 'none', border: 'none', color: theme.red, cursor: 'pointer', fontSize: 14 }}>×</button>
                </div>
              ))}
              <div style={{ color: theme.accent, fontSize: 11, marginTop: 2 }}>+ Add more</div>
            </div>
          )}
        </div>
      </FormField>
      <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 8 }}>
        <button style={btnSecondary} onClick={onClose}>Cancel</button>
        <button style={btnPrimary} onClick={handleSubmit} disabled={saving}>{saving ? 'Saving...' : 'Submit Work Order'}</button>
      </div>
    </Modal>
  );
};

const QuickInventoryForm = ({ open, onClose }) => {
  const [form, setForm] = React.useState({ part_number: '', name: '', quantity: '', unit_of_measure: 'pcs', material_specification: '' });
  const [saving, setSaving] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const handleSubmit = async () => {
    if (!form.part_number || !form.name) return alert('Part number and name are required');
    setSaving(true);
    try {
      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
      const res = await fetch('/api/inventory/parts/', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
        body: JSON.stringify({
          part_number: form.part_number, name: form.name,
          quantity: form.quantity ? parseFloat(form.quantity) : 0,
          unit_of_measure: form.unit_of_measure,
          material_specification: form.material_specification,
        }),
      });
      if (res.ok) {
        setSuccess(true);
        setTimeout(() => { setSuccess(false); onClose(); setForm({ part_number: '', name: '', quantity: '', unit_of_measure: 'pcs', material_specification: '' }); }, 1200);
      } else { const err = await res.text(); alert('Error: ' + err); }
    } catch (e) { alert('Network error: ' + e.message); }
    setSaving(false);
  };

  if (success) return <Modal open={open} onClose={onClose} title="Part Added">
    <div style={{ textAlign: 'center', padding: 40 }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>✓</div>
      <div style={{ color: theme.green, fontSize: 18, fontWeight: 600 }}>Sample Added!</div>
    </div>
  </Modal>;

  return (
    <Modal open={open} onClose={onClose} title="Quick Add Sample" width={560}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
        <FormField label="Part Number" required><input style={inputStyle} value={form.part_number} onChange={e => set('part_number', e.target.value)} placeholder="e.g. TAR-200-A" /></FormField>
        <FormField label="Name" required><input style={inputStyle} value={form.name} onChange={e => set('name', e.target.value)} placeholder="e.g. Thick Aftermarket Pad" /></FormField>
        <FormField label="Quantity" required><input style={inputStyle} type="number" value={form.quantity} onChange={e => set('quantity', e.target.value)} placeholder="0" /></FormField>
        <FormField label="Unit"><select style={selectStyle} value={form.unit_of_measure} onChange={e => set('unit_of_measure', e.target.value)}><option>pcs</option><option>kg</option><option>lbs</option><option>sheets</option><option>liters</option></select></FormField>
      </div>
      <FormField label="Material Specification"><textarea style={{ ...inputStyle, height: 60, resize: "vertical" }} value={form.material_specification} onChange={e => set('material_specification', e.target.value)} placeholder="Brief spec summary..." /></FormField>
      <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 8 }}>
        <button style={btnSecondary} onClick={onClose}>Cancel</button>
        <button style={{ ...btnPrimary, background: theme.green }} onClick={handleSubmit} disabled={saving}>{saving ? 'Saving...' : 'Add Part'}</button>
      </div>
    </Modal>
  );
};

const QuickBookingForm = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose} title="Book Equipment" width={520}>
    <FormField label="Equipment" required><select style={selectStyle}><option>Select equipment...</option><option>Pin-on-Disc Tribometer</option><option>Instron 5969 Universal Tester</option><option>Keyence VHX-7000 Microscope</option><option>Shimadzu TGA-50</option></select></FormField>
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
      <FormField label="Date" required><input style={inputStyle} type="date" /></FormField>
      <FormField label="Program"><select style={selectStyle}><option>Select...</option><option>FPD-TAR</option><option>FPD-MDW</option></select></FormField>
      <FormField label="Start Time" required><input style={inputStyle} type="time" /></FormField>
      <FormField label="End Time" required><input style={inputStyle} type="time" /></FormField>
    </div>
    <FormField label="Purpose"><textarea style={{ ...inputStyle, height: 60, resize: "vertical" }} placeholder="What will you be testing?" /></FormField>
    <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 8 }}>
      <button style={btnSecondary} onClick={onClose}>Cancel</button>
      <button style={btnPrimary}>Book Equipment</button>
    </div>
  </Modal>
);

const QuickHelpForm = ({ open, onClose }) => {
  const [helpTo, setHelpTo] = React.useState('');
  const [helpDate, setHelpDate] = React.useState('');
  const [helpText, setHelpText] = React.useState('');
  const [helpSending, setHelpSending] = React.useState(false);
  const [helpUsers, setHelpUsers] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (open) fetch('/api/quality-docs/users-with-tags/', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : []).then(setHelpUsers).catch(() => {});
  }, [open]);

  return (
  <Modal open={open} onClose={onClose} title="Request Help" width={480}>
    <FormField label="Who do you need help from?" required>
      <select style={selectStyle} value={helpTo} onChange={e => setHelpTo(e.target.value)}>
        <option value="">Select team member...</option>
        {helpUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
      </select>
    </FormField>
    <FormField label="Needed By"><input style={inputStyle} type="date" value={helpDate} onChange={e => setHelpDate(e.target.value)} /></FormField>
    <FormField label="What do you need help with?" required><textarea style={{ ...inputStyle, height: 100, resize: "vertical" as const }} placeholder="Describe what you need..." value={helpText} onChange={e => setHelpText(e.target.value)} /></FormField>
    <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 8 }}>
      <button style={btnSecondary} onClick={onClose}>Cancel</button>
      <button disabled={!helpTo || !helpText.trim() || helpSending} style={{ ...btnPrimary, background: theme.orange, opacity: !helpTo || !helpText.trim() || helpSending ? 0.5 : 1 }} onClick={async () => {
        setHelpSending(true);
        try {
          const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
          const res = await fetch('/api/quality-docs/help-request/', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
            body: JSON.stringify({
              recipient: Number(helpTo),
              message: helpText,
              needed_by: helpDate,
            }),
          });
          if (res.ok) {
            alert('Help request sent!');
            onClose();
            setHelpTo(''); setHelpDate(''); setHelpText('');
          } else {
            alert('Failed to send. The notification system may need configuration.');
          }
        } catch (e) { alert('Failed to send request.'); }
        setHelpSending(false);
      }}>{helpSending ? 'Sending...' : 'Send Request'}</button>
    </div>
  </Modal>
  );
};

const QuickStandupForm = ({ open, onClose }) => {
  const [form, setForm] = React.useState({ yesterday: '', today: '', blockers: '' });
  const [saving, setSaving] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const handleSubmit = async () => {
    setSaving(true);
    try {
      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
      const res = await fetch('/api/sprints/standups/', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
        body: JSON.stringify({ yesterday: form.yesterday, today: form.today, blockers: form.blockers }),
      });
      if (res.ok) {
        setSuccess(true);
        setTimeout(() => { setSuccess(false); onClose(); setForm({ yesterday: '', today: '', blockers: '' }); }, 1200);
      } else { const err = await res.text(); alert('Error: ' + err); }
    } catch (e) { alert('Network error: ' + e.message); }
    setSaving(false);
  };

  if (success) return <Modal open={open} onClose={onClose} title="Standup Submitted">
    <div style={{ textAlign: 'center', padding: 40 }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>✓</div>
      <div style={{ color: theme.green, fontSize: 18, fontWeight: 600 }}>Standup Submitted!</div>
    </div>
  </Modal>;

  return (
    <Modal open={open} onClose={onClose} title="Daily Standup Update" width={520}>
      <FormField label="What did you accomplish yesterday?"><textarea style={{ ...inputStyle, height: 70, resize: "vertical" }} value={form.yesterday} onChange={e => set('yesterday', e.target.value)} placeholder="Completed items, progress made..." /></FormField>
      <FormField label="What are you working on today?"><textarea style={{ ...inputStyle, height: 70, resize: "vertical" }} value={form.today} onChange={e => set('today', e.target.value)} placeholder="Today's plan..." /></FormField>
      <FormField label="Any blockers or support needed?"><textarea style={{ ...inputStyle, height: 50, resize: "vertical" }} value={form.blockers} onChange={e => set('blockers', e.target.value)} placeholder="Issues, dependencies, help needed..." /></FormField>
      <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 8 }}>
        <button style={btnSecondary} onClick={onClose}>Cancel</button>
        <button style={{ ...btnPrimary, background: theme.green }} onClick={handleSubmit} disabled={saving}>{saving ? 'Submitting...' : 'Submit Update'}</button>
      </div>
    </Modal>
  );
};

const ProfileModal = ({ open, onClose, currentUser }) => {
  const [profile, setProfile] = React.useState(null);
  const [cur, setCur] = React.useState('');
  const [nw, setNw] = React.useState('');
  const [confirmPw, setConfirmPw] = React.useState('');
  const [msg, setMsg] = React.useState(null);
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => {
    if (!open) { setCur(''); setNw(''); setConfirmPw(''); setMsg(null); return; }
    fetch('/api/auth/profile/', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null).then(d => setProfile(d)).catch(() => setProfile(null));
  }, [open]);

  if (!open) return null;
  const p = profile || currentUser || {};
  const fullName = p.full_name || `${p.first_name || ''} ${p.last_name || ''}`.trim() || p.username || '—';
  const isSSO = profile && profile.has_usable_password === false;

  const submit = async () => {
    setMsg(null);
    if (!cur || !nw) { setMsg({ ok: false, text: 'Enter your current and new password.' }); return; }
    if (nw.length < 8) { setMsg({ ok: false, text: 'New password must be at least 8 characters.' }); return; }
    if (nw !== confirmPw) { setMsg({ ok: false, text: 'New password and confirmation do not match.' }); return; }
    setSaving(true);
    try {
      const csrf = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
      const res = await fetch('/api/auth/change-password/', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrf },
        body: JSON.stringify({ current_password: cur, new_password: nw }),
      });
      const d = await res.json().catch(() => ({}));
      if (res.ok) { setMsg({ ok: true, text: d.detail || 'Password changed successfully.' }); setCur(''); setNw(''); setConfirmPw(''); }
      else { setMsg({ ok: false, text: d.detail || 'Could not change password.' }); }
    } catch (e) { setMsg({ ok: false, text: 'Something went wrong. Please try again.' }); }
    setSaving(false);
  };

  const row = (label, value) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '8px 0', borderBottom: `1px solid ${theme.border}` }}>
      <span style={{ color: theme.textDim, fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 }}>{label}</span>
      <span style={{ color: theme.text, fontSize: 13, fontWeight: 500, textAlign: 'right' }}>{value || '—'}</span>
    </div>
  );

  return (
    <Modal open={open} onClose={onClose} title="My Profile" width={460}>
      <div style={{ marginBottom: 8 }}>
        {row('Name', fullName)}
        {row('Username', p.username)}
        {row('Email', p.email)}
        {row('Role', (p.role || '').replace(/_/g, ' '))}
      </div>

      <div style={{ marginTop: 20, paddingTop: 16, borderTop: `1px solid ${theme.border}` }}>
        <div style={{ color: theme.text, fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Change Password</div>
        {isSSO ? (
          <div style={{ color: theme.textMuted, fontSize: 12, lineHeight: 1.6, background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, padding: 12 }}>
            Your account signs in through single sign-on, so your password is managed there rather than here.
          </div>
        ) : (
          <>
            <FormField label="Current Password"><input type="password" autoComplete="current-password" style={inputStyle} value={cur} onChange={e => setCur(e.target.value)} /></FormField>
            <FormField label="New Password"><input type="password" autoComplete="new-password" style={inputStyle} value={nw} onChange={e => setNw(e.target.value)} placeholder="At least 8 characters" /></FormField>
            <FormField label="Confirm New Password"><input type="password" autoComplete="new-password" style={inputStyle} value={confirmPw} onChange={e => setConfirmPw(e.target.value)} /></FormField>
            {msg && <div style={{ fontSize: 12, marginBottom: 12, color: msg.ok ? theme.green : theme.red }}>{msg.text}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={submit} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, background: theme.accent, color: '#fff', border: 'none', cursor: saving ? 'default' : 'pointer', fontSize: 13, fontWeight: 600, opacity: saving ? 0.6 : 1 }}>{saving ? 'Saving…' : 'Update Password'}</button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

const QuickTaskForm = ({ open, onClose }) => {
  const [form, setForm] = React.useState({ title: '', description: '', priority: 'normal', due_date: '' });
  const [files, setFiles] = React.useState([]);
  const [saving, setSaving] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const fileRef = React.useRef(null);
  const set = (k, v) => setForm(prev => ({ ...prev, [k]: v }));

  const handleSubmit = async () => {
    if (!form.title) return alert('Title is required');
    setSaving(true);
    try {
      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
      const res = await fetch('/api/sprints/tasks/', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
        body: JSON.stringify({
          title: form.title, description: form.description,
          priority: form.priority, status: 'todo',
          due_date: form.due_date || null,
        }),
      });
      if (res.ok) {
        const task = await res.json();
        for (const f of files) {
          const fd = new FormData();
          fd.append('file', f);
          fd.append('title', f.name);
          fd.append('task', task.id);
          await fetch('/api/sprints/tasks/' + task.id + '/attach/', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'X-CSRFToken': csrfToken }, body: fd,
          });
        }
        setSuccess(true);
        setTimeout(() => { setSuccess(false); onClose(); setForm({ title: '', description: '', priority: 'normal', due_date: '' }); setFiles([]); }, 1200);
      } else { const err = await res.text(); alert('Error: ' + err); }
    } catch (e) { alert('Network error: ' + e.message); }
    setSaving(false);
  };

  const removeFile = (i) => setFiles(prev => prev.filter((_, idx) => idx !== i));

  if (success) return <Modal open={open} onClose={onClose} title="Task Created">
    <div style={{ textAlign: 'center', padding: 40 }}>
      <div style={{ fontSize: 48, marginBottom: 12 }}>✓</div>
      <div style={{ color: theme.green, fontSize: 18, fontWeight: 600 }}>Task Created!</div>
    </div>
  </Modal>;

  return (
    <Modal open={open} onClose={onClose} title="New Task" width={520}>
      <FormField label="Title" required><input style={inputStyle} value={form.title} onChange={e => set('title', e.target.value)} placeholder="e.g. Take SEM images of material XYZ" /></FormField>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
        <FormField label="Priority"><select style={selectStyle} value={form.priority} onChange={e => set('priority', e.target.value)}>
          <option value="low">Low</option><option value="normal">Normal</option><option value="high">High</option><option value="urgent">Urgent</option>
        </select></FormField>
        <FormField label="Due Date"><input style={inputStyle} type="date" value={form.due_date} onChange={e => set('due_date', e.target.value)} /></FormField>
      </div>
      <FormField label="Description"><textarea style={{ ...inputStyle, height: 70, resize: "vertical" }} value={form.description} onChange={e => set('description', e.target.value)} placeholder="What needs to be done, acceptance criteria..." /></FormField>
      <FormField label="Attachments (reference docs, specs)">
        <div onClick={() => fileRef.current?.click()}
          onDragOver={e => e.preventDefault()}
          onDrop={e => { e.preventDefault(); setFiles(prev => [...prev, ...Array.from(e.dataTransfer.files)]); }}
          style={{ border: `2px dashed ${theme.border}`, borderRadius: 8, padding: files.length ? 10 : 16, textAlign: 'center', cursor: 'pointer' }}>
          <input ref={fileRef} type="file" multiple style={{ display: 'none' }} onChange={e => setFiles(prev => [...prev, ...Array.from(e.target.files)])} />
          {files.length === 0 ? (
            <div style={{ color: theme.textDim, fontSize: 12 }}>Drop files or click to attach reference docs</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {files.map((f, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 8px', background: theme.bg, borderRadius: 6, textAlign: 'left' }}>
                  <span style={{ color: theme.text, fontSize: 12, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.name}</span>
                  <button onClick={e => { e.stopPropagation(); removeFile(i); }} style={{ background: 'none', border: 'none', color: theme.red, cursor: 'pointer' }}>×</button>
                </div>
              ))}
              <div style={{ color: theme.accent, fontSize: 11, marginTop: 2 }}>+ Add more</div>
            </div>
          )}
        </div>
      </FormField>
      <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 8 }}>
        <button style={btnSecondary} onClick={onClose}>Cancel</button>
        <button style={btnPrimary} onClick={handleSubmit} disabled={saving}>{saving ? 'Creating...' : 'Create Task'}</button>
      </div>
    </Modal>
  );
};

// ─── Main Nav Items ─────────────────────────────────────────────────────────
const NAV = [
  { id: "dashboard", label: "Dashboard", icon: <Icons.Home size={18}/> },
  { id: "programs", label: "Programs", icon: <Icons.Rocket size={18}/> },
  { id: "sprint", label: "Sprint", icon: <Icons.Calendar size={18}/> },
  { id: "kanban", label: "Task Board", icon: <Icons.Kanban size={18}/> },
  { id: "workorders", label: "Work Orders", icon: <Icons.Clipboard size={18}/> },
  { id: "equipment", label: "Equipment", icon: <Icons.Wrench size={18}/> },
  { id: "inventory", label: "Samples", icon: <Icons.Package size={18}/> },
  { id: "documents", label: "Documents", icon: <Icons.File size={18}/> },
  { id: "hr", label: "HR Portal", icon: <Icons.Users size={18}/> },
  { id: "quality-docs", label: "Quality Docs", icon: <Icons.Shield size={18}/> },
  { id: "messaging", label: "Messages", icon: <Icons.MessageSquare size={18}/>, badge: true },
  { id: "customers", label: "Customers", icon: <Icons.Users size={18}/> },
  { id: "sales", label: "Sales", icon: <Icons.Chart size={18}/> },
  { id: "team", label: "Team Wins", icon: <Icons.Trophy size={18}/> },
  { id: "metrics", label: "Metrics", icon: <Icons.Chart size={18}/> },
  { id: "operations", label: "Operations", icon: <Icons.Chart size={18}/> },
  { id: "epicor", label: "Epicor Reports", icon: <Icons.Database size={18}/> },
  { id: "materials", label: "Material Tracker", icon: <Icons.Package size={18}/> },
  { id: "labels", label: "Label Designer", icon: <Icons.File size={18}/> },
  { id: "import", label: "Bulk Import", icon: <Icons.Plus size={18}/> },
  { id: "cornhole", label: "Cornhole Tournament", icon: <Icons.Trophy size={18}/> },
];

// ─── Dashboard Page (Live Data) ──────────────────────────────────────────────
// ─── Security Banner ────────────────────────────────────────────────────────
const SecurityBanner = () => (
  <div style={{
    width: "100%", background: "#B45309", color: "#FFF7ED",
    padding: "6px 16px", textAlign: "center", fontSize: 12, fontWeight: 600,
    letterSpacing: 0.2, lineHeight: 1.35, borderBottom: "1px solid #92400E", flexShrink: 0,
  }}>
    The Engineering Portal is for Internal Use Only &mdash; Documents are{" "}
    <span style={{ textDecoration: "underline" }}>NOT</span> to be distributed to Third Parties and should only be accessed from a secure location.
  </div>
);

// ─── Operations Tracker (embedded Flask app served at /operations/) ──────────
const OpsTrackerFrame = () => (
  <iframe
    src="/operations/"
    title="Operations Dashboard"
    style={{
      width: "100%", height: "100%", minHeight: 520, display: "block",
      border: `1px solid ${theme.border}`, borderRadius: 12, background: theme.surface,
    }}
  />
);

// ─── Dashboard ──────────────────────────────────────────────────────────────
const DashboardPage = ({ onNav, openModal, onAddSample }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, height: "100%" }}>
      {/* Quick Actions */}
      <div>
        <div style={{ color: theme.textDim, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, marginBottom: 10 }}>Quick Actions</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))", gap: 10 }}>
          <QuickAction icon={<Icons.Clipboard size={22}/>} label="New Work Order" color={theme.purple} onClick={() => openModal("workorder")} />
          <QuickAction icon={<Icons.Package size={22}/>} label="Add Sample" color={theme.green} onClick={onAddSample} />
          <QuickAction icon={<Icons.Wrench size={22}/>} label="Book Equipment" color={theme.accent} onClick={() => openModal("booking")} />
          <QuickAction icon={<Icons.Send size={22}/>} label="Help Request" color={theme.orange} onClick={() => openModal("help")} />
          <QuickAction icon={<Icons.Users size={22}/>} label="Standup" color={theme.yellow} onClick={() => openModal("standup")} />
          <QuickAction icon={<Icons.Plus size={22}/>} label="New Task" color={theme.textDim} onClick={() => openModal("task")} />
          <QuickAction icon={<Icons.Shield size={22}/>} label="Quality Docs" color={theme.accent} onClick={() => onNav("quality-docs")} />
        </div>
      </div>

      {/* Operations Dashboard (embedded) */}
      <div style={{ flex: 1, minHeight: 520, display: "flex", flexDirection: "column" }}>
        <OpsTrackerFrame />
      </div>
    </div>
  );
};

// ─── Login Page ─────────────────────────────────────────────────────────────
const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [mode, setMode] = React.useState('sso'); // 'sso' or 'direct'
  const [ssoAvailable, setSsoAvailable] = React.useState(null); // null=checking, true/false

  // Check if Keycloak is reachable
  React.useEffect(() => {
    const checkSSO = async () => {
      try {
        // Try to reach Keycloak realm endpoint through nginx proxy
        const res = await fetch(window.location.origin + '/auth/realms/engportal', { method: 'GET' });
        setSsoAvailable(res.ok);
      } catch (e) {
        // Also try direct port
        try {
          const res2 = await fetch(window.location.origin + '/auth/realms/engportal');
          setSsoAvailable(res2.ok);
        } catch (e2) {
          setSsoAvailable(false);
        }
      }
    };
    checkSSO();
  }, []);

  const handleSSO = () => {
    // Redirect to Keycloak login page (same-origin /auth path, proxied to Keycloak by nginx)
    const baseUrl = window.location.origin;
    const keycloakBase = window.location.origin + '/auth';
    const redirectUri = encodeURIComponent(baseUrl + '/');
    const authUrl = keycloakBase + '/realms/engportal/protocol/openid-connect/auth' +
      '?client_id=engportal-frontend' +
      '&response_type=code' +
      '&redirect_uri=' + redirectUri +
      '&scope=openid profile email';
    window.location.href = authUrl;
  };

  const handleDirectLogin = async () => {
    if (!username || !password) return setError('Please enter credentials');
    setLoading(true); setError('');
    try {
      const csrfRes = await fetch('/api/auth/session-login/', { method: 'GET', credentials: 'same-origin' });
      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
      const res = await fetch('/api/auth/session-login/', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
        body: JSON.stringify({ username, password }),
      });
      if (res.ok) { onLogin(await res.json()); }
      else { const data = await res.json().catch(() => ({})); setError(data.detail || 'Invalid credentials'); }
    } catch (e) { setError('Connection error'); }
    setLoading(false);
  };

  const iStyle = { width: "100%", padding: "12px 14px", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, fontSize: 14, outline: "none", boxSizing: "border-box" };
  const lStyle = { display: "block", color: theme.textMuted, fontSize: 12, fontWeight: 600, marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.5 };

  return (
  <div style={{ display: "flex", height: "100%", background: theme.bg, fontFamily: "'IBM Plex Sans', -apple-system, system-ui, sans-serif" }}>
    <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: `linear-gradient(135deg, #0d1527, #162038, #0d1527)`, position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", inset: 0, opacity: 0.03, backgroundImage: `linear-gradient(${theme.accent} 1px, transparent 1px), linear-gradient(90deg, ${theme.accent} 1px, transparent 1px)`, backgroundSize: "40px 40px" }} />
      <div style={{ position: "relative", textAlign: "center" }}>
        <img src="/img/logo-login.png" alt="AvCarb" style={{ width: 260, height: "auto", marginBottom: 24, filter: "brightness(1.15)" }} />
        <div style={{ fontSize: 13, color: theme.textDim, letterSpacing: 3, textTransform: "uppercase", fontWeight: 500 }}>Engineering Dashboard</div>
        <div style={{ width: 60, height: 2, background: theme.accent, margin: "20px auto", borderRadius: 1, opacity: 0.6 }} />
        <div style={{ fontSize: 13, color: theme.textDim, maxWidth: 340, lineHeight: 1.6, marginTop: 8 }}>
          Program Management &bull; Sprint Planning &bull; Equipment Booking &bull; Inventory Tracking
        </div>
      </div>
    </div>
    <div style={{ width: 440, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: theme.surface, padding: 48 }}>
      <div style={{ width: "100%", maxWidth: 320 }}>
        <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 700, marginBottom: 6 }}>Welcome back</h2>
        <p style={{ color: theme.textDim, fontSize: 13, marginBottom: 24 }}>Sign in to your engineering workspace</p>

        {error && <div style={{ background: theme.red+'22', color: theme.red, padding: '8px 12px', borderRadius: 6, fontSize: 12, marginBottom: 16 }}>{error}</div>}

        {/* SSO Button */}
        {ssoAvailable && (
          <button onClick={handleSSO} style={{
            width: "100%", padding: "14px", background: `linear-gradient(135deg, ${theme.accent}, #2563EB)`, color: "#fff", border: "none",
            borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3"/></svg>
            Sign In with SSO
          </button>
        )}

        {ssoAvailable === null && (
          <div style={{ textAlign: 'center', padding: '10px 0 16px', color: theme.textDim, fontSize: 12 }}>Checking SSO availability...</div>
        )}

        {ssoAvailable && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <div style={{ flex: 1, height: 1, background: theme.border }} />
            <span style={{ color: theme.textDim, fontSize: 11 }}>or sign in directly</span>
            <div style={{ flex: 1, height: 1, background: theme.border }} />
          </div>
        )}

        {/* Direct Login */}
        <div style={{ marginBottom: 16 }}>
          <label style={lStyle}>Username</label>
          <input value={username} onChange={e => setUsername(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleDirectLogin()} style={iStyle} placeholder="Enter your username" />
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={lStyle}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleDirectLogin()} style={iStyle} placeholder="Enter your password" />
        </div>
        <button onClick={handleDirectLogin} disabled={loading} style={{
          width: "100%", padding: "12px", background: ssoAvailable ? 'transparent' : theme.accent, color: ssoAvailable ? theme.textMuted : "#fff",
          border: ssoAvailable ? `1px solid ${theme.border}` : "none", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", marginBottom: 16,
        }}>
          {loading ? 'Signing in...' : ssoAvailable ? 'Sign In with Password' : 'Sign In'}
        </button>

        {ssoAvailable === false && (
          <div style={{ textAlign: "center", marginTop: 4 }}>
            <span style={{ color: theme.textDim, fontSize: 11 }}>SSO not configured · Using direct login</span>
          </div>
        )}
      </div>
      <div style={{ position: "absolute", bottom: 24, color: theme.textDim, fontSize: 11 }}>AvCarb Material Solutions &copy; 2026</div>
    </div>
  </div>
  );
};

// ─── Placeholder Pages ──────────────────────────────────────────────────────
const PlaceholderPage = ({ title, icon }) => (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "60vh", gap: 16 }}>
    <div style={{ color: theme.accent, opacity: 0.4 }}>{React.cloneElement(icon, { size: 48 })}</div>
    <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 600, margin: 0 }}>{title}</h2>
    <p style={{ color: theme.textDim, fontSize: 14 }}>This page will be built in Phase 2</p>
  </div>
);


// ─── Quality Docs Page ──────────────────────────────────────────────────────

const QUALITY_CATEGORIES = [
  { key: 'all', label: 'All', includes: [] as string[] },
  { key: 'forms', label: 'Forms', prefix: 'FORM', includes: ['forms'] },
  { key: 'pcc', label: 'PCC', prefix: 'PCC', includes: ['pcc'] },
  { key: 'sop', label: 'SOP', prefix: 'SOP', includes: ['sop', 'eop'] },
  { key: 'qatp', label: 'QATP', prefix: 'QATP', includes: ['qatp'] },
  { key: 'route_sheets', label: 'Route Sheets', prefix: 'RS', includes: ['route_sheets'] },
  { key: 'specifications', label: 'Specifications', prefix: 'SPEC', includes: ['specifications'] },
  { key: 'tds', label: 'TDS', prefix: 'TDS', includes: ['tds', 'sds'] },
  { key: 'training', label: 'Training', prefix: 'TRAIN', includes: ['training', 'competencies'] },
  { key: 'management', label: 'Management', prefix: 'OI', includes: ['oi', 'qms'] },
  { key: 'templates', label: 'Templates', prefix: 'TMPL', includes: ['templates'] },
];

const STATUS_OPTIONS = [
  { key: '', label: 'All Status' },
  { key: 'active', label: 'Active' },
  { key: 'pending', label: 'Pending' },
  { key: 'draft', label: 'Draft' },
  { key: 'archive', label: 'Archive' },
];

const DISPLAY_FIELD_OPTIONS = [
  { value: 'system_doc_number', label: 'System Doc Number' },
  { value: 'original_filename', label: 'Original Filename' },
  { value: 'document_number', label: 'Document Number' },
  { value: 'part_number', label: 'Part Number' },
  { value: 'description', label: 'Description' },
  { value: 'revision', label: 'Revision' },
];

const qdStatusColor = (s) => ({
  active: theme.green,
  pending: theme.yellow,
  draft: theme.textDim,
  archive: theme.red,
}[s] || theme.textMuted);

const QualityDocsPage = ({ currentUser, pendingNav, clearPendingNav }: any) => {
  const isManager = currentUser?.role === 'engineering_manager' || currentUser?.role === 'executive';
  const isExecutive = currentUser?.role === 'executive' || currentUser?.role === 'engineering_manager';
  const [allUsers, setAllUsers] = useState([]);
  const [showChangeRequest, setShowChangeRequest] = useState(false);
  const [changeRequestText, setChangeRequestText] = useState('');
  const [submittingCR, setSubmittingCR] = useState(false);
  const [changeRequestFile, setChangeRequestFile] = useState(null);
  const [showArchiveRequest, setShowArchiveRequest] = useState(false);
  const [archiveReason, setArchiveReason] = useState('');
  const [submittingArchive, setSubmittingArchive] = useState(false);
  const [changeReviews, setChangeReviews] = useState([]);
  const [selectedReview, setSelectedReview] = useState(null);
  const [pnRequests, setPnRequests] = useState([]);
  const [selectedPN, setSelectedPN] = useState<any>(null);
  const [reviewsLoading, setReviewsLoading] = useState(false);
  const [reviewStatusFilter, setReviewStatusFilter] = useState('');
  const [showRejectModal, setShowRejectModal] = useState<any>(null);
  const [rejectReason, setRejectReason] = useState('');
  const [rejectFile, setRejectFile] = useState(null);
  const [showEOModal, setShowEOModal] = useState(false);
  const [eoForm, setEoForm] = useState({
    program: '', spec_type: 'production', duration: 'permanent',
    part_numbers: '', document_title: '',
    change_type: 'mandatory', hardware_unaffected: false, lot_numbers: '',
    change_from: '', change_to: '', reason: '', disposition: '',
  });
  const [submittingEO, setSubmittingEO] = useState(false);
  const [eoList, setEoList] = useState([]);
  const [selectedEO, setSelectedEO] = useState(null);
  const [eoLoading, setEoLoading] = useState(false);
  const [pendingApprovals, setPendingApprovals] = useState({ eo_signoffs: [], doc_reviews: [], total_pending: 0, has_eo_access: false });
  const [activeCategory, setActiveCategory] = useState('all');
  const [sortBy, setSortBy] = useState(null);
  const [sortDir, setSortDir] = useState('asc');
  const [statusFilter, setStatusFilter] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [stats, setStats] = useState({ total: 0, by_category: {}, by_status: {} });
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [saving, setSaving] = useState(false);

  // Display config state
  const [displayConfigs, setDisplayConfigs] = useState({});
  const [userTags, setUserTags] = useState([]);
  const [tagUsers, setTagUsers] = useState([]);
  const [newTagName, setNewTagName] = useState('');
  const [newTagColor, setNewTagColor] = useState('#6366f1');
  const [dropdownLists, setDropdownLists] = useState([]);
  const [showNewDocModal, setShowNewDocModal] = useState(false);
  const [showNewPNModal, setShowNewPNModal] = useState(false);
  const [pnStep, setPnStep] = useState(1);
  const [pnForm, setPnForm] = useState({
    isNewParent: false, isPurchased: true,
    existingParent: '', newSuffix: '', partDescription: '',
    costingLot: '', uomInventory: '', uomSales: '', uomPurchasing: '',
    productGroup: '', productClass: '', mfgDateTracking: false,
    shelfLifeDays: '0', countryOfOrigin: '', reason: '',
    similarPart: '', similarChanges: '', sdsOnFile: true,
  });
  const [pnSubmitting, setPnSubmitting] = useState(false);
  const [pnDropdowns, setPnDropdowns] = useState<any[]>([]);
  // Upload form state
  const [uploadCategory, setUploadCategory] = useState('forms');
  const [uploadFiles, setUploadFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  // Mock data for demo (will be replaced by API calls in production)
  const loadDocuments = useCallback(async () => {
    setLoading(true);
    try {
      // Build query params
      const params = new URLSearchParams();
      if (activeCategory && activeCategory !== 'all') {
        // Find the category config to check for grouped includes
        const catConfig = QUALITY_CATEGORIES.find(c => c.key === activeCategory);
        if (catConfig && catConfig.includes && catConfig.includes.length > 1) {
          // Grouped tab — send comma-separated categories
          params.set('category', catConfig.includes.join(','));
        } else if (catConfig && catConfig.includes && catConfig.includes.length === 1) {
          params.set('category', catConfig.includes[0]);
        } else {
          params.set('category', activeCategory);
        }
      }
      if (statusFilter) params.set('status', statusFilter);
      if (searchQuery) params.set('q', searchQuery);
      const paramStr = params.toString();

      const [docsRes, statsRes, configRes] = await Promise.all([
        fetch('/api/quality-docs/' + (paramStr ? '?' + paramStr : ''), { credentials: 'same-origin' }).then(r => r.ok ? r.json() : []),
        fetch('/api/quality-docs/stats/', { credentials: 'same-origin' }).then(r => r.ok ? r.json() : { total: 0, by_category: {}, by_status: {} }),
        fetch('/api/quality-docs/display-config/', { credentials: 'same-origin' }).then(r => r.ok ? r.json() : []),
      ]);

      const docs = Array.isArray(docsRes) ? docsRes : docsRes.results || [];
      setDocuments(docs);
      setStats(statsRes);

      // Build display configs map — default to document_number (legacy)
      const configs = {};
      QUALITY_CATEGORIES.filter(c => c.key !== 'all').forEach(c => {
        // Set default for each actual category in the group
        (c.includes || [c.key]).forEach(k => { configs[k] = 'document_number'; });
      });
      (Array.isArray(configRes) ? configRes : configRes.results || []).forEach(c => {
        configs[c.category] = c.display_field;
      });
      setDisplayConfigs(configs);
    } catch (e) {
      console.error('Failed to load quality docs:', e);
    }
    setLoading(false);
  }, [activeCategory, statusFilter, searchQuery]);

  useEffect(() => {
    loadDocuments();
  }, [loadDocuments]);

  // Load user list for owner/approval team dropdowns
  useEffect(() => {
    fetch('/api/quality-docs/users-with-tags/', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : [])
      .then(d => { setAllUsers(Array.isArray(d) ? d : []); setTagUsers(Array.isArray(d) ? d : []); })
      .catch(() => {});
  }, []);

  // Handle pending navigation from notification bell clicks
  useEffect(() => {
    if (!pendingNav) return;
    const nav = pendingNav;
    clearPendingNav();
    if (nav.tab) setActiveCategory(nav.tab);
    if (nav.reviewId) {
      fetch('/api/quality-docs/reviews/' + nav.reviewId + '/', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null).then(data => { if (data) setSelectedReview(data); }).catch(() => {});
      loadChangeReviews();
    }
    if (nav.pnId) {
      fetch('/api/quality-docs/pn-requests/' + nav.pnId + '/', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null).then(data => { if (data) setSelectedPN(data); }).catch(() => {});
      loadPNRequests();
    }
    if (nav.docId) {
      fetch('/api/quality-docs/' + nav.docId + '/', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null).then(data => { if (data) setSelectedDoc(data); }).catch(() => {});
    }
  }, [pendingNav]);

  // Load pending approvals for current user
  const loadPending = useCallback(() => {
    fetch('/api/quality-docs/eo/my-pending/', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : { eo_signoffs: [], doc_reviews: [], total_pending: 0, has_eo_access: false })
      .then(setPendingApprovals)
      .catch(() => {});
  }, []);

  useEffect(() => { loadPending(); }, [loadPending]);

  // Load EO list when EO tab is active
  const loadEOs = useCallback(async () => {
    setEoLoading(true);
    try {
      const res = await fetch('/api/quality-docs/eo/', { credentials: 'same-origin' });
      if (res.ok) {
        const data = await res.json();
        setEoList(Array.isArray(data) ? data : []);
      }
    } catch (e) { console.error('Failed to load EOs:', e); }
    setEoLoading(false);
  }, []);

  const loadChangeReviews = useCallback(async (opts?: any) => {
    const cached = getCached('qd:reviews');
    if (cached && !opts?.force) { setChangeReviews(cached); setReviewsLoading(false); }
    else setReviewsLoading(true);
    await swrLoad('qd:reviews', async () => {
      const res = await fetch('/api/quality-docs/reviews/', { credentials: 'same-origin' });
      if (res.ok) { const data = await res.json(); return Array.isArray(data) ? data : []; }
      return cached || [];
    }, setChangeReviews, opts);
    setReviewsLoading(false);
  }, []);

  const loadPNRequests = useCallback(async () => {
    try {
      const res = await fetch('/api/quality-docs/pn-requests/', { credentials: 'same-origin' });
      if (res.ok) setPnRequests(await res.json());
    } catch (e) { console.error('Failed to load PN requests:', e); }
  }, []);

  useEffect(() => {
    if (activeCategory === 'eo') loadEOs();
    if (activeCategory === 'reviews') loadChangeReviews();
    if (activeCategory === 'pn_requests') loadPNRequests();
    loadPending();
  }, [activeCategory, loadEOs, loadChangeReviews, loadPending]);

  // Re-apply display names when config changes
  const applyDisplayNames = useCallback((docs, configs) => {
    return docs.map(d => ({
      ...d,
      display_name: d[configs[d.category] || 'document_number'] || d.document_number || d.system_doc_number,
    }));
  }, []);

  // Filter documents
  // Documents are already filtered by the API based on activeCategory, statusFilter, searchQuery
  const filtered = documents;
  const toggleSort = (key) => {
    if (sortBy === key) setSortDir(d => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortBy(key); setSortDir('asc'); }
  };
  const sortedDocs = (() => {
    if (!sortBy) return filtered;
    const arr = [...filtered];
    arr.sort((a, b) => {
      let av = a[sortBy]; let bv = b[sortBy];
      av = av == null ? '' : (typeof av === 'string' ? av.toLowerCase() : av);
      bv = bv == null ? '' : (typeof bv === 'string' ? bv.toLowerCase() : bv);
      if (av < bv) return sortDir === 'asc' ? -1 : 1;
      if (av > bv) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });
    return arr;
  })();
  const showWhereUsed = activeCategory === 'forms' || activeCategory === 'pcc' || activeCategory === 'sop';

  const handleConfigChange = async (category, field) => {
    const newConfigs = { ...displayConfigs, [category]: field };
    setDisplayConfigs(newConfigs);
    // Save to backend
    try {
      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
      await fetch('/api/quality-docs/display-config/bulk-update/', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
        body: JSON.stringify({ configs: [{ category, display_field: field }] }),
      });
      loadDocuments(); // Refresh to get updated display_name from server
    } catch (e) {
      console.error('Failed to save display config:', e);
    }
  };

  const handleUpload = async () => {
    if (!uploadFiles.length) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('category', uploadCategory);
      Array.from(uploadFiles).forEach(f => formData.append('files', f));
      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
      const res = await fetch('/api/quality-docs/mass-upload/', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'X-CSRFToken': csrfToken },
        body: formData,
      });
      if (res.ok) {
        setUploadFiles([]);
        setShowUpload(false);
        loadDocuments(); // Refresh the list
      } else {
        const err = await res.json().catch(() => ({ detail: 'Upload failed' }));
        alert(err.detail || 'Upload failed');
      }
    } catch (e) {
      alert('Upload failed: ' + e.message);
    }
    setUploading(false);
  };

  // ─── Shared Styles ─────────────────────────
  const inputStyle = {
    background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8,
    padding: '8px 12px', color: theme.text, fontSize: 13, outline: 'none', width: '100%',
  };
  const btnPrimary = {
    background: theme.accent, color: '#fff', border: 'none', borderRadius: 8,
    padding: '8px 18px', fontSize: 13, fontWeight: 600, cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: 6,
  };
  const btnSecondary = {
    background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`,
    borderRadius: 8, padding: '8px 14px', fontSize: 13, cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: 6,
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20, height: '100%' }}>
      {/* Header Row */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0, color: theme.text }}>Quality Documents</h1>
          <p style={{ fontSize: 13, color: theme.textDim, margin: '4px 0 0' }}>
            {stats.total} controlled documents across {QUALITY_CATEGORIES.length - 1} categories
          </p>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          {isManager && (
            <button style={btnSecondary} onClick={() => {
              setShowSettings(true);
              // Load tags
              fetch('/api/quality-docs/tags/', { credentials: 'same-origin' })
                .then(r => r.ok ? r.json() : []).then(setUserTags).catch(() => {});
              fetch('/api/quality-docs/users-with-tags/', { credentials: 'same-origin' })
                .then(r => r.ok ? r.json() : []).then(setTagUsers).catch(() => {});
              // Load dropdown lists
              fetch('/api/quality-docs/dropdowns/', { credentials: 'same-origin' })
                .then(r => r.ok ? r.json() : []).then(setDropdownLists).catch(() => {});
            }}>
              <Icons.Settings size={14}/> Display Settings
            </button>
          )}
          {isManager && (
            <button style={btnPrimary} onClick={() => setShowUpload(true)}>
              <Icons.Upload size={14}/> Upload Documents
            </button>
          )}
        </div>
      </div>

      {/* Pending Approvals Banner */}
      {pendingApprovals.total_pending > 0 && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '10px 16px', borderRadius: 10,
          background: theme.yellow + '10', border: `1px solid ${theme.yellow}33`,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              width: 24, height: 24, borderRadius: '50%', fontSize: 12, fontWeight: 700,
              background: theme.yellow, color: '#000',
            }}>{pendingApprovals.total_pending}</span>
            <span style={{ fontSize: 13, color: theme.text }}>
              {pendingApprovals.eo_signoffs.length > 0 && (
                <span><strong>{pendingApprovals.eo_signoffs.length}</strong> EO signoff{pendingApprovals.eo_signoffs.length !== 1 ? 's' : ''} </span>
              )}
              {pendingApprovals.eo_signoffs.length > 0 && pendingApprovals.doc_reviews.length > 0 && <span>and </span>}
              {pendingApprovals.doc_reviews.length > 0 && (
                <span><strong>{pendingApprovals.doc_reviews.length}</strong> document review{pendingApprovals.doc_reviews.length !== 1 ? 's' : ''} </span>
              )}
              <span style={{ color: theme.textDim }}>awaiting your action</span>
            </span>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {pendingApprovals.eo_signoffs.length > 0 && (
              <button onClick={() => setActiveCategory('eo')} style={{
                padding: '5px 14px', borderRadius: 6, fontSize: 11, fontWeight: 600,
                background: theme.yellow + '18', color: theme.yellow, border: `1px solid ${theme.yellow}33`,
                cursor: 'pointer',
              }}>
                View EO Signoffs
              </button>
            )}
            {pendingApprovals.doc_reviews.length > 0 && (
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {pendingApprovals.doc_reviews.map((rev: any) => (
                  <button key={rev.doc_id} onClick={async () => {
                    setActiveCategory('all');
                    try {
                      const res = await fetch('/api/quality-docs/' + rev.doc_id + '/', { credentials: 'same-origin' });
                      if (res.ok) {
                        const doc = await res.json();
                        setSelectedDoc(doc);
                        setEditForm({ description: doc.description || '', part_number: doc.part_number || '', document_number: doc.document_number || '', revision: doc.revision || '', next_review_date: doc.next_review_date || '', status: doc.status || 'active', owner: doc.owner || '', approval_team: doc.approval_team || [] });
                      }
                    } catch(e) {}
                  }} style={{
                    padding: '4px 10px', borderRadius: 6, fontSize: 11, fontWeight: 600,
                    background: theme.accent + '18', color: theme.accent, border: `1px solid ${theme.accent}33`,
                    cursor: 'pointer',
                  }}>
                    {rev.document_number || rev.system_doc_number} — Due {rev.days_until < 0 ? `${Math.abs(rev.days_until)}d overdue` : `in ${rev.days_until}d`}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Category Tabs */}
      <div style={{
        display: 'flex', gap: 4, overflowX: 'auto', padding: '2px 0',
        borderBottom: `1px solid ${theme.border}`, flexWrap: 'wrap',
      }}>
        {QUALITY_CATEGORIES.map(cat => {
          const count = cat.key === 'all' ? stats.total :
            (cat.includes && cat.includes.length > 0
              ? cat.includes.reduce((sum: number, k: string) => sum + (stats.by_category[k] || 0), 0)
              : (stats.by_category[cat.key] || 0));
          const isActive = activeCategory === cat.key;
          return (
            <button key={cat.key} onClick={() => setActiveCategory(cat.key)} style={{
              background: isActive ? theme.accentGlow : 'transparent',
              color: isActive ? theme.accent : theme.textMuted,
              border: 'none', borderBottom: isActive ? `2px solid ${theme.accent}` : '2px solid transparent',
              padding: '8px 14px', fontSize: 12, fontWeight: isActive ? 600 : 400,
              cursor: 'pointer', borderRadius: '6px 6px 0 0', transition: 'all 0.15s',
              whiteSpace: 'nowrap',
            }}>
              {cat.label}
              <span style={{
                marginLeft: 6, fontSize: 10, background: isActive ? theme.accent + '33' : theme.bg,
                padding: '1px 6px', borderRadius: 10, color: isActive ? theme.accent : theme.textDim,
              }}>{count}</span>
            </button>
          );
        })}
        {/* EO Tab — executives, engineering managers, and users with pending signoffs */}
        {(isExecutive || pendingApprovals.has_eo_access) && (
          <button onClick={() => setActiveCategory('eo')} style={{
            background: activeCategory === 'eo' ? theme.yellow + '18' : 'transparent',
            color: activeCategory === 'eo' ? theme.yellow : theme.textMuted,
            border: 'none', borderBottom: activeCategory === 'eo' ? `2px solid ${theme.yellow}` : '2px solid transparent',
            padding: '8px 14px', fontSize: 12, fontWeight: activeCategory === 'eo' ? 600 : 400,
            cursor: 'pointer', borderRadius: '6px 6px 0 0', transition: 'all 0.15s',
            whiteSpace: 'nowrap', marginLeft: 8,
          }}>
            EOs
            <span style={{
              marginLeft: 6, fontSize: 10, background: activeCategory === 'eo' ? theme.yellow + '33' : theme.bg,
              padding: '1px 6px', borderRadius: 10, color: activeCategory === 'eo' ? theme.yellow : theme.textDim,
            }}>{eoList.length}</span>
          </button>
        )}
        {/* Change Reviews Tab */}
        <button onClick={() => setActiveCategory('reviews')} style={{
          background: activeCategory === 'reviews' ? theme.accent + '18' : 'transparent',
          color: activeCategory === 'reviews' ? theme.accent : theme.textMuted,
          border: 'none', borderBottom: activeCategory === 'reviews' ? `2px solid ${theme.accent}` : '2px solid transparent',
          padding: '8px 14px', fontSize: 12, fontWeight: activeCategory === 'reviews' ? 600 : 400,
          cursor: 'pointer', borderRadius: '6px 6px 0 0', transition: 'all 0.15s',
          whiteSpace: 'nowrap', marginLeft: 4,
        }}>
          Reviews
          <span style={{
            marginLeft: 6, fontSize: 10, background: activeCategory === 'reviews' ? theme.accent + '33' : theme.bg,
            padding: '1px 6px', borderRadius: 10, color: activeCategory === 'reviews' ? theme.accent : theme.textDim,
          }}>{changeReviews.length}</span>
        </button>
        {/* Part Requests Tab */}
        <button onClick={() => setActiveCategory('pn_requests')} style={{
          background: activeCategory === 'pn_requests' ? theme.yellow + '18' : 'transparent',
          color: activeCategory === 'pn_requests' ? theme.yellow : theme.textMuted,
          border: 'none', borderBottom: activeCategory === 'pn_requests' ? `2px solid ${theme.yellow}` : '2px solid transparent',
          padding: '8px 14px', fontSize: 12, fontWeight: activeCategory === 'pn_requests' ? 600 : 400,
          cursor: 'pointer', borderRadius: '6px 6px 0 0', whiteSpace: 'nowrap', marginLeft: 4,
        }}>
          Part Requests
          <span style={{ marginLeft: 6, fontSize: 10, background: activeCategory === 'pn_requests' ? theme.yellow + '33' : theme.bg, padding: '1px 6px', borderRadius: 10, color: activeCategory === 'pn_requests' ? theme.yellow : theme.textDim }}>{pnRequests.length}</span>
        </button>
      </div>
      {activeCategory !== 'eo' && activeCategory !== 'reviews' && activeCategory !== 'pn_requests' && (<>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 400 }}>
          <input
            placeholder="Search by doc number, filename, part number, description..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            style={{ ...inputStyle, paddingLeft: 34, paddingRight: searchQuery ? 30 : 12 }}
          />
          <Icons.Search size={14} color={theme.textDim} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }}/>
          {searchQuery && (
            <button onClick={() => setSearchQuery('')}
              style={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted, padding: 2 }}>
              <Icons.X size={14}/>
            </button>
          )}
        </div>
        <select
          value={statusFilter}
          onChange={e => setStatusFilter(e.target.value)}
          style={{ ...inputStyle, width: 140, cursor: 'pointer' }}
        >
          {STATUS_OPTIONS.map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
        </select>
        <span style={{ fontSize: 12, color: theme.textDim }}>
          {filtered.length} document{filtered.length !== 1 ? 's' : ''}
        </span>
        <button onClick={() => setShowEOModal(true)}
          style={{
            padding: '6px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
            background: theme.yellow + '15', color: theme.yellow,
            border: `1px solid ${theme.yellow}33`, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
          }}>
          <Icons.Alert size={13}/> Create EO
        </button>
        <button onClick={() => setShowNewDocModal(true)}
          style={{
            padding: '6px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
            background: theme.green + '15', color: theme.green,
            border: `1px solid ${theme.green}33`, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
          }}>
          <Icons.Upload size={13}/> New Document
        </button>
        <button onClick={() => {
          setShowNewPNModal(true);
          setPnStep(1);
          setPnForm({ isNewParent: false, isPurchased: true, existingParent: '', newSuffix: '', partDescription: '', costingLot: '', uomInventory: '', uomSales: '', uomPurchasing: '', productGroup: '', productClass: '', mfgDateTracking: false, shelfLifeDays: '0', countryOfOrigin: '', reason: '', similarPart: '', similarChanges: '', sdsOnFile: true });
          fetch('/api/quality-docs/dropdowns/', { credentials: 'same-origin' }).then(r => r.ok ? r.json() : []).then(setPnDropdowns).catch(() => {});
        }}
          style={{
            padding: '6px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
            background: theme.accent + '15', color: theme.accent,
            border: `1px solid ${theme.accent}33`, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 6, whiteSpace: 'nowrap',
          }}>
          New Part #
        </button>
      </div>

      {/* Document Table (Master Log) */}
      <Card style={{ padding: 0, flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ overflow: 'auto', flex: 1 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: theme.bg, position: 'sticky', top: 0, zIndex: 1 }}>
                {[
                  { label: 'Display Name', key: 'display_name' },
                  { label: 'Description', key: 'description' },
                  { label: 'Revision', key: 'revision' },
                  { label: 'Owner', key: 'owner_name' },
                  ...(showWhereUsed ? [{ label: 'Where Used', key: 'where_used' }] : []),
                  { label: 'Status', key: 'status' },
                  { label: 'Next Review', key: 'next_review_date' },
                  { label: 'Actions', key: null },
                ].map(col => (
                  <th key={col.label} onClick={col.key ? () => toggleSort(col.key) : undefined} style={{
                    padding: '10px 14px', textAlign: 'left', fontSize: 11,
                    fontWeight: 600, color: theme.textDim, textTransform: 'uppercase',
                    letterSpacing: 0.5, borderBottom: `1px solid ${theme.border}`,
                    whiteSpace: 'nowrap', cursor: col.key ? 'pointer' : 'default', userSelect: 'none',
                  }}>
                    {col.label}{col.key && sortBy === col.key ? (sortDir === 'asc' ? ' ▲' : ' ▼') : ''}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sortedDocs.length === 0 ? (
                <tr>
                  <td colSpan={showWhereUsed ? 8 : 7} style={{ padding: 40, textAlign: 'center', color: theme.textDim }}>
                    {searchQuery ? 'No documents match your search.' : 'No documents in this category yet.'}
                  </td>
                </tr>
              ) : (
                sortedDocs.map(doc => (
                  <tr key={doc.id} style={{ borderBottom: `1px solid ${theme.border}`, cursor: 'pointer' }}
                      onClick={async () => {
                        // Set immediately from list data for fast display
                        setSelectedDoc(doc);
                        setEditForm({ description: doc.description || '', part_number: doc.part_number || '', document_number: doc.document_number || '', revision: doc.revision || '', next_review_date: doc.next_review_date || '', status: doc.status || 'active', owner: doc.owner || '', approval_team: doc.approval_team || [] });
                        // Fetch full detail to get approval_team, review_team, etc.
                        try {
                          const res = await fetch('/api/quality-docs/' + doc.id + '/', { credentials: 'same-origin' });
                          if (res.ok) {
                            const full = await res.json();
                            setSelectedDoc(full);
                            setEditForm(prev => ({ ...prev, owner: full.owner || '', approval_team: full.approval_team || [] }));
                          }
                        } catch (e) {}
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                    <td style={{ padding: '10px 14px', fontWeight: 600, color: theme.text, maxWidth: 220, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {doc.display_name}
                    </td>
                    <td style={{ padding: '10px 14px', color: theme.textMuted, fontSize: 12, maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {doc.description || '—'}
                    </td>
                    <td style={{ padding: '10px 14px', color: theme.textMuted, fontFamily: 'monospace', fontSize: 12 }}>
                      {doc.revision}
                    </td>
                    <td style={{ padding: '10px 14px', color: theme.textMuted, fontSize: 12 }}>
                      {doc.owner_name || '—'}
                    </td>
                    {showWhereUsed && (
                      <td style={{ padding: '8px 12px' }} onClick={e => e.stopPropagation()}>
                        {isExecutive ? (
                          <input defaultValue={doc.where_used || ''} placeholder="Add location(s)…"
                            onBlur={async (e) => {
                              const val = e.target.value;
                              if (val === (doc.where_used || '')) return;
                              try {
                                const csrf = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                const res = await fetch('/api/quality-docs/' + doc.id + '/', {
                                  method: 'PATCH', credentials: 'same-origin',
                                  headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrf },
                                  body: JSON.stringify({ where_used: val }),
                                });
                                if (res.ok) doc.where_used = val;
                              } catch (err) {}
                            }}
                            style={{ width: 170, padding: '4px 8px', fontSize: 12, background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text }} />
                        ) : (
                          <span style={{ color: theme.textMuted, fontSize: 12 }}>{doc.where_used || '—'}</span>
                        )}
                      </td>
                    )}
                    <td style={{ padding: '10px 14px' }}>
                      <span style={{
                        fontSize: 11, padding: '2px 8px', borderRadius: 6,
                        background: qdStatusColor(doc.status) + '18',
                        color: qdStatusColor(doc.status), fontWeight: 500,
                        textTransform: 'capitalize',
                      }}>{doc.status}</span>
                    </td>
                    <td style={{ padding: '10px 14px', color: theme.textMuted, fontSize: 12 }}>
                      {doc.next_review_date || '—'}
                    </td>
                    <td style={{ padding: '10px 14px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={(e) => { e.stopPropagation(); window.open('/api/quality-docs/' + doc.id + '/view/', '_blank'); }}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted, padding: 4 }}
                                title="View / Print">
                          <Icons.Eye size={14}/>
                        </button>
                        <button onClick={(e) => {
                                  e.stopPropagation();
                                  const a = document.createElement('a');
                                  a.href = '/api/quality-docs/' + doc.id + '/download/';
                                  a.download = doc.original_filename || doc.system_doc_number;
                                  document.body.appendChild(a); a.click(); document.body.removeChild(a);
                                }}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted, padding: 4 }}
                                title="Download">
                          <Icons.Download size={14}/>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Card>
      </>)}

      {/* ─── EO List View ─── */}
      {activeCategory === 'eo' && (
        <Card style={{ padding: 0, flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div style={{ flex: 1, overflow: 'auto' }}>
            {eoLoading ? (
              <div style={{ padding: 40, textAlign: 'center', color: theme.textDim }}>Loading Engineering Orders...</div>
            ) : eoList.length === 0 ? (
              <div style={{ padding: 40, textAlign: 'center', color: theme.textDim }}>No Engineering Orders yet.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: `2px solid ${theme.border}`, background: theme.bg }}>
                    {['EO #', 'Title', 'Part(s)', 'Type', 'Status', 'Created By', 'Date', 'Signoffs'].map(h => (
                      <th key={h} style={{
                        padding: '10px 14px', textAlign: 'left', fontWeight: 600,
                        color: theme.textDim, fontSize: 10, textTransform: 'uppercase',
                        position: 'sticky', top: 0, background: theme.bg,
                      }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {eoList.map((eo: any) => {
                    const signedCount = (eo.signoffs || []).filter((s: any) => s.signed).length;
                    const totalSignoffs = (eo.signoffs || []).length;
                    const statusColors: any = { draft: theme.textDim, submitted: theme.yellow, in_review: theme.accent, approved: theme.green, rejected: theme.red };
                    return (
                      <tr key={eo.id}
                          onClick={() => setSelectedEO(eo)}
                          style={{ borderBottom: `1px solid ${theme.border}`, cursor: 'pointer' }}
                          onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '10px 14px', fontWeight: 700, fontFamily: 'monospace', color: theme.yellow }}>{eo.display_number || ('EO-' + eo.eo_number)}</td>
                        <td style={{ padding: '10px 14px', color: theme.text, maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{eo.document_title}</td>
                        <td style={{ padding: '10px 14px', color: theme.textMuted, fontFamily: 'monospace', fontSize: 11 }}>{eo.part_numbers?.split('\n')[0]}{eo.part_numbers?.includes('\n') ? '...' : ''}</td>
                        <td style={{ padding: '10px 14px', color: theme.textMuted, fontSize: 11 }}>{eo.change_type === 'mandatory' ? 'Mandatory' : eo.change_type === 'optional' ? 'Optional' : 'Ease of Mfg.'}</td>
                        <td style={{ padding: '10px 14px' }}>
                          <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: (statusColors[eo.status] || theme.textDim) + '18', color: statusColors[eo.status] || theme.textDim }}>{eo.status_label}</span>
                        </td>
                        <td style={{ padding: '10px 14px', color: theme.textMuted, fontSize: 11 }}>{eo.created_by_name}</td>
                        <td style={{ padding: '10px 14px', color: theme.textMuted, fontSize: 11 }}>{eo.created_at ? new Date(eo.created_at).toLocaleDateString() : '—'}</td>
                        <td style={{ padding: '10px 14px' }}>
                          <span style={{ fontSize: 11, fontWeight: 600, color: signedCount === totalSignoffs && totalSignoffs > 0 ? theme.green : theme.textMuted }}>{signedCount}/{totalSignoffs}</span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </Card>
      )}

      {/* ─── EO Detail Panel ─── */}
      {selectedEO && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setSelectedEO(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: theme.surface, borderRadius: 14, width: 700, maxHeight: '90vh', border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.4)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ padding: '16px 24px', borderBottom: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ fontFamily: 'monospace', fontWeight: 700, color: theme.yellow, fontSize: 16 }}>{selectedEO.display_number || ('EO-' + selectedEO.eo_number)}</span>
                <span style={{ marginLeft: 12, fontSize: 14, color: theme.text }}>{selectedEO.document_title}</span>
              </div>
              <button onClick={() => setSelectedEO(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted }}><Icons.X size={18}/></button>
            </div>
            <div style={{ padding: 24, overflow: 'auto', flex: 1 }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 20, fontSize: 12 }}>
                <div><span style={{ color: theme.textDim }}>Program:</span> <span style={{ color: theme.text }}>{selectedEO.program || '—'}</span></div>
                <div><span style={{ color: theme.textDim }}>Type:</span> <span style={{ color: theme.text }}>{selectedEO.spec_type}</span></div>
                <div><span style={{ color: theme.textDim }}>Duration:</span> <span style={{ color: theme.text }}>{selectedEO.duration === 'one_time' ? 'One Time Only' : 'Permanent'}</span></div>
                <div><span style={{ color: theme.textDim }}>Change:</span> <span style={{ color: theme.text }}>{selectedEO.change_type === 'mandatory' ? 'Mandatory' : selectedEO.change_type === 'optional' ? 'Optional' : 'Ease of Mfg.'}</span></div>
                <div><span style={{ color: theme.textDim }}>Part(s):</span> <span style={{ color: theme.text, fontFamily: 'monospace' }}>{selectedEO.part_numbers}</span></div>
                <div><span style={{ color: theme.textDim }}>Lot Nos:</span> <span style={{ color: theme.text }}>{selectedEO.lot_numbers || '—'}</span></div>
                <div><span style={{ color: theme.textDim }}>Created:</span> <span style={{ color: theme.text }}>{selectedEO.created_by_name}, {selectedEO.created_at ? new Date(selectedEO.created_at).toLocaleDateString() : ''}</span></div>
                <div><span style={{ color: theme.textDim }}>Owner:</span> <span style={{ color: theme.text }}>{selectedEO.eo_owner_name || '—'}</span></div>
                <div><span style={{ color: theme.textDim }}>HW Unaffected:</span> <span style={{ color: theme.text }}>{selectedEO.hardware_unaffected ? 'Yes' : 'No'}</span></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 }}>
                <div style={{ background: theme.bg, borderRadius: 8, padding: 12, border: `1px solid ${theme.border}` }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>Change From</div>
                  <div style={{ fontSize: 12, color: theme.text, whiteSpace: 'pre-wrap' }}>{selectedEO.change_from}</div>
                </div>
                <div style={{ background: theme.bg, borderRadius: 8, padding: 12, border: `1px solid ${theme.border}` }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>Change To</div>
                  <div style={{ fontSize: 12, color: theme.text, whiteSpace: 'pre-wrap' }}>{selectedEO.change_to}</div>
                </div>
              </div>
              <div style={{ background: theme.bg, borderRadius: 8, padding: 12, border: `1px solid ${theme.border}`, marginBottom: 16 }}>
                <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>Why Is This Change Necessary?</div>
                <div style={{ fontSize: 12, color: theme.text, whiteSpace: 'pre-wrap' }}>{selectedEO.reason}</div>
              </div>
              {selectedEO.disposition && (
                <div style={{ background: theme.bg, borderRadius: 8, padding: 12, border: `1px solid ${theme.border}`, marginBottom: 16 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>Disposition of Material</div>
                  <div style={{ fontSize: 12, color: theme.text, whiteSpace: 'pre-wrap' }}>{selectedEO.disposition}</div>
                </div>
              )}

              {/* Signoff Team Selector — executive only */}
              {isExecutive && (
                <div style={{ marginBottom: 20, padding: 14, borderRadius: 8, background: theme.bg, border: `1px solid ${theme.border}` }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>
                    Assign Signoff Team ({(selectedEO.signoff_team || []).length}/10)
                  </div>
                  <select multiple value={(selectedEO.signoff_team || []).map(String)}
                    onChange={async e => {
                      const selected = Array.from(e.target.selectedOptions, o => Number(o.value));
                      if (selected.length > 10) return;
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      const res = await fetch('/api/quality-docs/eo/' + selectedEO.id + '/', {
                        method: 'PATCH', credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        body: JSON.stringify({ signoff_team: selected }),
                      });
                      if (res.ok) { const updated = await res.json(); setSelectedEO(updated); loadEOs(); loadPending(); }
                    }}
                    style={{ ...inputStyle, fontSize: 11, height: 80, padding: 4, width: '100%' }}>
                    {allUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
                  </select>
                  <div style={{ fontSize: 10, color: theme.textDim, marginTop: 4 }}>Hold Ctrl/Cmd to select. Changes save immediately and notify new members.</div>
                  {(selectedEO.signoff_team_ids || []).length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 6 }}>
                      {(selectedEO.signoff_team_ids || []).map((u: any) => (
                        <span key={u.id} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: theme.yellow + '18', color: theme.yellow, fontWeight: 600 }}>
                          {u.name}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Signoff Status */}
              <div style={{ marginTop: 10 }}>
                <h3 style={{ fontSize: 14, fontWeight: 700, color: theme.text, margin: '0 0 12px' }}>
                  Signoff Status {(selectedEO.signoffs || []).length > 0 && (
                    <span style={{ fontSize: 12, fontWeight: 400, color: theme.textDim }}>
                      ({(selectedEO.signoffs || []).filter((s:any) => s.signed).length}/{(selectedEO.signoffs || []).length})
                    </span>
                  )}
                </h3>
                {(selectedEO.signoffs || []).length === 0 ? (
                  <div style={{ fontSize: 12, color: theme.textDim, padding: '10px 0' }}>
                    {isExecutive ? 'Use the selector above to assign signoff members.' : 'Signoff team not yet assigned.'}
                  </div>
                ) : (
                  (selectedEO.signoffs || []).map((s: any) => (
                    <div key={s.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderRadius: 6, marginBottom: 4, background: s.signed ? theme.green + '08' : theme.bg, border: `1px solid ${s.signed ? theme.green + '33' : theme.border}` }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <span style={{ fontSize: 16 }}>{s.signed ? '✓' : '○'}</span>
                        <div>
                          <div style={{ fontSize: 12, fontWeight: 600, color: theme.text }}>{s.assigned_to_name}</div>
                          <div style={{ fontSize: 10, color: theme.textDim }}>
                            {s.signed ? `Signed ${new Date(s.signed_at).toLocaleDateString()}` : 'Awaiting signature'}
                          </div>
                        </div>
                      </div>
                      {!s.signed && (s.assigned_to === currentUser?.id || isExecutive) && (
                        <button onClick={async () => {
                          const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                          const res = await fetch('/api/quality-docs/eo/' + selectedEO.id + '/sign/' + s.id + '/', {
                            method: 'POST', credentials: 'same-origin',
                            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                            body: JSON.stringify({}),
                          });
                          if (res.ok) {
                            const eoRes = await fetch('/api/quality-docs/eo/' + selectedEO.id + '/', { credentials: 'same-origin' });
                            if (eoRes.ok) { const updated = await eoRes.json(); setSelectedEO(updated); loadEOs(); loadPending(); }
                          } else { const err = await res.json().catch(() => ({ detail: 'Sign failed' })); alert(err.detail || 'Failed'); }
                        }} style={{ padding: '4px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.green + '15', color: theme.green, border: `1px solid ${theme.green}33`, cursor: 'pointer' }}>
                          Sign
                        </button>
                      )}
                    </div>
                  ))
                )}
              </div>
            </div>
            <div style={{ padding: '12px 24px', borderTop: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setSelectedEO(null)} style={{ padding: '7px 18px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Change Reviews List ─── */}
      {activeCategory === 'reviews' && (() => {
        const filteredReviews = reviewStatusFilter
          ? changeReviews.filter((cr: any) => cr.status === reviewStatusFilter)
          : changeReviews;
        return (
        <Card style={{ padding: 0, flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '10px 14px', borderBottom: `1px solid ${theme.border}`, display: 'flex', alignItems: 'center', gap: 12 }}>
            <select value={reviewStatusFilter} onChange={e => setReviewStatusFilter(e.target.value)}
              style={{ ...inputStyle, width: 180, cursor: 'pointer' }}>
              <option value="">All Statuses</option>
              <option value="submitted">Submitted to QM</option>
              <option value="in_review">In Review (Voting)</option>
              <option value="revision_needed">Revision Needed</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
            <span style={{ fontSize: 12, color: theme.textDim }}>{filteredReviews.length} review{filteredReviews.length !== 1 ? 's' : ''}</span>
          </div>
          <div style={{ flex: 1, overflow: 'auto' }}>
            {reviewsLoading ? (
              <div style={{ padding: 40, textAlign: 'center', color: theme.textDim }}>Loading change reviews...</div>
            ) : filteredReviews.length === 0 ? (
              <div style={{ padding: 40, textAlign: 'center', color: theme.textDim }}>No change reviews match this filter.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: `2px solid ${theme.border}`, background: theme.bg }}>
                    {['Tracking #', 'Document', 'Description', 'Status', 'Requested By', 'Round', 'Votes', 'Date'].map(h => (
                      <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: theme.textDim, fontSize: 10, textTransform: 'uppercase', position: 'sticky', top: 0, background: theme.bg }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredReviews.map((cr: any) => {
                    const approvedCount = (cr.votes || []).filter((v: any) => v.vote === 'approved' && v.review_round === cr.review_round).length;
                    const totalVoters = (cr.votes || []).filter((v: any) => v.review_round === cr.review_round).length;
                    const statusColors: any = { submitted: theme.yellow, in_review: theme.accent, rejection_pending: theme.red, approved: theme.green, rejected: theme.red, revision_needed: theme.yellow, draft: theme.textDim };
                    return (
                      <tr key={cr.id} onClick={async () => {
                        const res = await fetch('/api/quality-docs/reviews/' + cr.id + '/', { credentials: 'same-origin' });
                        if (res.ok) {
                          const reviewData = await res.json();
                          // Also load downstream impacts
                          try {
                            const impRes = await fetch('/api/quality-docs/reviews/' + cr.id + '/impacts/', { credentials: 'same-origin' });
                            if (impRes.ok) reviewData._impacts = await impRes.json();
                          } catch(e) {}
                          setSelectedReview(reviewData);
                        }
                        // Load user tags for coverage checking
                        if (!tagUsers.length) {
                          fetch('/api/quality-docs/users-with-tags/', { credentials: 'same-origin' })
                            .then(r => r.ok ? r.json() : []).then(setTagUsers).catch(() => {});
                        }
                      }} style={{ borderBottom: `1px solid ${theme.border}`, cursor: 'pointer' }}
                        onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '10px 14px', fontWeight: 700, fontFamily: 'monospace', color: theme.accent }}>{cr.tracking_number}</td>
                        <td style={{ padding: '10px 14px', fontFamily: 'monospace', fontSize: 11 }}>{cr.document_number}</td>
                        <td style={{ padding: '10px 14px', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{cr.document_description || cr.description}</td>
                        <td style={{ padding: '10px 14px' }}>
                          <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: (statusColors[cr.status] || theme.textDim) + '18', color: statusColors[cr.status] || theme.textDim }}>{cr.status_label}</span>
                        </td>
                        <td style={{ padding: '10px 14px', fontSize: 11, color: theme.textMuted }}>{cr.requested_by_name}</td>
                        <td style={{ padding: '10px 14px', fontSize: 11 }}>{cr.review_round}</td>
                        <td style={{ padding: '10px 14px', fontSize: 11, fontWeight: 600, color: approvedCount === totalVoters && totalVoters > 0 ? theme.green : theme.textMuted }}>{approvedCount}/{totalVoters}</td>
                        <td style={{ padding: '10px 14px', fontSize: 11, color: theme.textMuted }}>{cr.created_at ? new Date(cr.created_at).toLocaleDateString() : '—'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </Card>
        );
      })()}

      {/* ─── Part Number Requests List ─── */}
      {activeCategory === 'pn_requests' && (
        <Card style={{ padding: 0, flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div style={{ flex: 1, overflow: 'auto' }}>
            {pnRequests.length === 0 ? (
              <div style={{ padding: 40, textAlign: 'center', color: theme.textDim }}>No part number requests yet.</div>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: `2px solid ${theme.border}`, background: theme.bg }}>
                    {['Tracking #', 'Part #', 'Description', 'Scenario', 'Status', 'Requested By', 'Cards', 'Date'].map(h => (
                      <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: theme.textDim, fontSize: 10, textTransform: 'uppercase', position: 'sticky', top: 0, background: theme.bg }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {pnRequests.map((pn: any) => {
                    const completedCards = (pn.review_cards || []).filter((c: any) => c.status === 'completed').length;
                    const totalCards = (pn.review_cards || []).length;
                    const statusColors: any = { draft: theme.textDim, submitted: theme.yellow, pn_confirmed: theme.yellow, in_review: theme.accent, approved: theme.green, rejected: theme.red, cancelled: theme.textDim };
                    return (
                      <tr key={pn.id} onClick={async () => {
                        const res = await fetch('/api/quality-docs/pn-requests/' + pn.id + '/', { credentials: 'same-origin' });
                        if (res.ok) {
                          setSelectedPN(await res.json());
                          if (!tagUsers.length) fetch('/api/quality-docs/users-with-tags/', { credentials: 'same-origin' }).then(r => r.ok ? r.json() : []).then(setTagUsers).catch(() => {});
                        }
                      }} style={{ borderBottom: `1px solid ${theme.border}`, cursor: 'pointer' }}
                        onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <td style={{ padding: '10px 14px', fontWeight: 700, fontFamily: 'monospace', color: theme.yellow }}>{pn.tracking_number}</td>
                        <td style={{ padding: '10px 14px', fontFamily: 'monospace', fontSize: 11 }}>{pn.allocated_part_number}</td>
                        <td style={{ padding: '10px 14px', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pn.part_description}</td>
                        <td style={{ padding: '10px 14px', fontSize: 11 }}>{pn.scenario_label}</td>
                        <td style={{ padding: '10px 14px' }}><span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: (statusColors[pn.status] || theme.textDim) + '18', color: statusColors[pn.status] || theme.textDim }}>{pn.status_label}</span></td>
                        <td style={{ padding: '10px 14px', fontSize: 11, color: theme.textMuted }}>{pn.requested_by_name}</td>
                        <td style={{ padding: '10px 14px', fontSize: 11, fontWeight: 600 }}>{totalCards > 0 ? `${completedCards}/${totalCards}` : '—'}</td>
                        <td style={{ padding: '10px 14px', fontSize: 11, color: theme.textMuted }}>{pn.created_at ? new Date(pn.created_at).toLocaleDateString() : '—'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        </Card>
      )}

      {/* ─── Part Number Request Detail Panel ─── */}
      {selectedPN && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setSelectedPN(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: theme.surface, borderRadius: 14, width: 760, maxHeight: '90vh', border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.4)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ padding: '16px 24px', borderBottom: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ fontFamily: 'monospace', fontWeight: 700, color: theme.yellow, fontSize: 16 }}>{selectedPN.tracking_number}</span>
                <span style={{ marginLeft: 12, fontSize: 14, color: theme.text }}>{selectedPN.allocated_part_number}</span>
                <span style={{ marginLeft: 8, fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: theme.accent + '18', color: theme.accent }}>{selectedPN.status_label}</span>
              </div>
              <button onClick={() => setSelectedPN(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted }}><Icons.X size={18}/></button>
            </div>
            <div style={{ padding: 24, overflow: 'auto', flex: 1 }}>
              {/* Request details */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 14, fontSize: 12 }}>
                <div><span style={{ color: theme.textDim }}>Scenario:</span> <span style={{ color: theme.text }}>{selectedPN.scenario_label}</span></div>
                <div><span style={{ color: theme.textDim }}>Requested by:</span> <span style={{ color: theme.text }}>{selectedPN.requested_by_name}</span></div>
                <div><span style={{ color: theme.textDim }}>Parent:</span> <span style={{ color: theme.text }}>{selectedPN.existing_parent_number || 'New'}</span></div>
              </div>
              <div style={{ background: theme.bg, borderRadius: 8, padding: 12, border: `1px solid ${theme.border}`, marginBottom: 12 }}>
                <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 4 }}>Part Description</div>
                <div style={{ fontSize: 12, color: theme.text }}>{selectedPN.part_description}</div>
              </div>
              {selectedPN.reason && (
                <div style={{ background: theme.bg, borderRadius: 8, padding: 12, border: `1px solid ${theme.border}`, marginBottom: 12 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 4 }}>Reason</div>
                  <div style={{ fontSize: 12, color: theme.text, whiteSpace: 'pre-wrap' }}>{selectedPN.reason}</div>
                </div>
              )}
              {/* Files */}
              <div style={{ display: 'flex', gap: 6, marginBottom: 14, flexWrap: 'wrap' }}>
                {selectedPN.spec_file && <button onClick={() => window.open(selectedPN.spec_file, '_blank')} style={{ padding: '4px 10px', borderRadius: 6, fontSize: 10, fontWeight: 600, background: theme.accent + '15', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>Spec</button>}
                {selectedPN.bl1200_file && <button onClick={() => window.open(selectedPN.bl1200_file, '_blank')} style={{ padding: '4px 10px', borderRadius: 6, fontSize: 10, fontWeight: 600, background: theme.accent + '15', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>BL-1200</button>}
                {selectedPN.sds_file && <button onClick={() => window.open(selectedPN.sds_file, '_blank')} style={{ padding: '4px 10px', borderRadius: 6, fontSize: 10, fontWeight: 600, background: theme.accent + '15', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>SDS</button>}
                {selectedPN.bom_file && <button onClick={() => window.open(selectedPN.bom_file, '_blank')} style={{ padding: '4px 10px', borderRadius: 6, fontSize: 10, fontWeight: 600, background: theme.accent + '15', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>BOM</button>}
                {selectedPN.route_sheet_file && <button onClick={() => window.open(selectedPN.route_sheet_file, '_blank')} style={{ padding: '4px 10px', borderRadius: 6, fontSize: 10, fontWeight: 600, background: theme.accent + '15', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>Route Sheet</button>}
              </div>

              {/* Upload Documents — when P/N is confirmed, requester or QM can upload */}
              {(selectedPN.status === 'pn_confirmed') && (currentUser?.id === selectedPN.requested_by || isExecutive) && (
                <div style={{ padding: 14, borderRadius: 8, background: theme.yellow + '08', border: `1px solid ${theme.yellow}33`, marginBottom: 14 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: theme.yellow, marginBottom: 6 }}>
                    Part number confirmed: {selectedPN.allocated_part_number} — Upload revised documents
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, fontSize: 11, marginBottom: 10 }}>
                    <div><span style={{ color: theme.textDim }}>Specification:</span> <input type="file" id="pn-upload-spec" style={{ fontSize: 11 }} /></div>
                    <div><span style={{ color: theme.textDim }}>BL-1200:</span> <input type="file" id="pn-upload-bl1200" style={{ fontSize: 11 }} /></div>
                    <div><span style={{ color: theme.textDim }}>SDS:</span> <input type="file" id="pn-upload-sds" style={{ fontSize: 11 }} /></div>
                    <div><span style={{ color: theme.textDim }}>BOM:</span> <input type="file" id="pn-upload-bom" style={{ fontSize: 11 }} /></div>
                    <div><span style={{ color: theme.textDim }}>Route Sheet:</span> <input type="file" id="pn-upload-rs" style={{ fontSize: 11 }} /></div>
                  </div>
                  <button onClick={async () => {
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    const fd = new FormData();
                    const specF = (document.getElementById('pn-upload-spec') as HTMLInputElement)?.files?.[0];
                    const blF = (document.getElementById('pn-upload-bl1200') as HTMLInputElement)?.files?.[0];
                    const sdsF = (document.getElementById('pn-upload-sds') as HTMLInputElement)?.files?.[0];
                    const bomF = (document.getElementById('pn-upload-bom') as HTMLInputElement)?.files?.[0];
                    const rsF = (document.getElementById('pn-upload-rs') as HTMLInputElement)?.files?.[0];
                    if (!specF && !blF && !sdsF && !bomF && !rsF) { alert('Please select at least one file.'); return; }
                    if (specF) fd.append('spec_file', specF);
                    if (blF) fd.append('bl1200_file', blF);
                    if (sdsF) fd.append('sds_file', sdsF);
                    if (bomF) fd.append('bom_file', bomF);
                    if (rsF) fd.append('route_sheet_file', rsF);
                    const res = await fetch('/api/quality-docs/pn-requests/' + selectedPN.id + '/', {
                      method: 'PATCH', credentials: 'same-origin',
                      headers: { 'X-CSRFToken': csrfToken }, body: fd,
                    });
                    if (res.ok) { setSelectedPN(await res.json()); alert('Documents uploaded.'); }
                    else { alert('Upload failed.'); }
                  }} style={{ padding: '6px 16px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: theme.yellow, color: '#000', border: 'none', cursor: 'pointer' }}>
                    Upload Documents
                  </button>
                </div>
              )}

              {/* QM Controls — Confirm P/N */}
              {isExecutive && selectedPN.status === 'submitted' && (
                <div style={{ padding: 14, borderRadius: 8, background: theme.bg, border: `1px solid ${theme.border}`, marginBottom: 14 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>QM: Confirm Part Number</div>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    <input id="pn-confirm-number" defaultValue={selectedPN.allocated_part_number} placeholder="Confirmed part number" style={{ ...inputStyle, flex: 1 }} />
                    <button onClick={async () => {
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      const pn = (document.getElementById('pn-confirm-number') as HTMLInputElement).value;
                      const res = await fetch('/api/quality-docs/pn-requests/' + selectedPN.id + '/', {
                        method: 'PATCH', credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        body: JSON.stringify({ action: 'confirm_pn', allocated_part_number: pn }),
                      });
                      if (res.ok) { setSelectedPN(await res.json()); loadPNRequests(); loadPending(); alert('P/N confirmed. Owner notified to upload documents.'); }
                    }} style={{ padding: '6px 14px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.green + '15', color: theme.green, border: `1px solid ${theme.green}33`, cursor: 'pointer' }}>Confirm P/N</button>
                    <button onClick={async () => {
                      const reason = prompt('Reason for rejecting:');
                      if (reason === null) return;
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      await fetch('/api/quality-docs/pn-requests/' + selectedPN.id + '/', {
                        method: 'PATCH', credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        body: JSON.stringify({ action: 'reject', qm_notes: reason }),
                      });
                      setSelectedPN(null); loadPNRequests(); loadPending();
                    }} style={{ padding: '6px 14px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.red + '10', color: theme.red, border: `1px solid ${theme.red}33`, cursor: 'pointer' }}>Reject</button>
                  </div>
                </div>
              )}

              {/* QM Controls — Assign Card Reviewers & Send for Review */}
              {isExecutive && (selectedPN.status === 'pn_confirmed' || selectedPN.status === 'submitted') && (
                <div style={{ padding: 14, borderRadius: 8, background: theme.bg, border: `1px solid ${theme.border}`, marginBottom: 14 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>QM: Assign Review Cards & Send for Review</div>
                  <div style={{ fontSize: 11, color: theme.textDim, marginBottom: 8 }}>Required cards: {(selectedPN.required_card_types || []).join(', ')}</div>
                  {(selectedPN.required_card_types || []).map((ct: string) => {
                    // Map card type to tag name
                    const tagMap: any = { ehs: 'EHS', materials: 'Materials', finance: 'Finance', sales: 'Sales', process_eng: 'Process Eng', qm: 'Quality' };
                    const tagName = tagMap[ct] || ct;
                    // Filter users who have the matching tag
                    const matchingUsers = tagUsers.filter((u: any) => (u.tags || []).some((t: any) => t.name === tagName));
                    const cardLabels: any = { ehs: 'EHS', materials: 'Materials', finance: 'Finance', sales: 'Sales', process_eng: 'Process Eng', qm: 'Quality Manager' };
                    return (
                    <div key={ct} style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                      <span style={{ fontSize: 11, fontWeight: 600, color: theme.text, width: 120 }}>{cardLabels[ct] || ct}:</span>
                      <select id={`pn-card-${ct}`} style={{ ...inputStyle, flex: 1, fontSize: 11, padding: '4px 8px' }}>
                        <option value="">Select reviewer...</option>
                        {matchingUsers.length > 0
                          ? matchingUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)
                          : allUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`} (no tag match)</option>)
                        }
                      </select>
                    </div>
                    );
                  })}
                  {/* Additional (optional) reviewers */}
                  <div style={{ marginTop: 10, paddingTop: 10, borderTop: `1px solid ${theme.border}` }}>
                    <span style={{ fontSize: 10, color: theme.textDim, fontWeight: 600 }}>Additional Reviewers (optional — approve/reject only):</span>
                    <select id="pn-extra-reviewers" multiple style={{ ...inputStyle, fontSize: 11, height: 60, padding: 4, width: '100%', marginTop: 4 }}>
                      {allUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
                    </select>
                  </div>
                  <button onClick={async () => {
                    const assignments: any = {};
                    for (const ct of (selectedPN.required_card_types || [])) {
                      const sel = document.getElementById('pn-card-' + ct) as HTMLSelectElement;
                      if (!sel?.value) { alert(`Please assign a reviewer for ${ct}`); return; }
                      assignments[ct] = Number(sel.value);
                    }
                    // Collect extra reviewers
                    const extraSel = document.getElementById('pn-extra-reviewers') as HTMLSelectElement;
                    const extraAssignments: any = {};
                    if (extraSel) {
                      Array.from(extraSel.selectedOptions).forEach(o => {
                        extraAssignments['extra_' + o.value] = Number(o.value);
                      });
                    }
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    const res = await fetch('/api/quality-docs/pn-requests/' + selectedPN.id + '/', {
                      method: 'PATCH', credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                      body: JSON.stringify({ action: 'send_for_review', card_assignments: assignments, extra_assignments: extraAssignments }),
                    });
                    if (res.ok) { setSelectedPN(await res.json()); loadPNRequests(); loadPending(); alert('Sent for review. Card holders notified.'); }
                    else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
                  }} style={{ padding: '7px 16px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: theme.accent, color: '#fff', border: 'none', cursor: 'pointer', marginTop: 8 }}>
                    Send for Review
                  </button>
                </div>
              )}

              {/* Review Cards */}
              {(selectedPN.review_cards || []).length > 0 && (
                <div style={{ marginTop: 10 }}>
                  <h3 style={{ fontSize: 14, fontWeight: 700, color: theme.text, margin: '0 0 12px' }}>Review Cards</h3>
                  {(selectedPN.review_cards || []).map((card: any) => {
                    const isMyCard = card.assigned_to === currentUser?.id;
                    const cardColors: any = { pending: theme.textDim, completed: theme.green, rejected: theme.red };
                    // View-only (additional reviewer) cards don't gate approval — show a muted badge.
                    const badgeColor = card.is_view_only && card.status === 'pending' ? theme.textDim : (cardColors[card.status] || theme.textDim);
                    return (
                      <div key={card.id} style={{ padding: 12, borderRadius: 8, marginBottom: 8, background: card.status === 'completed' ? theme.green + '06' : card.status === 'rejected' ? theme.red + '06' : theme.bg, border: `1px solid ${(cardColors[card.status] || theme.border) + '33'}` }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                          <div>
                            <span style={{ fontSize: 13, fontWeight: 700, color: theme.text }}>{card.card_type_label}</span>
                            <span style={{ fontSize: 11, color: theme.textMuted, marginLeft: 8 }}>→ {card.assigned_to_name}</span>
                          </div>
                          <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 8, background: badgeColor + '18', color: badgeColor }}>{card.status_label}</span>
                        </div>
                        {/* Card-specific fields for the assigned reviewer */}
                        {isMyCard && card.status === 'pending' && (
                          <div style={{ marginTop: 8, padding: 10, borderRadius: 6, background: theme.surface, border: `1px solid ${theme.border}` }}>
                            {/* EHS Card */}
                            {card.card_type === 'ehs' && (<>
                              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 6, cursor: 'pointer' }}>
                                <input type="checkbox" id={`card-${card.id}-sds`} defaultChecked={card.ehs_sds_reviewed} /> SDS reviewed and correct
                              </label>
                              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 6, cursor: 'pointer' }}>
                                <input type="checkbox" id={`card-${card.id}-spec`} defaultChecked={card.ehs_spec_reviewed} /> Spec reviewed for safety
                              </label>
                              <textarea id={`card-${card.id}-notes`} defaultValue={card.ehs_handling_notes} placeholder="Safe handling notes (optional)" style={{ ...inputStyle, height: 40, resize: 'vertical' as const, width: '100%', fontSize: 11, marginBottom: 6 }} />
                            </>)}
                            {/* Materials Card */}
                            {card.card_type === 'materials' && (<>
                              {selectedPN.scenario.includes('purchased') && (<>
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                                  <div><span style={{ fontSize: 10, color: theme.textDim }}>Supplier:</span><input id={`card-${card.id}-supplier`} defaultValue={card.mat_supplier_name} style={{ ...inputStyle, fontSize: 11, width: '100%' }} /></div>
                                  <div><span style={{ fontSize: 10, color: theme.textDim }}>Lead Time (days):</span><input id={`card-${card.id}-lead`} defaultValue={card.mat_lead_time_days} style={{ ...inputStyle, fontSize: 11, width: '100%' }} /></div>
                                </div>
                              </>)}
                              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                                <div><span style={{ fontSize: 10, color: theme.textDim }}>Planner & Buyer:</span><input id={`card-${card.id}-planner`} defaultValue={card.mat_planner_buyer} style={{ ...inputStyle, fontSize: 11, width: '100%' }} /></div>
                                <div><span style={{ fontSize: 10, color: theme.textDim }}>Min OH Qty:</span><input id={`card-${card.id}-minoh`} defaultValue={card.mat_min_oh_qty} style={{ ...inputStyle, fontSize: 11, width: '100%' }} /></div>
                              </div>
                            </>)}
                            {/* Finance Card */}
                            {card.card_type === 'finance' && (<>
                              {selectedPN.scenario.includes('purchased') ? (
                                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 6, cursor: 'pointer' }}>
                                  <input type="checkbox" id={`card-${card.id}-price`} defaultChecked={card.fin_price_entered} /> Price entered in ERP
                                </label>
                              ) : (
                                <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 6, cursor: 'pointer' }}>
                                  <input type="checkbox" id={`card-${card.id}-rollup`} defaultChecked={card.fin_cost_rollup_complete} /> Full cost rollup completed and reviewed
                                </label>
                              )}
                            </>)}
                            {/* Sales Card */}
                            {card.card_type === 'sales' && (<>
                              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 8 }}>
                                <div><span style={{ fontSize: 10, color: theme.textDim }}>ECCN:</span><input id={`card-${card.id}-eccn`} defaultValue={card.sales_eccn} style={{ ...inputStyle, fontSize: 11, width: '100%' }} /></div>
                                <div><span style={{ fontSize: 10, color: theme.textDim }}>Schedule B:</span><input id={`card-${card.id}-schedb`} defaultValue={card.sales_schedule_b} style={{ ...inputStyle, fontSize: 11, width: '100%' }} /></div>
                                <div><span style={{ fontSize: 10, color: theme.textDim }}>Export License:</span><input id={`card-${card.id}-export`} defaultValue={card.sales_export_license} style={{ ...inputStyle, fontSize: 11, width: '100%' }} /></div>
                              </div>
                            </>)}
                            {/* Process Eng Card */}
                            {card.card_type === 'process_eng' && (<>
                              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 6, cursor: 'pointer' }}>
                                <input type="checkbox" id={`card-${card.id}-bom`} defaultChecked={card.eng_bom_reviewed} /> BOM reviewed
                              </label>
                              <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 6, cursor: 'pointer' }}>
                                <input type="checkbox" id={`card-${card.id}-routing`} defaultChecked={card.eng_routing_reviewed} /> Routing reviewed
                              </label>
                              <textarea id={`card-${card.id}-engnotes`} defaultValue={card.eng_notes} placeholder="Engineering notes" style={{ ...inputStyle, height: 40, resize: 'vertical' as const, width: '100%', fontSize: 11, marginBottom: 6 }} />
                            </>)}
                            {/* QM / Additional Reviewer Card — approve/reject with notes */}
                            {card.card_type === 'qm' && (
                              <textarea id={`card-${card.id}-notes`} defaultValue={card.notes} placeholder="Review notes (optional)" style={{ ...inputStyle, height: 40, resize: 'vertical' as const, width: '100%', fontSize: 11, marginBottom: 6 }} />
                            )}
                            {/* Approve / Reject buttons */}
                            <div style={{ display: 'flex', gap: 6, marginTop: 6 }}>
                              <button onClick={async () => {
                                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                const body: any = { status: 'completed' };
                                // Collect card-specific fields
                                const g = (id: string) => (document.getElementById(id) as any)?.value || '';
                                const gc = (id: string) => (document.getElementById(id) as any)?.checked || false;
                                if (card.card_type === 'ehs') { body.ehs_sds_reviewed = gc(`card-${card.id}-sds`); body.ehs_spec_reviewed = gc(`card-${card.id}-spec`); body.ehs_handling_notes = g(`card-${card.id}-notes`); }
                                if (card.card_type === 'materials') { body.mat_supplier_name = g(`card-${card.id}-supplier`); body.mat_lead_time_days = g(`card-${card.id}-lead`); body.mat_planner_buyer = g(`card-${card.id}-planner`); body.mat_min_oh_qty = g(`card-${card.id}-minoh`); }
                                if (card.card_type === 'finance') { body.fin_price_entered = gc(`card-${card.id}-price`); body.fin_cost_rollup_complete = gc(`card-${card.id}-rollup`); }
                                if (card.card_type === 'sales') { body.sales_eccn = g(`card-${card.id}-eccn`); body.sales_schedule_b = g(`card-${card.id}-schedb`); body.sales_export_license = g(`card-${card.id}-export`); }
                                if (card.card_type === 'process_eng') { body.eng_bom_reviewed = gc(`card-${card.id}-bom`); body.eng_routing_reviewed = gc(`card-${card.id}-routing`); body.eng_notes = g(`card-${card.id}-engnotes`); }
                                const res = await fetch('/api/quality-docs/pn-cards/' + card.id + '/', {
                                  method: 'PATCH', credentials: 'same-origin',
                                  headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                  body: JSON.stringify(body),
                                });
                                if (res.ok) { setSelectedPN(await res.json()); loadPNRequests(); loadPending(); }
                              }} style={{ padding: '4px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.green + '15', color: theme.green, border: `1px solid ${theme.green}33`, cursor: 'pointer' }}>Complete Card</button>
                              <button onClick={async () => {
                                const reason = prompt('Reason for rejecting:');
                                if (reason === null) return;
                                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                const res = await fetch('/api/quality-docs/pn-cards/' + card.id + '/', {
                                  method: 'PATCH', credentials: 'same-origin',
                                  headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                  body: JSON.stringify({ status: 'rejected', rejection_reason: reason }),
                                });
                                if (res.ok) { setSelectedPN(await res.json()); loadPNRequests(); loadPending(); }
                              }} style={{ padding: '4px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.red + '10', color: theme.red, border: `1px solid ${theme.red}33`, cursor: 'pointer' }}>Reject</button>
                            </div>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* QM Final Approval */}
              {isExecutive && selectedPN.status === 'in_review' && (selectedPN.review_cards || []).filter((c: any) => !c.is_view_only).every((c: any) => c.status === 'completed') && (
                <div style={{ padding: 14, borderRadius: 8, background: theme.green + '08', border: `1px solid ${theme.green}33`, marginTop: 14 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: theme.green, marginBottom: 8 }}>All cards completed — Ready for final approval</div>
                  {!selectedPN.is_new_parent && (
                    <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, marginBottom: 8, cursor: 'pointer', color: theme.text }}>
                      <input type="checkbox" id="pn-uprev" /> Up-rev all parts under parent p/n
                    </label>
                  )}
                  {!selectedPN.is_new_parent && (
                    <div style={{ padding: '6px 10px', borderRadius: 6, background: theme.yellow + '12', border: `1px solid ${theme.yellow}33`, fontSize: 11, color: theme.yellow, fontWeight: 600, marginBottom: 10 }}>
                      ⚠ If up-rev is selected, all route sheets under this parent will need manual revision updates.
                    </div>
                  )}
                  <button onClick={async () => {
                    const uprev = (document.getElementById('pn-uprev') as HTMLInputElement)?.checked || false;
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    const res = await fetch('/api/quality-docs/pn-requests/' + selectedPN.id + '/', {
                      method: 'PATCH', credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                      body: JSON.stringify({ action: 'final_approve', uprev_required: uprev, uprev_warning_acknowledged: uprev }),
                    });
                    if (res.ok) { setSelectedPN(await res.json()); loadPNRequests(); loadPending(); alert('Part number approved!'); }
                  }} style={{ padding: '8px 20px', borderRadius: 8, fontSize: 13, fontWeight: 600, background: theme.green, color: '#fff', border: 'none', cursor: 'pointer' }}>
                    Final Approve
                  </button>
                </div>
              )}
            </div>
            <div style={{ padding: '12px 24px', borderTop: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setSelectedPN(null)} style={{ padding: '7px 18px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Change Review Detail Panel ─── */}
      {selectedReview && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setSelectedReview(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: theme.surface, borderRadius: 14, width: 720, maxHeight: '90vh', border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.4)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div style={{ padding: '16px 24px', borderBottom: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <span style={{ fontFamily: 'monospace', fontWeight: 700, color: theme.accent, fontSize: 16 }}>{selectedReview.tracking_number}</span>
                <span style={{ marginLeft: 12, fontSize: 14, color: theme.text }}>{selectedReview.document_number}</span>
                <span style={{ marginLeft: 8, fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: theme.accent + '18', color: theme.accent }}>{selectedReview.status_label}</span>
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                {selectedReview.document && (
                  <>
                    <button onClick={async () => {
                      // Fetch the document directly instead of relying on loaded list
                      try {
                        const res = await fetch('/api/quality-docs/' + selectedReview.document + '/', { credentials: 'same-origin' });
                        if (res.ok) setSelectedDoc(await res.json());
                      } catch(e) {}
                    }} style={{ padding: '5px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.accent + '15', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>
                      Preview Document
                    </button>
                    <button onClick={() => {
                      window.open('/api/quality-docs/' + selectedReview.document + '/download/', '_blank');
                    }} style={{ padding: '5px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.green + '15', color: theme.green, border: `1px solid ${theme.green}33`, cursor: 'pointer' }}>
                      Download
                    </button>
                  </>
                )}
                {selectedReview.new_file && (
                  <button onClick={() => {
                    window.open(selectedReview.new_file, '_blank');
                  }} style={{ padding: '5px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.yellow + '15', color: theme.yellow, border: `1px solid ${theme.yellow}33`, cursor: 'pointer' }}>
                    Proposed File
                  </button>
                )}
                <button onClick={() => setSelectedReview(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted }}><Icons.X size={18}/></button>
              </div>
            </div>
            <div style={{ padding: 24, overflow: 'auto', flex: 1 }}>
              {/* Review details */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, marginBottom: 16, fontSize: 12 }}>
                <div><span style={{ color: theme.textDim }}>Requested by:</span> <span style={{ color: theme.text }}>{selectedReview.requested_by_name}</span></div>
                <div><span style={{ color: theme.textDim }}>Round:</span> <span style={{ color: theme.text }}>{selectedReview.review_round}</span></div>
                <div><span style={{ color: theme.textDim }}>New Revision:</span> <span style={{ color: theme.text }}>{selectedReview.new_revision || '—'}</span></div>
              </div>
              <div style={{ background: theme.bg, borderRadius: 8, padding: 12, border: `1px solid ${theme.border}`, marginBottom: 12 }}>
                <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 4 }}>Justification</div>
                <div style={{ fontSize: 12, color: theme.text, whiteSpace: 'pre-wrap' }}>{selectedReview.justification}</div>
              </div>
              {selectedReview.description && (
                <div style={{ background: theme.bg, borderRadius: 8, padding: 12, border: `1px solid ${theme.border}`, marginBottom: 12 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 4 }}>Description of Changes</div>
                  <div style={{ fontSize: 12, color: theme.text, whiteSpace: 'pre-wrap' }}>{selectedReview.description}</div>
                </div>
              )}
              {/* Document links */}
              <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                {selectedReview.new_file && (
                  <button onClick={() => window.open(selectedReview.new_file, '_blank')} style={{ padding: '5px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.accent + '15', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>
                    View Revised Document
                  </button>
                )}
                {selectedReview.qm_file && (
                  <button onClick={() => window.open(selectedReview.qm_file, '_blank')} style={{ padding: '5px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.yellow + '15', color: theme.yellow, border: `1px solid ${theme.yellow}33`, cursor: 'pointer' }}>
                    QM Attachment
                  </button>
                )}
              </div>
              {selectedReview.qm_notes && (
                <div style={{ background: theme.yellow + '08', borderRadius: 8, padding: 12, border: `1px solid ${theme.yellow}33`, marginBottom: 16 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.yellow, textTransform: 'uppercase', marginBottom: 4 }}>QM Notes</div>
                  <div style={{ fontSize: 12, color: theme.text, whiteSpace: 'pre-wrap' }}>{selectedReview.qm_notes}</div>
                </div>
              )}

              {/* Rejection pending QM review — QM dismisses (reopen) or accepts (revise) */}
              {selectedReview.status === 'rejection_pending' && (
                <div style={{ padding: 14, borderRadius: 8, background: theme.red + '0C', border: `1px solid ${theme.red}44`, marginBottom: 16 }}>
                  <div style={{ fontSize: 12, fontWeight: 700, color: theme.red, marginBottom: 6 }}>
                    Rejection received — paused for QM review
                  </div>
                  {(selectedReview.votes || []).filter((v:any) => v.review_round === selectedReview.review_round && v.vote === 'rejected').map((v:any) => (
                    <div key={v.id} style={{ fontSize: 11, color: theme.text, marginBottom: 6, marginLeft: 4 }}>
                      <span style={{ fontWeight: 600 }}>{v.reviewer_name}</span> rejected{v.rejection_reason ? ': ' + v.rejection_reason : '.'}
                    </div>
                  ))}
                  {isExecutive ? (
                    <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                      <button onClick={async () => {
                        if (!window.confirm('Dismiss this rejection and reopen the round for voting?')) return;
                        const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                        const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/dismiss-rejection/', {
                          method: 'POST', credentials: 'same-origin',
                          headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        });
                        if (res.ok) {
                          const rv = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', { credentials: 'same-origin' });
                          if (rv.ok) { setSelectedReview(await rv.json()); loadChangeReviews({force:true}); loadPending(); }
                        } else { const e = await res.json().catch(() => ({ detail: 'Failed' })); alert(e.detail); }
                      }} style={{ padding: '6px 14px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.accent + '15', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>Dismiss &amp; continue round</button>
                      <button onClick={async () => {
                        if (!window.confirm('Accept the rejection and return this change to the requester for revision?')) return;
                        const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                        const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/accept-rejection/', {
                          method: 'POST', credentials: 'same-origin',
                          headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        });
                        if (res.ok) {
                          const rv = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', { credentials: 'same-origin' });
                          if (rv.ok) { setSelectedReview(await rv.json()); loadChangeReviews({force:true}); loadPending(); }
                        } else { const e = await res.json().catch(() => ({ detail: 'Failed' })); alert(e.detail); }
                      }} style={{ padding: '6px 14px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.red + '10', color: theme.red, border: `1px solid ${theme.red}33`, cursor: 'pointer' }}>Accept &amp; return for revision</button>
                    </div>
                  ) : (
                    <div style={{ fontSize: 11, color: theme.textDim, fontStyle: 'italic', marginTop: 6 }}>
                      The Quality Manager will decide whether to continue the round or return this for revision.
                    </div>
                  )}
                </div>
              )}

              {/* Resubmit after rejection — visible to requester and QM */}
              {selectedReview.status === 'revision_needed' && (currentUser?.id === selectedReview.requested_by || isExecutive) && (
                <div style={{ padding: 14, borderRadius: 8, background: theme.red + '08', border: `1px solid ${theme.red}33`, marginBottom: 16 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: theme.red, marginBottom: 8 }}>
                    Revision Needed — Please address the reviewer feedback and resubmit
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>
                      Upload Revised Document
                    </label>
                    <input type="file" id="resubmit-file" style={{ fontSize: 12, color: theme.text }} />
                  </div>
                  <div style={{ marginBottom: 10 }}>
                    <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>
                      Updated Justification (optional)
                    </label>
                    <textarea id="resubmit-justification" placeholder="Describe what was revised..."
                      style={{ ...inputStyle, height: 60, resize: 'vertical' as const, width: '100%' }} />
                  </div>
                  <div style={{ display: 'flex', gap: 10 }}>
                    <button onClick={async () => {
                      const fileInput = document.getElementById('resubmit-file') as HTMLInputElement;
                      const justInput = document.getElementById('resubmit-justification') as HTMLTextAreaElement;
                      const file = fileInput?.files?.[0];
                      if (!file) { alert('Please select a revised file.'); return; }
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      const formData = new FormData();
                      formData.append('new_file', file);
                      if (justInput?.value) formData.append('justification', justInput.value);
                      const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/resubmit/', {
                        method: 'POST', credentials: 'same-origin',
                        headers: { 'X-CSRFToken': csrfToken },
                        body: formData,
                      });
                      if (res.ok) {
                        const updated = await res.json();
                        setSelectedReview(updated);
                        loadChangeReviews({force:true});
                        loadPending();
                        alert('Revised document resubmitted. Round ' + updated.review_round + ' — reviewers have been notified.');
                      } else {
                        const err = await res.json().catch(() => ({ detail: 'Failed' }));
                        alert(err.detail || 'Resubmission failed');
                      }
                    }} style={{
                      padding: '7px 20px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                      background: theme.accent, color: '#fff', border: 'none', cursor: 'pointer',
                    }}>
                      Resubmit for Review
                    </button>
                    <button onClick={async () => {
                      const reason = prompt('Reason for cancelling this change request (optional):');
                      if (reason === null) return;
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/cancel/', {
                        method: 'POST', credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        body: JSON.stringify({ reason }),
                      });
                      if (res.ok) {
                        setSelectedReview(null);
                        loadChangeReviews({force:true});
                        loadDocuments();
                        loadPending();
                        alert('Change request cancelled. Document restored to active.');
                      } else {
                        const err = await res.json().catch(() => ({ detail: 'Failed' }));
                        alert(err.detail || 'Cancel failed');
                      }
                    }} style={{
                      padding: '7px 20px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                      background: 'transparent', color: theme.red, border: `1px solid ${theme.red}33`, cursor: 'pointer',
                    }}>
                      Cancel Request
                    </button>
                  </div>
                </div>
              )}

              {/* Cancel option when still in submitted status (before QM sends for review) */}
              {selectedReview.status === 'submitted' && (currentUser?.id === selectedReview.requested_by || isExecutive) && (
                <div style={{ marginBottom: 16 }}>
                  <button onClick={async () => {
                    const reason = prompt('Reason for cancelling this change request (optional):');
                    if (reason === null) return;
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/cancel/', {
                      method: 'POST', credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                      body: JSON.stringify({ reason }),
                    });
                    if (res.ok) {
                      setSelectedReview(null);
                      loadChangeReviews({force:true});
                      loadDocuments();
                      loadPending();
                      alert('Change request cancelled. Document restored to active.');
                    } else {
                      const err = await res.json().catch(() => ({ detail: 'Failed' }));
                      alert(err.detail || 'Cancel failed');
                    }
                  }} style={{
                    padding: '6px 16px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                    background: 'transparent', color: theme.red, border: `1px solid ${theme.red}33`, cursor: 'pointer',
                  }}>
                    Withdraw Request
                  </button>
                </div>
              )}

              {/* QM Controls — assign team and send for review */}
              {isExecutive && selectedReview.status === 'submitted' && (
                <div style={{ padding: 14, borderRadius: 8, background: theme.bg, border: `1px solid ${theme.border}`, marginBottom: 16 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>
                    QM: Assign Review Team & Send for Voting
                  </div>
                  {/* Required Tag Groups — coverage indicator */}
                  {(selectedReview.required_tags || []).length > 0 && (() => {
                    const requiredTags = selectedReview.required_tags || [];
                    const waivedTags = selectedReview.waived_tags || [];
                    const effectiveRequired = requiredTags.filter((t: string) => !waivedTags.includes(t));
                    const canEditWaivers = !!selectedReview.can_edit_waivers && isExecutive;
                    const selectedIds = selectedReview.review_team || [];
                    const notifyIds = selectedReview.notify_only_team || [];
                    // Check which tags are covered by selected users. Notify-only
                    // participants are mandatory stakeholders too, so they count
                    // toward a required approval group (matching the backend).
                    const coveredTags: Set<string> = new Set();
                    [...selectedIds, ...notifyIds].forEach((uid: number) => {
                      const user = tagUsers.find((u: any) => u.id === uid);
                      if (user) (user.tags || []).forEach((t: any) => coveredTags.add(t.name));
                    });
                    const allCovered = effectiveRequired.every((t: string) => coveredTags.has(t));
                    const saveWaivers = async (next: string[]) => {
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      try {
                        const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', {
                          method: 'PATCH', credentials: 'same-origin',
                          headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                          body: JSON.stringify({ waived_tags: next }),
                        });
                        if (!res.ok) {
                          const e = await res.json().catch(() => ({}));
                          throw new Error(e.detail || ('HTTP ' + res.status));
                        }
                        const updated = await res.json();
                        setSelectedReview(updated);
                        loadChangeReviews({force:true});
                      } catch (err: any) {
                        alert('Could not update waived groups: ' + (err.message || 'error'));
                      }
                    };
                    return (
                      <div style={{ padding: '10px 12px', borderRadius: 8, marginBottom: 10, background: allCovered ? theme.green + '08' : theme.red + '08', border: `1px solid ${allCovered ? theme.green : theme.red}33` }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: allCovered ? theme.green : theme.red, marginBottom: 6 }}>
                          {allCovered ? '✓ All required groups covered' : 'Required groups — must assign at least one from each:'}
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                          {requiredTags.map((tag: string) => {
                            const isWaived = waivedTags.includes(tag);
                            const isCovered = coveredTags.has(tag);
                            if (isWaived) {
                              return (
                                <span key={tag} title={canEditWaivers ? 'Click to restore this group' : 'Waived for this review'}
                                  onClick={canEditWaivers ? () => saveWaivers(waivedTags.filter((t: string) => t !== tag)) : undefined}
                                  style={{
                                    fontSize: 10, padding: '3px 8px', borderRadius: 10, fontWeight: 600,
                                    background: theme.textDim + '14', color: theme.textDim,
                                    border: `1px dashed ${theme.textDim}55`, textDecoration: 'line-through',
                                    cursor: canEditWaivers ? 'pointer' : 'default',
                                  }}>
                                  {tag} — waived{canEditWaivers ? ' ↩' : ''}
                                </span>
                              );
                            }
                            return (
                              <span key={tag} style={{
                                fontSize: 10, padding: '3px 8px', borderRadius: 10, fontWeight: 600,
                                background: isCovered ? theme.green + '18' : theme.red + '15',
                                color: isCovered ? theme.green : theme.red,
                                border: `1px solid ${isCovered ? theme.green : theme.red}33`,
                                display: 'inline-flex', alignItems: 'center', gap: 4,
                              }}>
                                {isCovered ? '✓' : '✗'} {tag}
                                {canEditWaivers && (
                                  <span title={`Waive ${tag} for this review only`}
                                    onClick={() => {
                                      if (confirm(`Waive "${tag}" for this review only?\n\nThis review will go out without a ${tag} approver. The master requirement for this document type is unchanged, and this exception is recorded on the review.`)) {
                                        saveWaivers([...waivedTags, tag]);
                                      }
                                    }}
                                    style={{ cursor: 'pointer', fontWeight: 700, opacity: 0.75, paddingLeft: 2 }}>×</span>
                                )}
                              </span>
                            );
                          })}
                        </div>
                        {canEditWaivers && (
                          <div style={{ fontSize: 9, color: theme.textDim, marginTop: 6 }}>
                            Click × to waive a group for this review only — possible until it's sent for voting.
                          </div>
                        )}
                        {waivedTags.length > 0 && selectedReview.waived_by_name && (
                          <div style={{ fontSize: 9, color: theme.textDim, marginTop: 4 }}>
                            Waived by {selectedReview.waived_by_name}
                            {selectedReview.waived_at ? ' on ' + new Date(selectedReview.waived_at).toLocaleString() : ''}
                          </div>
                        )}
                      </div>
                    );
                  })()}
                  {/* Suggested reviewers */}
                  {(selectedReview.suggested_reviewers || []).length > 0 && (
                    <div style={{ marginBottom: 10 }}>
                      <div style={{ fontSize: 10, color: theme.textDim, marginBottom: 4 }}>Suggested reviewers:</div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        {(selectedReview.suggested_reviewers || []).map((s: any) => (
                          <button key={s.id} onClick={() => {
                            const current = selectedReview.review_team || [];
                            if (!current.includes(s.id) && current.length < 10) {
                              setSelectedReview({...selectedReview, review_team: [...current, s.id]});
                            }
                          }} style={{
                            fontSize: 10, padding: '3px 8px', borderRadius: 10, cursor: 'pointer',
                            background: (selectedReview.review_team || []).includes(s.id) ? theme.green + '18' : theme.accent + '12',
                            color: (selectedReview.review_team || []).includes(s.id) ? theme.green : theme.accent,
                            border: `1px solid ${(selectedReview.review_team || []).includes(s.id) ? theme.green : theme.accent}33`,
                            fontWeight: 600,
                          }}>
                            {(selectedReview.review_team || []).includes(s.id) ? '✓ ' : '+ '}{s.name} ({s.reason})
                          </button>
                        ))}
                      </div>
                    </div>
                  )}
                  <select multiple value={(selectedReview.review_team || []).map(String)}
                    onChange={e => {
                      const selected = Array.from(e.target.selectedOptions, o => Number(o.value));
                      if (selected.length <= 10) setSelectedReview({...selectedReview, review_team: selected});
                    }}
                    style={{ ...inputStyle, fontSize: 11, height: 80, padding: 4, width: '100%', marginBottom: 4 }}>
                    {allUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
                  </select>
                  {/* Show selected team as chips */}
                  {(selectedReview.review_team || []).length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 8 }}>
                      {(selectedReview.review_team || []).map((uid: number) => {
                        const user = allUsers.find(u => u.id === uid);
                        return user ? (
                          <span key={uid} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: theme.accent + '18', color: theme.accent, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                            {user.first_name} {user.last_name}
                            <span onClick={() => setSelectedReview({...selectedReview, review_team: (selectedReview.review_team || []).filter((id: number) => id !== uid)})}
                              style={{ cursor: 'pointer', fontSize: 12 }}>&times;</span>
                          </span>
                        ) : null;
                      })}
                    </div>
                  )}
                  {/* Notify-only participants — informed, not required to vote */}
                  <div style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', marginBottom: 4, marginTop: 4 }}>
                    Notify only (informed, no vote required)
                  </div>
                  <select multiple value={(selectedReview.notify_only_team || []).map(String)}
                    onChange={e => {
                      const sel = Array.from(e.target.selectedOptions, o => Number(o.value));
                      // A person can't be both a voter and notify-only; voters win.
                      const voters = selectedReview.review_team || [];
                      setSelectedReview({...selectedReview, notify_only_team: sel.filter((id: number) => !voters.includes(id))});
                    }}
                    style={{ ...inputStyle, fontSize: 11, height: 60, padding: 4, width: '100%', marginBottom: 4 }}>
                    {allUsers.filter((u: any) => !(selectedReview.review_team || []).includes(u.id))
                      .map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
                  </select>
                  {(selectedReview.notify_only_team || []).length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 8 }}>
                      {(selectedReview.notify_only_team || []).map((uid: number) => {
                        const user = allUsers.find(u => u.id === uid);
                        return user ? (
                          <span key={uid} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 10, background: theme.textDim + '18', color: theme.textMuted, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                            🔔 {user.first_name} {user.last_name}
                            <span onClick={() => setSelectedReview({...selectedReview, notify_only_team: (selectedReview.notify_only_team || []).filter((id: number) => id !== uid)})}
                              style={{ cursor: 'pointer', fontSize: 12 }}>&times;</span>
                          </span>
                        ) : null;
                      })}
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    <textarea placeholder="QM notes (optional — cost estimates, additional context)..."
                      value={selectedReview._qmNotes || ''}
                      onChange={e => setSelectedReview({...selectedReview, _qmNotes: e.target.value})}
                      style={{ ...inputStyle, height: 50, resize: 'vertical' as const, flex: 1 }} />
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                    <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600 }}>Attach file (cost estimate, etc.):</label>
                    <input type="file" id="qm-review-file" style={{ fontSize: 11, color: theme.text }} />
                  </div>
                  <button onClick={async () => {
                    if (!(selectedReview.review_team || []).length) { alert('Please assign at least one reviewer.'); return; }
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    // Use FormData if there's a file
                    const fileInput = document.getElementById('qm-review-file') as HTMLInputElement;
                    const qmFile = fileInput?.files?.[0];
                    if (qmFile) {
                      // First upload the file via PATCH
                      const fd = new FormData();
                      fd.append('qm_file', qmFile);
                      fd.append('qm_notes', selectedReview._qmNotes || '');
                      await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', {
                        method: 'PATCH', credentials: 'same-origin',
                        headers: { 'X-CSRFToken': csrfToken },
                        body: fd,
                      });
                    }
                    // Then assign team and send for review
                    const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', {
                      method: 'PATCH', credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                      body: JSON.stringify({
                        review_team: selectedReview.review_team || [],
                        notify_only_team: selectedReview.notify_only_team || [],
                        qm_notes: selectedReview._qmNotes || '',
                        status: 'in_review',
                      }),
                    });
                    if (res.ok) {
                      const updated = await res.json();
                      setSelectedReview(updated);
                      loadChangeReviews({force:true});
                      loadPending();
                      alert('Sent for review. Reviewers have been notified.');
                    } else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
                  }} style={{ padding: '8px 16px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: theme.accent, color: '#fff', border: 'none', cursor: 'pointer' }}>
                    Send for Voting
                  </button>
                </div>
              )}

              {/* QM Controls — add reviewers after voting has started (any phase) */}
              {isExecutive && (selectedReview.status === 'in_review' || selectedReview.status === 'revision_needed') && (
                <div style={{ padding: 14, borderRadius: 8, background: theme.bg, border: `1px solid ${theme.border}`, marginBottom: 16 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>
                    QM: Add Reviewers {selectedReview.status === 'in_review' ? '(voting in progress)' : '(joins next round)'}
                  </div>
                  <div style={{ fontSize: 11, color: theme.textMuted, marginBottom: 8, lineHeight: 1.5 }}>
                    {selectedReview.status === 'in_review'
                      ? 'Added reviewers are notified and must vote before this round can complete.'
                      : 'Added reviewers are included when the revised document is resubmitted for the next round.'}
                  </div>
                  <select multiple value={(selectedReview._addReviewers || []).map(String)}
                    onChange={e => {
                      const sel = Array.from(e.target.selectedOptions, o => Number(o.value));
                      setSelectedReview({...selectedReview, _addReviewers: sel});
                    }}
                    style={{ ...inputStyle, fontSize: 11, height: 70, padding: 4, width: '100%', marginBottom: 8 }}>
                    {allUsers.filter((u: any) => !(selectedReview.review_team || []).includes(u.id))
                      .map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
                  </select>
                  <button onClick={async () => {
                    const toAdd = selectedReview._addReviewers || [];
                    if (!toAdd.length) { alert('Select at least one person to add.'); return; }
                    const combined = Array.from(new Set([...(selectedReview.review_team || []), ...toAdd]));
                    if (combined.length > 10) { alert('A review can have at most 10 reviewers.'); return; }
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', {
                      method: 'PATCH', credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                      body: JSON.stringify({ review_team: combined }),
                    });
                    if (res.ok) {
                      const updated = await res.json();
                      setSelectedReview({...updated, _addReviewers: []});
                      loadChangeReviews({force:true});
                      loadPending();
                      alert(selectedReview.status === 'in_review'
                        ? 'Reviewer(s) added and notified. This round now needs their vote to complete.'
                        : 'Reviewer(s) added. They will be included on the next round when resubmitted.');
                    } else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
                  }} style={{ padding: '8px 16px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: theme.accent, color: '#fff', border: 'none', cursor: 'pointer' }}>
                    Add to Review
                  </button>
                </div>
              )}

              {/* Downstream Impact — shown on approved/completed reviews for the requester */}
              {(selectedReview.status === 'approved' || selectedReview.status === 'in_review') && (currentUser?.id === selectedReview.requested_by || isExecutive) && (
                <div style={{ padding: 12, borderRadius: 8, background: theme.bg, border: `1px solid ${theme.border}`, marginBottom: 16 }}>
                  <div style={{ fontSize: 10, fontWeight: 600, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>
                    Downstream Impact — Does this change affect other documents?
                  </div>
                  <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                    <select id="impact-doc-select" style={{ ...inputStyle, flex: 1, fontSize: 11, padding: '4px 8px' }}>
                      <option value="">Select affected document...</option>
                      {documents.filter(d => d.id !== selectedReview.document && d.status === 'active').map(d => (
                        <option key={d.id} value={d.id}>{d.system_doc_number} — {d.description || d.original_filename}</option>
                      ))}
                    </select>
                    <button onClick={async () => {
                      const sel = document.getElementById('impact-doc-select') as HTMLSelectElement;
                      if (!sel.value) return;
                      const reason = prompt('Why is this document affected?');
                      if (reason === null) return;
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/impacts/', {
                        method: 'POST', credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        body: JSON.stringify({ affected_document_id: Number(sel.value), reason }),
                      });
                      if (res.ok) {
                        sel.value = '';
                        // Refresh impacts
                        const impRes = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/impacts/', { credentials: 'same-origin' });
                        if (impRes.ok) setSelectedReview({...selectedReview, _impacts: await impRes.json()});
                      }
                    }} style={{ padding: '4px 12px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.yellow + '15', color: theme.yellow, border: `1px solid ${theme.yellow}33`, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                      Flag Impact
                    </button>
                  </div>
                  {/* List existing impacts */}
                  {(selectedReview._impacts || []).map((imp: any) => (
                    <div key={imp.id} style={{ padding: '6px 10px', borderRadius: 6, marginBottom: 4, background: theme.surface, border: `1px solid ${theme.border}`, fontSize: 11 }}>
                      <span style={{ fontFamily: 'monospace', fontWeight: 600, color: theme.accent }}>{imp.affected_document_number}</span>
                      <span style={{ color: theme.textDim, margin: '0 6px' }}>·</span>
                      <span style={{ color: theme.text }}>{imp.affected_document_desc}</span>
                      <span style={{ color: theme.textDim, margin: '0 6px' }}>·</span>
                      <span style={{ fontSize: 9, color: imp.status === 'pending' ? theme.yellow : theme.green, fontWeight: 600 }}>{imp.status}</span>
                      {imp.reason && <div style={{ fontSize: 10, color: theme.textDim, marginTop: 2 }}>{imp.reason}</div>}
                    </div>
                  ))}
                </div>
              )}

              {/* Voting Status */}
              <div style={{ marginTop: 10 }}>
                <h3 style={{ fontSize: 14, fontWeight: 700, color: theme.text, margin: '0 0 12px' }}>
                  Review Votes — Round {selectedReview.review_round}
                </h3>
                {(selectedReview.votes || []).filter((v:any) => v.review_round === selectedReview.review_round).length === 0 ? (
                  <div style={{ fontSize: 12, color: theme.textDim, padding: '10px 0' }}>
                    {selectedReview.status === 'submitted' ? 'Waiting for QM to assign reviewers.' : 'No votes yet.'}
                  </div>
                ) : (
                  (selectedReview.votes || []).filter((v:any) => v.review_round === selectedReview.review_round).map((v: any) => {
                    const voteColors: any = { pending: theme.textDim, approved: theme.green, rejected: theme.red };
                    return (
                      <div key={v.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderRadius: 6, marginBottom: 4, background: v.vote === 'approved' ? theme.green + '08' : v.vote === 'rejected' ? theme.red + '08' : theme.bg, border: `1px solid ${(voteColors[v.vote] || theme.border) + '33'}` }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <span style={{ fontSize: 14 }}>{v.vote === 'approved' ? '✓' : v.vote === 'rejected' ? '✗' : '○'}</span>
                            <span style={{ fontSize: 12, fontWeight: 600, color: theme.text }}>{v.reviewer_name}</span>
                            <span style={{ fontSize: 10, color: voteColors[v.vote], fontWeight: 600 }}>{v.vote === 'pending' ? 'Pending' : v.vote === 'approved' ? 'Approved' : 'Rejected'}</span>
                          </div>
                          {v.rejection_reason && <div style={{ fontSize: 11, color: theme.red, marginTop: 4, marginLeft: 22 }}>{v.rejection_reason}</div>}
                          {v.overridden_by_qm && <div style={{ fontSize: 10, color: theme.textDim, fontStyle: 'italic', marginTop: 3, marginLeft: 22 }}>Cast by QM ({v.overridden_by_qm_name}) &mdash; {v.override_reason}</div>}
                          {v.rejection_file && <a href={v.rejection_file} target="_blank" rel="noreferrer" style={{ fontSize: 10, color: theme.accent, marginLeft: 22 }}>View proposed alternative</a>}
                        </div>
                        {/* Vote buttons for current user */}
                        {v.vote === 'pending' && (v.reviewer === currentUser?.id || isExecutive) && (
                          <div style={{ display: 'flex', gap: 6 }}>
                            <button onClick={async () => {
                              const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                              const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/vote/', {
                                method: 'POST', credentials: 'same-origin',
                                headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                body: JSON.stringify({ vote: 'approved' }),
                              });
                              if (res.ok) {
                                const rvRes = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', { credentials: 'same-origin' });
                                if (rvRes.ok) { setSelectedReview(await rvRes.json()); loadChangeReviews({force:true}); loadPending(); }
                              } else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
                            }} style={{ padding: '3px 10px', borderRadius: 4, fontSize: 10, fontWeight: 600, background: theme.green + '15', color: theme.green, border: `1px solid ${theme.green}33`, cursor: 'pointer' }}>Approve</button>
                            <button onClick={() => { setShowRejectModal(v); setRejectReason(''); setRejectFile(null); }}
                              style={{ padding: '3px 10px', borderRadius: 4, fontSize: 10, fontWeight: 600, background: theme.red + '10', color: theme.red, border: `1px solid ${theme.red}33`, cursor: 'pointer' }}>Reject</button>
                          </div>
                        )}
                        {/* QM override — cast another reviewer's vote on their behalf (manager only) */}
                        {v.vote === 'pending' && v.reviewer !== currentUser?.id && isManager && (
                          <button onClick={async () => {
                            const dir = window.prompt('Override this reviewer\'s vote — type "approve" or "reject":', 'approve');
                            if (!dir) return;
                            const norm = dir.trim().toLowerCase();
                            const voteVal = norm.startsWith('a') ? 'approved' : norm.startsWith('r') ? 'rejected' : null;
                            if (!voteVal) { alert('Please type "approve" or "reject".'); return; }
                            const reason = window.prompt('Reason for casting this vote on their behalf (required):', '');
                            if (!reason || !reason.trim()) { alert('An override reason is required.'); return; }
                            const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                            const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/override-vote/', {
                              method: 'POST', credentials: 'same-origin',
                              headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                              body: JSON.stringify({ reviewer_id: v.reviewer, vote: voteVal, override_reason: reason.trim() }),
                            });
                            if (res.ok) {
                              const rvRes = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', { credentials: 'same-origin' });
                              if (rvRes.ok) { setSelectedReview(await rvRes.json()); loadChangeReviews({force:true}); loadPending(); }
                            } else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
                          }} style={{ padding: '3px 10px', borderRadius: 4, fontSize: 10, fontWeight: 600, background: theme.accent + '12', color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: 'pointer' }}>Override</button>
                        )}
                      </div>
                    );
                  })
                )}
                {/* Informed (notify-only) — stakeholders notified but not voting */}
                {(selectedReview.notify_only_team_names || []).length > 0 && (
                  <div style={{ marginTop: 12 }}>
                    <div style={{ fontSize: 10, fontWeight: 700, color: theme.textDim, textTransform: 'uppercase', marginBottom: 6 }}>
                      Informed — no vote required
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {(selectedReview.notify_only_team_names || []).map((u: any) => (
                        <span key={u.id} style={{ fontSize: 11, padding: '3px 10px', borderRadius: 10, background: theme.textDim + '14', color: theme.textMuted, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                          🔔 {u.name}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div style={{ padding: '12px 24px', borderTop: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setSelectedReview(null)} style={{ padding: '7px 18px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Reject Vote Modal ─── */}
      {showRejectModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setShowRejectModal(null)}>
          <div onClick={e => e.stopPropagation()} style={{ background: theme.surface, borderRadius: 12, padding: 24, width: 480, border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
            <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 700, color: theme.red }}>Reject Change</h3>
            <p style={{ margin: '0 0 14px', fontSize: 12, color: theme.textDim }}>
              Explain why you're rejecting this change. You can optionally upload your own proposed revision.
            </p>
            <textarea placeholder="Reason for rejection..." value={rejectReason} onChange={e => setRejectReason(e.target.value)}
              style={{ ...inputStyle, height: 80, resize: 'vertical' as const, width: '100%', marginBottom: 10 }} />
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Proposed Alternative Document (optional)</label>
              <input type="file" onChange={e => setRejectFile(e.target.files?.[0] || null)} style={{ fontSize: 12, color: theme.text }} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowRejectModal(null)} style={{ padding: '7px 16px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>Cancel</button>
              <button disabled={!rejectReason.trim()} onClick={async () => {
                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                const formData = new FormData();
                formData.append('vote', 'rejected');
                formData.append('rejection_reason', rejectReason);
                if (rejectFile) formData.append('rejection_file', rejectFile as any);
                const res = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/vote/', {
                  method: 'POST', credentials: 'same-origin',
                  headers: { 'X-CSRFToken': csrfToken },
                  body: formData,
                });
                if (res.ok) {
                  setShowRejectModal(null);
                  const rvRes = await fetch('/api/quality-docs/reviews/' + selectedReview.id + '/', { credentials: 'same-origin' });
                  if (rvRes.ok) { setSelectedReview(await rvRes.json()); loadChangeReviews({force:true}); loadPending(); }
                } else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
              }} style={{ padding: '7px 20px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: theme.red, color: '#fff', border: 'none', cursor: 'pointer', opacity: !rejectReason.trim() ? 0.5 : 1 }}>
                Submit Rejection
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedDoc && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={() => setSelectedDoc(null)}>
          <div style={{
            background: theme.surface, borderRadius: 16, padding: 28, width: 620,
            border: `1px solid ${theme.border}`, maxHeight: '85vh', overflow: 'auto',
          }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0, color: theme.text, wordBreak: 'break-word' }}>{selectedDoc.original_filename || selectedDoc.system_doc_number}</h2>
                <p style={{ fontSize: 12, color: theme.textDim, margin: '4px 0 0' }}>
                  {selectedDoc.category_label} · {selectedDoc.system_doc_number}
                  {isExecutive && selectedDoc.is_locked && <span style={{ marginLeft: 8, color: theme.green, fontWeight: 600 }}>🔒 Locked</span>}
                </p>
              </div>
              <button onClick={() => setSelectedDoc(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted }}>
                <Icons.X size={18}/>
              </button>
            </div>

            {/* Editable fields */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px', marginBottom: 20 }}>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={{ fontSize: 11, color: theme.textDim, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>Description</label>
                <textarea disabled={!isManager} value={editForm.description || ''} onChange={e => setEditForm(p => ({...p, description: e.target.value}))}
                  style={{ ...inputStyle, height: 60, resize: 'vertical' as const }} placeholder="Document description..." />
              </div>
              <div>
                <label style={{ fontSize: 11, color: theme.textDim, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>Document Number (Legacy)</label>
                <input disabled={!isManager} value={editForm.document_number || ''} onChange={e => setEditForm(p => ({...p, document_number: e.target.value}))}
                  style={inputStyle} placeholder="e.g. BL-1512" />
              </div>
              <div>
                <label style={{ fontSize: 11, color: theme.textDim, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>Part Number</label>
                <input disabled={!isManager} value={editForm.part_number || ''} onChange={e => setEditForm(p => ({...p, part_number: e.target.value}))}
                  style={inputStyle} placeholder="e.g. PN-1001" />
              </div>
              <div>
                <label style={{ fontSize: 11, color: theme.textDim, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>
                  Revision {isExecutive && selectedDoc.is_locked && <span style={{ color: theme.yellow, fontSize: 9, fontWeight: 400 }}>(locked)</span>}
                </label>
                <input value={editForm.revision || ''} onChange={e => setEditForm(p => ({...p, revision: e.target.value}))}
                  disabled={!isManager || selectedDoc.is_locked}
                  style={{ ...inputStyle, opacity: (isExecutive && selectedDoc.is_locked) ? 0.5 : 1 }} placeholder="e.g. G or 4" />
              </div>
              <div>
                <label style={{ fontSize: 11, color: theme.textDim, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>
                  Next Review Date {isExecutive && selectedDoc.is_locked && <span style={{ color: theme.yellow, fontSize: 9, fontWeight: 400 }}>(locked)</span>}
                </label>
                <input type="date" value={editForm.next_review_date || ''} onChange={e => setEditForm(p => ({...p, next_review_date: e.target.value}))}
                  disabled={!isManager || selectedDoc.is_locked}
                  style={{ ...inputStyle, opacity: (isExecutive && selectedDoc.is_locked) ? 0.5 : 1 }} />
              </div>
              <div>
                <label style={{ fontSize: 11, color: theme.textDim, fontWeight: 600, display: 'block', marginBottom: 4, textTransform: 'uppercase' }}>Status</label>
                <select disabled={!isManager} value={editForm.status || 'active'} onChange={e => setEditForm(p => ({...p, status: e.target.value}))}
                  style={{ ...inputStyle, cursor: 'pointer' }}>
                  {STATUS_OPTIONS.filter(s => s.key).map(s => <option key={s.key} value={s.key}>{s.label}</option>)}
                </select>
              </div>
            </div>

            {/* Read-only info + Owner/Approval Team */}
            <div style={{ background: theme.bg, borderRadius: 8, padding: 14, marginBottom: 20, border: `1px solid ${theme.border}` }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, fontSize: 12 }}>
                {isExecutive ? (
                  <div>
                    <span style={{ color: theme.textDim, display: 'block', marginBottom: 4, fontSize: 10, fontWeight: 600, textTransform: 'uppercase' }}>Owner</span>
                    <select value={editForm.owner || ''} onChange={e => setEditForm(p => ({...p, owner: e.target.value ? Number(e.target.value) : null}))}
                      style={{ ...inputStyle, fontSize: 12, padding: '4px 8px' }}>
                      <option value="">— No Owner —</option>
                      {allUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
                    </select>
                  </div>
                ) : (
                  <div><span style={{ color: theme.textDim }}>Owner:</span> <span style={{ color: theme.text }}>{selectedDoc.owner_name || '—'}</span></div>
                )}
                <div><span style={{ color: theme.textDim }}>Imported:</span> <span style={{ color: theme.text }}>{selectedDoc.import_date ? new Date(selectedDoc.import_date).toLocaleDateString() : '—'}</span></div>
                <div><span style={{ color: theme.textDim }}>File Size:</span> <span style={{ color: theme.text }}>{selectedDoc.file_size ? (selectedDoc.file_size / 1024).toFixed(0) + ' KB' : '—'}</span></div>
              </div>
              {/* Approval Team — executive only edit */}
              {(isExecutive || (selectedDoc.approval_team_names && selectedDoc.approval_team_names.length > 0)) && (
                <div style={{ marginTop: 10, borderTop: `1px solid ${theme.border}`, paddingTop: 10 }}>
                  <span style={{ color: theme.textDim, display: 'block', marginBottom: 4, fontSize: 10, fontWeight: 600, textTransform: 'uppercase' }}>
                    Approval Team ({(editForm.approval_team || []).length}/10) {!isExecutive && <span style={{ fontWeight: 400, textTransform: 'none' }}>(set by executive)</span>}
                  </span>
                  {isExecutive ? (
                    <>
                      <select multiple value={(editForm.approval_team || []).map(String)}
                        onChange={e => {
                          const selected = Array.from(e.target.selectedOptions, o => Number(o.value));
                          if (selected.length <= 10) setEditForm(p => ({...p, approval_team: selected}));
                        }}
                        style={{ ...inputStyle, fontSize: 11, height: 80, padding: 4 }}>
                        {allUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
                      </select>
                      <div style={{ fontSize: 10, color: theme.textDim, marginTop: 4 }}>Hold Ctrl/Cmd to select up to 10 users</div>
                      {/* Show selected members as chips */}
                      {(editForm.approval_team || []).length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 6 }}>
                          {(editForm.approval_team || []).map((uid: number) => {
                            const user = allUsers.find(u => u.id === uid);
                            return user ? (
                              <span key={uid} style={{
                                display: 'inline-flex', alignItems: 'center', gap: 4,
                                fontSize: 10, padding: '2px 8px', borderRadius: 10,
                                background: theme.accent + '18', color: theme.accent, fontWeight: 600,
                              }}>
                                {user.first_name} {user.last_name}
                                <span onClick={() => setEditForm(p => ({...p, approval_team: (p.approval_team || []).filter((id: number) => id !== uid)}))}
                                  style={{ cursor: 'pointer', marginLeft: 2, fontSize: 12, lineHeight: 1 }}>&times;</span>
                              </span>
                            ) : null;
                          })}
                        </div>
                      )}
                    </>
                  ) : (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {selectedDoc.approval_team_names?.length > 0
                        ? selectedDoc.approval_team_names.map((a: any, i: number) => (
                            <span key={i} style={{
                              fontSize: 11, padding: '2px 8px', borderRadius: 10,
                              background: theme.accent + '12', color: theme.accent, fontWeight: 500,
                            }}>{a.name || a}</span>
                          ))
                        : <span style={{ fontSize: 12, color: theme.textDim }}>— None —</span>
                      }
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Review window notice + Approve as Is button (owner only, within 30 days) */}
            {selectedDoc.next_review_date && (() => {
              const today = new Date();
              const reviewDate = new Date(selectedDoc.next_review_date);
              const daysUntil = Math.ceil((reviewDate.getTime() - today.getTime()) / 86400000);
              const isOwner = currentUser?.id === selectedDoc.owner;
              const inWindow = daysUntil <= 30;
              if (!inWindow) return null;
              return (
                <div style={{
                  padding: '10px 14px', borderRadius: 8, marginBottom: 14,
                  background: daysUntil < 0 ? theme.red + '12' : theme.yellow + '12',
                  border: `1px solid ${daysUntil < 0 ? theme.red : theme.yellow}33`,
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                }}>
                  <span style={{ fontSize: 12, color: daysUntil < 0 ? theme.red : theme.yellow }}>
                    {daysUntil < 0 ? `⚠ Review overdue by ${Math.abs(daysUntil)} days` : `📋 Review due in ${daysUntil} days (${selectedDoc.next_review_date})`}
                  </span>
                  {isOwner && (<>
                    <button onClick={async () => {
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      const res = await fetch('/api/quality-docs/' + selectedDoc.id + '/approve-review/', {
                        method: 'POST', credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        body: JSON.stringify({}),
                      });
                      if (res.ok) {
                        const data = await res.json();
                        alert('Document approved. New review date: ' + data.new_review_date);
                        loadDocuments();
                        loadPending();
                        setSelectedDoc(null);
                      } else {
                        const err = await res.json().catch(() => ({ detail: 'Failed' }));
                        alert(err.detail || 'Approval failed');
                      }
                    }} style={{
                      padding: '5px 14px', borderRadius: 6, fontSize: 11, fontWeight: 600,
                      background: theme.green + '18', color: theme.green, border: `1px solid ${theme.green}33`,
                      cursor: 'pointer', whiteSpace: 'nowrap',
                    }}>
                      ✓ Approve as Is
                    </button>
                    <button onClick={() => { setShowArchiveRequest(true); setArchiveReason(''); }}
                      style={{
                        padding: '5px 14px', borderRadius: 6, fontSize: 11, fontWeight: 600,
                        background: theme.red + '12', color: theme.red, border: `1px solid ${theme.red}33`,
                        cursor: 'pointer', whiteSpace: 'nowrap',
                      }}>
                      Request Archive
                    </button>
                  </>)}
                </div>
              );
            })()}

            {/* File access + Request Change buttons */}
            <div style={{ marginBottom: 14, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {selectedDoc.file && (
                <>
                  <button onClick={() => {
                    window.open('/api/quality-docs/' + selectedDoc.id + '/view/', '_blank');
                  }} style={{
                    padding: '6px 14px', borderRadius: 6, fontSize: 12, fontWeight: 600,
                    background: theme.green + '12', color: theme.green, border: `1px solid ${theme.green}33`,
                    cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6,
                  }}>
                    <Icons.Eye size={12}/> View File
                  </button>
                  <button onClick={() => {
                    window.open('/api/quality-docs/' + selectedDoc.id + '/download/', '_blank');
                  }} style={{
                    padding: '6px 14px', borderRadius: 6, fontSize: 12, fontWeight: 600,
                    background: theme.accent + '08', color: theme.accent, border: `1px solid ${theme.accent}33`,
                    cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6,
                  }}>
                    <Icons.Download size={12}/> Download
                  </button>
                </>
              )}
              <button onClick={() => { setShowChangeRequest(true); setChangeRequestText(''); }}
                style={{
                  padding: '6px 14px', borderRadius: 6, fontSize: 12, fontWeight: 600,
                  background: theme.accent + '12', color: theme.accent, border: `1px solid ${theme.accent}33`,
                  cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6,
                }}>
                <Icons.Send size={12}/> Request Change
              </button>
            </div>

            {/* Change Request Modal */}
            {showChangeRequest && (
              <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
              }} onClick={() => setShowChangeRequest(false)}>
                <div onClick={e => e.stopPropagation()} style={{
                  background: theme.surface, borderRadius: 12, padding: 24, width: 520,
                  border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                }}>
                  <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 700, color: theme.text }}>Request Document Change</h3>
                  <p style={{ margin: '0 0 14px', fontSize: 12, color: theme.textDim }}>
                    Upload a revised version of {selectedDoc.system_doc_number}. This will be sent to the Quality Manager for review.
                  </p>
                  <div style={{ marginBottom: 12 }}>
                    <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>
                      Revised Document (required)
                    </label>
                    <input type="file" onChange={e => setChangeRequestFile(e.target.files?.[0] || null)}
                      style={{ fontSize: 12, color: theme.text }} />
                  </div>
                  <div style={{ marginBottom: 12 }}>
                    <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>
                      Justification (required)
                    </label>
                    <textarea
                      placeholder="Why is this change being made?"
                      value={changeRequestText}
                      onChange={e => setChangeRequestText(e.target.value)}
                      style={{ ...inputStyle, height: 80, resize: 'vertical' as const, width: '100%' }}
                    />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 14 }}>
                    <div>
                      <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>
                        Description of Changes
                      </label>
                      <textarea
                        placeholder="What was changed?"
                        value={editForm.changeDescription || ''}
                        onChange={e => setEditForm(p => ({...p, changeDescription: e.target.value}))}
                        style={{ ...inputStyle, height: 60, resize: 'vertical' as const, width: '100%' }}
                      />
                    </div>
                    <div>
                      <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>
                        New Revision
                      </label>
                      <input
                        placeholder={selectedDoc.revision ? `Current: ${selectedDoc.revision}` : 'e.g. B or 2'}
                        value={editForm.newRevision || ''}
                        onChange={e => setEditForm(p => ({...p, newRevision: e.target.value}))}
                        style={inputStyle}
                      />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                    <button onClick={() => { setShowChangeRequest(false); setChangeRequestFile(null); }}
                      style={{ padding: '7px 16px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>
                      Cancel
                    </button>
                    <button disabled={!changeRequestText.trim() || !changeRequestFile || submittingCR}
                      onClick={async () => {
                        setSubmittingCR(true);
                        try {
                          const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                          const formData = new FormData();
                          formData.append('document', String(selectedDoc.id));
                          formData.append('new_file', changeRequestFile as any);
                          formData.append('justification', changeRequestText);
                          formData.append('description', editForm.changeDescription || '');
                          formData.append('new_revision', editForm.newRevision || '');
                          const res = await fetch('/api/quality-docs/reviews/', {
                            method: 'POST', credentials: 'same-origin',
                            headers: { 'X-CSRFToken': csrfToken },
                            body: formData,
                          });
                          if (res.ok) {
                            const data = await res.json();
                            setShowChangeRequest(false);
                            setChangeRequestFile(null);
                            loadDocuments();
                            loadPending();
                            alert(`Change review ${data.tracking_number} submitted. Quality Manager has been notified.`);
                          } else {
                            const err = await res.json().catch(() => ({ detail: 'Failed' }));
                            alert(err.detail || 'Submission failed');
                          }
                        } catch (e) { alert('Failed to submit request'); }
                        setSubmittingCR(false);
                      }}
                      style={{
                        padding: '7px 20px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                        background: theme.accent, color: '#fff', border: 'none', cursor: 'pointer',
                        opacity: !changeRequestText.trim() || !changeRequestFile || submittingCR ? 0.5 : 1,
                      }}>
                      {submittingCR ? 'Submitting...' : 'Submit for Review'}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Archive Request Modal */}
            {showArchiveRequest && (
              <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
              }} onClick={() => setShowArchiveRequest(false)}>
                <div onClick={e => e.stopPropagation()} style={{
                  background: theme.surface, borderRadius: 12, padding: 24, width: 480,
                  border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                }}>
                  <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 700, color: theme.red }}>Request Archive</h3>
                  <p style={{ margin: '0 0 14px', fontSize: 12, color: theme.textDim }}>
                    Explain why {selectedDoc.system_doc_number} should be archived. The quality manager will be notified.
                  </p>
                  <textarea
                    placeholder="Why should this document be archived?"
                    value={archiveReason}
                    onChange={e => setArchiveReason(e.target.value)}
                    style={{ ...inputStyle, height: 100, resize: 'vertical' as const, width: '100%', marginBottom: 14 }}
                  />
                  <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                    <button onClick={() => setShowArchiveRequest(false)}
                      style={{ padding: '7px 16px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>
                      Cancel
                    </button>
                    <button disabled={!archiveReason.trim() || submittingArchive}
                      onClick={async () => {
                        setSubmittingArchive(true);
                        try {
                          const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                          const res = await fetch('/api/quality-docs/' + selectedDoc.id + '/request-archive/', {
                            method: 'POST', credentials: 'same-origin',
                            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                            body: JSON.stringify({ reason: archiveReason }),
                          });
                          if (res.ok) {
                            setShowArchiveRequest(false);
                            alert('Archive request submitted. Quality manager has been notified.');
                          } else {
                            const err = await res.json().catch(() => ({ detail: 'Failed' }));
                            alert(err.detail || 'Submission failed');
                          }
                        } catch (e) { alert('Failed to submit request'); }
                        setSubmittingArchive(false);
                      }}
                      style={{
                        padding: '7px 20px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                        background: theme.red, color: '#fff', border: 'none', cursor: 'pointer',
                        opacity: !archiveReason.trim() || submittingArchive ? 0.5 : 1,
                      }}>
                      {submittingArchive ? 'Submitting...' : 'Submit Archive Request'}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* Action buttons */}
            <div style={{ display: 'flex', gap: 10, justifyContent: isManager ? 'space-between' : 'flex-end' }}>
              {isExecutive && (
                <div style={{ display: 'flex', gap: 8 }}>
                  {!selectedDoc.is_locked ? (
                    <button onClick={async () => {
                      try {
                        const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                        // Save edits first
                        await fetch('/api/quality-docs/' + selectedDoc.id + '/', {
                          method: 'PATCH', credentials: 'same-origin',
                          headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                          body: JSON.stringify(editForm),
                        });
                        // Then lock
                        const res = await fetch('/api/quality-docs/' + selectedDoc.id + '/lock/', {
                          method: 'POST', credentials: 'same-origin',
                          headers: { 'X-CSRFToken': csrfToken },
                        });
                        if (res.ok) {
                          const updated = await res.json();
                          setSelectedDoc(updated);
                          loadDocuments();
                        } else { alert('Lock failed'); }
                      } catch (e) { alert('Lock failed: ' + e.message); }
                    }} style={{ ...btnSecondary, color: theme.green, borderColor: theme.green + '44' }}>
                      🔒 Save & Lock
                    </button>
                  ) : (
                    <button onClick={async () => {
                      try {
                        const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                        const res = await fetch('/api/quality-docs/' + selectedDoc.id + '/unlock/', {
                          method: 'POST', credentials: 'same-origin',
                          headers: { 'X-CSRFToken': csrfToken },
                        });
                        if (res.ok) {
                          const updated = await res.json();
                          setSelectedDoc(updated);
                          loadDocuments();
                        } else { alert('Unlock failed'); }
                      } catch (e) { alert('Unlock failed: ' + e.message); }
                    }} style={{ ...btnSecondary, color: theme.yellow, borderColor: theme.yellow + '44' }}>
                      🔓 Unlock
                    </button>
                  )}
                </div>
              )}
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={() => setSelectedDoc(null)} style={btnSecondary}>Close</button>
                {isManager && (
                  <button onClick={async () => {
                    setSaving(true);
                    try {
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      const res = await fetch('/api/quality-docs/' + selectedDoc.id + '/', {
                        method: 'PATCH', credentials: 'same-origin',
                        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                        body: JSON.stringify(editForm),
                      });
                      if (res.ok) {
                        const updated = await res.json();
                        setSelectedDoc(updated);
                        loadDocuments();
                      } else {
                        const err = await res.json().catch(() => ({ detail: 'Save failed' }));
                        alert(err.detail || JSON.stringify(err));
                      }
                    } catch (e) { alert('Save failed: ' + e.message); }
                    setSaving(false);
                  }} style={{ ...btnPrimary, opacity: saving ? 0.5 : 1 }}>
                    {saving ? 'Saving...' : 'Save Changes'}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ─── Upload Modal ─── */}
      {showUpload && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={() => setShowUpload(false)}>
          <div style={{
            background: theme.surface, borderRadius: 16, padding: 28, width: 480,
            border: `1px solid ${theme.border}`, maxHeight: '80vh', overflow: 'auto',
          }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Upload Quality Documents</h2>
              <button onClick={() => setShowUpload(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted }}>
                <Icons.X size={18}/>
              </button>
            </div>

            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, color: theme.textDim, fontWeight: 600, display: 'block', marginBottom: 6 }}>Category</label>
              <select value={uploadCategory} onChange={e => setUploadCategory(e.target.value)} style={{ ...inputStyle, cursor: 'pointer' }}>
                {[
                  { key: 'forms', label: 'Form' }, { key: 'pcc', label: 'PCC' },
                  { key: 'sop', label: 'SOP' }, { key: 'eop', label: 'EOP' },
                  { key: 'qatp', label: 'QATP' }, { key: 'route_sheets', label: 'Route Sheet' },
                  { key: 'specifications', label: 'Specification' }, { key: 'tds', label: 'TDS' },
                  { key: 'sds', label: 'SDS' }, { key: 'training', label: 'Training' },
                  { key: 'competencies', label: 'Competency' }, { key: 'oi', label: 'Operating Instruction' },
                  { key: 'qms', label: 'QMS Document' },
                ].map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ fontSize: 12, color: theme.textDim, fontWeight: 600, display: 'block', marginBottom: 6 }}>Files</label>
              <div style={{
                border: `2px dashed ${theme.border}`, borderRadius: 12, padding: 32,
                textAlign: 'center', cursor: 'pointer',
                background: uploadFiles.length ? theme.accentGlow : 'transparent',
              }} onClick={() => document.getElementById('qd-file-input')?.click()}>
                <Icons.Upload size={28} color={theme.textDim}/>
                <p style={{ color: theme.textMuted, fontSize: 13, margin: '8px 0 0' }}>
                  {uploadFiles.length ? `${uploadFiles.length} file(s) selected` : 'Click to select files (multi-select enabled)'}
                </p>
                <input id="qd-file-input" type="file" multiple style={{ display: 'none' }}
                       onChange={e => setUploadFiles(Array.from(e.target.files || []))}/>
              </div>
              {uploadFiles.length > 0 && (
                <div style={{ marginTop: 10, maxHeight: 120, overflow: 'auto' }}>
                  {Array.from(uploadFiles).map((f, i) => (
                    <div key={i} style={{ fontSize: 12, color: theme.textMuted, padding: '3px 0' }}>
                      <Icons.File size={12}/> {f.name} ({(f.size / 1024).toFixed(0)} KB)
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowUpload(false)} style={btnSecondary}>Cancel</button>
              <button onClick={handleUpload} disabled={!uploadFiles.length || uploading} style={{
                ...btnPrimary, opacity: !uploadFiles.length || uploading ? 0.5 : 1,
              }}>
                {uploading ? 'Uploading...' : `Upload ${uploadFiles.length || ''} File${uploadFiles.length !== 1 ? 's' : ''}`}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── Display Settings Modal ─── */}
      {showSettings && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 1000,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }} onClick={() => setShowSettings(false)}>
          <div style={{
            background: theme.surface, borderRadius: 16, padding: 28, width: 560,
            border: `1px solid ${theme.border}`, maxHeight: '80vh', overflow: 'auto',
          }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <h2 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>Display Settings</h2>
                <p style={{ fontSize: 12, color: theme.textDim, margin: '4px 0 0' }}>
                  Choose which field to show as the primary display name for each category
                </p>
              </div>
              <button onClick={() => setShowSettings(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted }}>
                <Icons.X size={18}/>
              </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { key: 'forms', label: 'Forms', prefix: 'FORM' },
                { key: 'pcc', label: 'PCC', prefix: 'PCC' },
                { key: 'sop', label: 'SOP', prefix: 'SOP' },
                { key: 'eop', label: 'EOP', prefix: 'EOP' },
                { key: 'qatp', label: 'QATP', prefix: 'QATP' },
                { key: 'route_sheets', label: 'Route Sheets', prefix: 'RS' },
                { key: 'specifications', label: 'Specifications', prefix: 'SPEC' },
                { key: 'competencies', label: 'Competencies', prefix: 'COMP' },
                { key: 'tds', label: 'TDS', prefix: 'TDS' },
                { key: 'training', label: 'Training', prefix: 'TRAIN' },
                { key: 'sds', label: 'SDS', prefix: 'SDS' },
                { key: 'oi', label: 'Operating Instructions', prefix: 'OI' },
                { key: 'qms', label: 'QMS', prefix: 'QMS' },
              ].map(cat => (
                <div key={cat.key} style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  padding: '10px 14px', background: theme.bg, borderRadius: 8,
                  border: `1px solid ${theme.border}`,
                }}>
                  <div>
                    <span style={{ fontSize: 13, fontWeight: 600, color: theme.text }}>{cat.label}</span>
                    <span style={{ fontSize: 11, color: theme.textDim, marginLeft: 8 }}>{cat.prefix}-###</span>
                  </div>
                  <select
                    value={displayConfigs[cat.key] || 'system_doc_number'}
                    onChange={e => handleConfigChange(cat.key, e.target.value)}
                    style={{ ...inputStyle, width: 200, fontSize: 12, padding: '6px 10px', cursor: 'pointer' }}
                  >
                    {DISPLAY_FIELD_OPTIONS.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
              ))}
            </div>

            {/* ─── User Functional Tags ─── */}
            {isExecutive && (
              <div style={{ marginTop: 24, borderTop: `1px solid ${theme.border}`, paddingTop: 20 }}>
                <h3 style={{ margin: '0 0 12px', fontSize: 15, fontWeight: 700, color: theme.text }}>User Functional Tags</h3>
                <p style={{ fontSize: 11, color: theme.textDim, marginBottom: 14 }}>
                  Assign functional responsibilities (EHS, Finance, Quality Manager, etc.) to users. These are used for reviewer suggestions.
                </p>

                {/* Create new tag */}
                <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
                  <input value={newTagName} onChange={e => setNewTagName(e.target.value)}
                    placeholder="New tag name (e.g. EHS, Finance)" style={{ ...inputStyle, flex: 1 }} />
                  <input type="color" value={newTagColor} onChange={e => setNewTagColor(e.target.value)}
                    style={{ width: 36, height: 36, border: 'none', borderRadius: 6, cursor: 'pointer' }} />
                  <button disabled={!newTagName.trim()} onClick={async () => {
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    const res = await fetch('/api/quality-docs/tags/', {
                      method: 'POST', credentials: 'same-origin',
                      headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                      body: JSON.stringify({ name: newTagName, color: newTagColor }),
                    });
                    if (res.ok) {
                      setNewTagName('');
                      fetch('/api/quality-docs/tags/', { credentials: 'same-origin' })
                        .then(r => r.ok ? r.json() : []).then(setUserTags);
                    }
                  }} style={{ ...btnPrimary, opacity: newTagName.trim() ? 1 : 0.5, whiteSpace: 'nowrap', padding: '6px 14px', fontSize: 12 }}>
                    Add Tag
                  </button>
                </div>

                {/* Tag list with user assignments */}
                {userTags.map((tag: any) => (
                  <div key={tag.id} style={{
                    padding: 12, borderRadius: 8, marginBottom: 10,
                    background: theme.bg, border: `1px solid ${theme.border}`,
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <span style={{
                          width: 10, height: 10, borderRadius: '50%',
                          background: tag.color, display: 'inline-block',
                        }} />
                        <span style={{ fontSize: 13, fontWeight: 700, color: theme.text }}>{tag.name}</span>
                        <span style={{ fontSize: 10, color: theme.textDim }}>({tag.users?.length || 0} users)</span>
                      </div>
                      <button onClick={async () => {
                        const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                        await fetch('/api/quality-docs/tags/' + tag.id + '/', {
                          method: 'DELETE', credentials: 'same-origin',
                          headers: { 'X-CSRFToken': csrfToken },
                        });
                        fetch('/api/quality-docs/tags/', { credentials: 'same-origin' })
                          .then(r => r.ok ? r.json() : []).then(setUserTags);
                      }} style={{ fontSize: 10, color: theme.red, background: 'none', border: 'none', cursor: 'pointer' }}>
                        Remove
                      </button>
                    </div>
                    {/* Current users with this tag */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 8 }}>
                      {(tag.users || []).map((u: any) => (
                        <span key={u.id} style={{
                          fontSize: 10, padding: '2px 8px', borderRadius: 10,
                          background: tag.color + '18', color: tag.color, fontWeight: 600,
                          display: 'inline-flex', alignItems: 'center', gap: 3,
                        }}>
                          {u.name}
                          <span onClick={async () => {
                            const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                            await fetch('/api/quality-docs/tags/' + tag.id + '/assign/' + u.id + '/', {
                              method: 'DELETE', credentials: 'same-origin',
                              headers: { 'X-CSRFToken': csrfToken },
                            });
                            fetch('/api/quality-docs/tags/', { credentials: 'same-origin' })
                              .then(r => r.ok ? r.json() : []).then(setUserTags);
                          }} style={{ cursor: 'pointer', fontSize: 12 }}>&times;</span>
                        </span>
                      ))}
                    </div>
                    {/* Add user to tag */}
                    <select onChange={async e => {
                      if (!e.target.value) return;
                      const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                      await fetch('/api/quality-docs/tags/' + tag.id + '/assign/' + e.target.value + '/', {
                        method: 'POST', credentials: 'same-origin',
                        headers: { 'X-CSRFToken': csrfToken },
                      });
                      e.target.value = '';
                      fetch('/api/quality-docs/tags/', { credentials: 'same-origin' })
                        .then(r => r.ok ? r.json() : []).then(setUserTags);
                    }} style={{ ...inputStyle, fontSize: 11, padding: '4px 8px' }}>
                      <option value="">+ Add user...</option>
                      {allUsers.filter(u => !(tag.users || []).some((tu: any) => tu.id === u.id)).map(u => (
                        <option key={u.id} value={u.id}>{u.first_name} {u.last_name}</option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>
            )}

            {/* ─── BL-1200 Dropdown Lists ─── */}
            {isExecutive && (
              <div style={{ marginTop: 24, borderTop: `1px solid ${theme.border}`, paddingTop: 20 }}>
                <h3 style={{ margin: '0 0 12px', fontSize: 15, fontWeight: 700, color: theme.text }}>Dropdown Lists (BL-1200)</h3>
                <p style={{ fontSize: 11, color: theme.textDim, marginBottom: 14 }}>
                  Manage dropdown values used in part number requests and BL-1200 forms.
                </p>
                {dropdownLists.map((dl: any) => (
                  <div key={dl.id} style={{ padding: 10, borderRadius: 8, marginBottom: 8, background: theme.bg, border: `1px solid ${theme.border}` }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: theme.text, marginBottom: 6 }}>{dl.name}</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 6 }}>
                      {(dl.items || []).map((item: any) => (
                        <span key={item.id} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 8, background: theme.accent + '12', color: theme.accent, display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                          {item.label || item.value}
                          <span onClick={async () => {
                            const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                            await fetch('/api/quality-docs/dropdowns/' + dl.id + '/items/', {
                              method: 'DELETE', credentials: 'same-origin',
                              headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                              body: JSON.stringify({ item_id: item.id }),
                            });
                            fetch('/api/quality-docs/dropdowns/', { credentials: 'same-origin' })
                              .then(r => r.ok ? r.json() : []).then(setDropdownLists);
                          }} style={{ cursor: 'pointer', fontSize: 12 }}>&times;</span>
                        </span>
                      ))}
                    </div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <input id={`dd-add-${dl.id}`} placeholder="Add value..." style={{ ...inputStyle, fontSize: 11, padding: '3px 8px', flex: 1 }}
                        onKeyDown={async e => {
                          if (e.key !== 'Enter') return;
                          const input = e.target as HTMLInputElement;
                          if (!input.value.trim()) return;
                          const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                          await fetch('/api/quality-docs/dropdowns/' + dl.id + '/items/', {
                            method: 'POST', credentials: 'same-origin',
                            headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                            body: JSON.stringify({ value: input.value.trim() }),
                          });
                          input.value = '';
                          fetch('/api/quality-docs/dropdowns/', { credentials: 'same-origin' })
                            .then(r => r.ok ? r.json() : []).then(setDropdownLists);
                        }} />
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={() => setShowSettings(false)} style={btnPrimary}>Done</button>
            </div>
          </div>
        </div>
      )}

      {/* ─── EO Creation Modal ───────────────────────────────────── */}
      {showEOModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999,
        }} onClick={() => setShowEOModal(false)}>
          <div onClick={e => e.stopPropagation()} style={{
            background: theme.surface, borderRadius: 14, padding: 0, width: 700, maxHeight: '90vh',
            border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
            display: 'flex', flexDirection: 'column', overflow: 'hidden',
          }}>
            {/* Modal Header */}
            <div style={{
              padding: '16px 24px', borderBottom: `1px solid ${theme.border}`,
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              background: theme.yellow + '08',
            }}>
              <div>
                <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: theme.text }}>
                  Engineering Change / Engineering Order
                </h2>
                <p style={{ margin: '2px 0 0', fontSize: 11, color: theme.textDim }}>
                  Fill out the form below and submit for signoff
                </p>
              </div>
              <button onClick={() => setShowEOModal(false)}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: theme.textMuted, padding: 4 }}>
                <Icons.X size={18}/>
              </button>
            </div>

            {/* Modal Body — scrollable */}
            <div style={{ padding: 24, overflow: 'auto', flex: 1 }}>
              {/* Row 1: Program + Spec Type */}
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 14, marginBottom: 16 }}>
                <div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Program</label>
                  <input value={eoForm.program} onChange={e => setEoForm(p => ({...p, program: e.target.value}))}
                    style={inputStyle} placeholder="Program name" />
                </div>
                <div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Specification Type</label>
                  <div style={{ display: 'flex', gap: 14, marginTop: 6 }}>
                    {[{v:'production',l:'Production'},{v:'development',l:'Development'}].map(o => (
                      <label key={o.v} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: theme.text, cursor: 'pointer' }}>
                        <input type="radio" name="spec_type" checked={eoForm.spec_type === o.v}
                          onChange={() => setEoForm(p => ({...p, spec_type: o.v}))} /> {o.l}
                      </label>
                    ))}
                  </div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4, marginTop: 10 }}>Duration</label>
                  <div style={{ display: 'flex', gap: 14 }}>
                    {[{v:'one_time',l:'One Time Only (EO)'},{v:'permanent',l:'Permanent (EC)'}].map(o => (
                      <label key={o.v} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: theme.text, cursor: 'pointer' }}>
                        <input type="radio" name="duration" checked={eoForm.duration === o.v}
                          onChange={() => {
                            setEoForm(p => ({...p, duration: o.v}));
                            if (o.v === 'permanent') {
                              alert('Permanent Engineering Change (EC) requires updated Specification and Route Sheet. Please ensure both are included with this submission.');
                            }
                          }} /> {o.l}
                      </label>
                    ))}
                  </div>
                  {eoForm.duration === 'permanent' && (
                    <div style={{ marginTop: 6, padding: '6px 10px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: theme.yellow + '12', color: theme.yellow, border: `1px solid ${theme.yellow}33` }}>
                      ⚠ EC: Permanent change — must include updated Specification and Route Sheet
                    </div>
                  )}
                  </div>
                </div>
              </div>

              {/* Row 2: Part Numbers + Title */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 }}>
                <div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Part/Document Number(s)</label>
                  <textarea value={eoForm.part_numbers} onChange={e => setEoForm(p => ({...p, part_numbers: e.target.value}))}
                    style={{ ...inputStyle, height: 60, resize: 'vertical' as const }} placeholder="One per line, e.g.&#10;80566-002&#10;80567-002" />
                </div>
                <div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Drawing/Document Title</label>
                  <input value={eoForm.document_title} onChange={e => setEoForm(p => ({...p, document_title: e.target.value}))}
                    style={inputStyle} placeholder="e.g. GDS2185M" />
                </div>
              </div>

              {/* Row 3: Change Type + Lot Nos */}
              <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 14, marginBottom: 16 }}>
                <div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Change Type</label>
                  <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                    {[{v:'mandatory',l:'Mandatory'},{v:'optional',l:'Optional'},{v:'ease_mfg',l:'Ease of Mfg.'}].map(o => (
                      <label key={o.v} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: theme.text, cursor: 'pointer' }}>
                        <input type="radio" name="change_type" checked={eoForm.change_type === o.v}
                          onChange={() => setEoForm(p => ({...p, change_type: o.v}))} /> {o.l}
                      </label>
                    ))}
                  </div>
                </div>
                <div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Lot Nos. Affected</label>
                  <input value={eoForm.lot_numbers} onChange={e => setEoForm(p => ({...p, lot_numbers: e.target.value}))}
                    style={inputStyle} placeholder="Optional" />
                </div>
              </div>

              {/* Hardware unaffected checkbox */}
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, fontSize: 12, color: theme.text, cursor: 'pointer' }}>
                <input type="checkbox" checked={eoForm.hardware_unaffected}
                  onChange={e => setEoForm(p => ({...p, hardware_unaffected: e.target.checked}))} />
                Hardware Unaffected
              </label>

              {/* Change From / Change To */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 }}>
                <div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Change From</label>
                  <textarea value={eoForm.change_from} onChange={e => setEoForm(p => ({...p, change_from: e.target.value}))}
                    style={{ ...inputStyle, height: 100, resize: 'vertical' as const }} placeholder="Current state..." />
                </div>
                <div>
                  <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Change To</label>
                  <textarea value={eoForm.change_to} onChange={e => setEoForm(p => ({...p, change_to: e.target.value}))}
                    style={{ ...inputStyle, height: 100, resize: 'vertical' as const }} placeholder="New state..." />
                </div>
              </div>

              {/* Reason */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Why Is This Change Necessary?</label>
                <textarea value={eoForm.reason} onChange={e => setEoForm(p => ({...p, reason: e.target.value}))}
                  style={{ ...inputStyle, height: 80, resize: 'vertical' as const, width: '100%' }} placeholder="Explain the justification..." />
              </div>

              {/* Disposition */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Disposition of Material</label>
                <textarea value={eoForm.disposition} onChange={e => setEoForm(p => ({...p, disposition: e.target.value}))}
                  style={{ ...inputStyle, height: 60, resize: 'vertical' as const, width: '100%' }} placeholder="Optional — how should existing material be handled?" />
              </div>

              {/* File Attachment */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Attachment (optional)</label>
                <input type="file" id="eo-attachment" style={{ fontSize: 11 }} />
              </div>

              {/* Info note about signoffs */}
              <div style={{
                padding: '10px 14px', borderRadius: 8, fontSize: 11, color: theme.textDim,
                background: theme.bg, border: `1px solid ${theme.border}`,
              }}>
                Signoff roles will be assigned automatically from the master list when this EO is submitted.
                All assigned personnel will receive an email notification.
              </div>
            </div>

            {/* Modal Footer */}
            <div style={{
              padding: '14px 24px', borderTop: `1px solid ${theme.border}`,
              display: 'flex', gap: 10, justifyContent: 'flex-end',
            }}>
              <button onClick={() => setShowEOModal(false)}
                style={{ padding: '8px 18px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>
                Cancel
              </button>
              <button
                disabled={!eoForm.part_numbers.trim() || !eoForm.document_title.trim() || !eoForm.change_from.trim() || !eoForm.change_to.trim() || !eoForm.reason.trim() || submittingEO}
                onClick={async () => {
                  setSubmittingEO(true);
                  try {
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    // Create the EO with optional file attachment
                    const fd = new FormData();
                    Object.entries(eoForm).forEach(([k, v]) => fd.append(k, String(v)));
                    const eoFile = (document.getElementById('eo-attachment') as HTMLInputElement)?.files?.[0];
                    if (eoFile) fd.append('attachment', eoFile);
                    const createRes = await fetch('/api/quality-docs/eo/', {
                      method: 'POST', credentials: 'same-origin',
                      headers: { 'X-CSRFToken': csrfToken },
                      body: fd,
                    });
                    if (!createRes.ok) {
                      const err = await createRes.json().catch(() => ({
                        detail: `Failed to create EO — server error (HTTP ${createRes.status}). `
                              + `Please report this to IT with the time it happened.`,
                      }));
                      alert(err.detail || JSON.stringify(err));
                      setSubmittingEO(false);
                      return;
                    }
                    const eo = await createRes.json();
                    setShowEOModal(false);
                    setEoForm({
                      program: '', spec_type: 'production', duration: 'permanent',
                      part_numbers: '', document_title: '',
                      change_type: 'mandatory', hardware_unaffected: false, lot_numbers: '',
                      change_from: '', change_to: '', reason: '', disposition: '',
                    });
                    if (activeCategory === 'eo') loadEOs(); loadPending();
                    alert((eo.display_number || ('EO-' + eo.eo_number)) + ' submitted. Quality manager has been notified.');
                  } catch (e: any) { alert('Error: ' + e.message); }
                  setSubmittingEO(false);
                }}
                style={{
                  padding: '8px 24px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                  background: theme.yellow, color: '#000', border: 'none', cursor: 'pointer',
                  opacity: !eoForm.part_numbers.trim() || !eoForm.document_title.trim() || !eoForm.change_from.trim() || !eoForm.change_to.trim() || !eoForm.reason.trim() || submittingEO ? 0.5 : 1,
                }}>
                {submittingEO ? 'Submitting...' : 'Create & Submit EO'}
              </button>
            </div>
          </div>
      )}

      {/* ─── New Document Request Modal ──────────────────────────── */}
      {showNewDocModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setShowNewDocModal(false)}>
          <div onClick={e => e.stopPropagation()} style={{ background: theme.surface, borderRadius: 14, padding: 24, width: 500, border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
            <h2 style={{ margin: '0 0 4px', fontSize: 18, fontWeight: 700, color: theme.text }}>Request New Document</h2>
            <p style={{ margin: '0 0 12px', fontSize: 11, color: theme.textDim }}>Select a type and the system will allocate the next available document number.</p>
            <div style={{
              display: 'flex', gap: 8, alignItems: 'flex-start', marginBottom: 16, padding: '10px 12px',
              background: theme.yellow + '14', border: `1px solid ${theme.yellow}55`, borderRadius: 8,
            }}>
              <span style={{ fontSize: 13, lineHeight: '16px' }}>⚠️</span>
              <div style={{ fontSize: 11, color: theme.text, lineHeight: 1.5 }}>
                <strong>This is not for new Part Numbers or Specifications.</strong> If you need a new part
                number or its specification, close this and use <strong>Request New Part #</strong> instead —
                requests submitted here will be rejected and you'll have to re-enter them.
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Document Type</label>
              <select id="new-doc-category" style={{ ...inputStyle, width: '100%' }}>
                {[
                  { key: 'forms', label: 'Form' }, { key: 'pcc', label: 'PCC' },
                  { key: 'sop', label: 'SOP' }, { key: 'eop', label: 'EOP' },
                  { key: 'qatp', label: 'QATP' }, { key: 'route_sheets', label: 'Route Sheet' },
                  { key: 'specifications', label: 'Specification' }, { key: 'tds', label: 'TDS' },
                  { key: 'sds', label: 'SDS' }, { key: 'training', label: 'Training' },
                  { key: 'competencies', label: 'Competency' }, { key: 'oi', label: 'Operating Instruction' },
                  { key: 'qms', label: 'QMS Document' },
                ].map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
              </select>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Title</label>
              <input id="new-doc-title" style={inputStyle} placeholder="Document title..." />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Justification</label>
              <textarea id="new-doc-justification" placeholder="Why is this document needed?" style={{ ...inputStyle, height: 70, resize: 'vertical' as const, width: '100%' }} />
            </div>
            <div style={{ marginBottom: 14 }}>
              <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase', display: 'block', marginBottom: 4 }}>Draft File (optional)</label>
              <input type="file" id="new-doc-file" style={{ fontSize: 12, color: theme.text }} />
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowNewDocModal(false)} style={{ padding: '7px 16px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>Cancel</button>
              <button onClick={async () => {
                const cat = (document.getElementById('new-doc-category') as HTMLSelectElement).value;
                const title = (document.getElementById('new-doc-title') as HTMLInputElement).value.trim();
                const just = (document.getElementById('new-doc-justification') as HTMLTextAreaElement).value.trim();
                const fileInput = document.getElementById('new-doc-file') as HTMLInputElement;
                if (!title || !just) { alert('Title and justification are required.'); return; }
                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                const fd = new FormData();
                fd.append('category', cat);
                fd.append('title', title);
                fd.append('justification', just);
                if (fileInput?.files?.[0]) fd.append('file', fileInput.files[0]);
                const res = await fetch('/api/quality-docs/new-doc-requests/', {
                  method: 'POST', credentials: 'same-origin',
                  headers: { 'X-CSRFToken': csrfToken }, body: fd,
                });
                if (res.ok) {
                  const data = await res.json();
                  setShowNewDocModal(false);
                  loadDocuments(); loadPending();
                  alert(`New document ${data.document_number} created and sent to QM for review.`);
                } else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
              }} style={{ padding: '7px 20px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: theme.green, color: '#fff', border: 'none', cursor: 'pointer' }}>
                Submit Request
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ─── New Part Number Request Modal (Full 4-Scenario) ──────── */}
      {showNewPNModal && (() => {
        const step = pnStep;
        const setStep = setPnStep;
        const submitting = pnSubmitting;
        const setSubmitting = setPnSubmitting;
        const ddLists = pnDropdowns;

        const getList = (name: string) => (ddLists.find((d: any) => d.name === name)?.items || []).map((i: any) => i.value);

        const scenario = pnForm.isNewParent
          ? (pnForm.isPurchased ? 'new_purchased' : 'new_manufactured')
          : (pnForm.isPurchased ? 'suffix_purchased' : 'suffix_manufactured');

        const scenarioLabel = {
          'suffix_purchased': 'New Suffix — Purchased Part',
          'suffix_manufactured': 'New Suffix — Manufactured Part (EC)',
          'new_purchased': 'New Parent — Purchased Part',
          'new_manufactured': 'New Parent — Manufactured Part',
        }[scenario];

        const Lbl = ({children}: any) => <label style={{ fontSize: 10, color: theme.textDim, fontWeight: 600, textTransform: 'uppercase' as const, display: 'block', marginBottom: 3 }}>{children}</label>;

        return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setShowNewPNModal(false)}>
          <div onClick={e => e.stopPropagation()} style={{ background: theme.surface, borderRadius: 14, padding: 24, width: 600, maxHeight: '90vh', overflow: 'auto', border: `1px solid ${theme.border}`, boxShadow: '0 20px 60px rgba(0,0,0,0.4)' }}>
            <h2 style={{ margin: '0 0 4px', fontSize: 18, fontWeight: 700, color: theme.text }}>Request New Part Number</h2>
            <p style={{ margin: '0 0 16px', fontSize: 11, color: theme.textDim }}>Step {step} of 2 — {step === 1 ? 'Classification' : 'Part Details'}</p>

            {/* Step 1: Classification */}
            {step === 1 && (<>
              <div style={{ marginBottom: 16 }}>
                <Lbl>Is this a new parent part number or a new suffix?</Lbl>
                <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                  {[{v: false, l: 'New Suffix on Existing Parent'}, {v: true, l: 'Entirely New Parent Number'}].map(o => (
                    <label key={String(o.v)} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: theme.text, cursor: 'pointer', padding: '8px 14px', borderRadius: 8, border: `1px solid ${pnForm.isNewParent === o.v ? theme.accent : theme.border}`, background: pnForm.isNewParent === o.v ? theme.accent + '12' : 'transparent' }}>
                      <input type="radio" name="pn-parent" checked={pnForm.isNewParent === o.v}
                        onChange={() => setPnForm(p => ({...p, isNewParent: o.v}))} /> {o.l}
                    </label>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <Lbl>Is this a purchased part or manufactured?</Lbl>
                <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                  {[{v: true, l: 'Purchased'}, {v: false, l: 'Manufactured'}].map(o => (
                    <label key={String(o.v)} style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: theme.text, cursor: 'pointer', padding: '8px 14px', borderRadius: 8, border: `1px solid ${pnForm.isPurchased === o.v ? theme.accent : theme.border}`, background: pnForm.isPurchased === o.v ? theme.accent + '12' : 'transparent' }}>
                      <input type="radio" name="pn-type" checked={pnForm.isPurchased === o.v}
                        onChange={() => setPnForm(p => ({...p, isPurchased: o.v}))} /> {o.l}
                    </label>
                  ))}
                </div>
              </div>
              <div style={{ padding: '10px 14px', borderRadius: 8, background: theme.accent + '08', border: `1px solid ${theme.accent}33`, marginBottom: 16 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: theme.accent }}>{scenarioLabel}</div>
                <div style={{ fontSize: 11, color: theme.textDim, marginTop: 2 }}>
                  {scenario === 'suffix_manufactured' && 'This will generate an EC tracking number.'}
                  {scenario === 'suffix_purchased' && 'Adding a new size/quantity variant of an existing purchased material.'}
                  {scenario === 'new_purchased' && 'Introducing an entirely new raw material from a supplier.'}
                  {scenario === 'new_manufactured' && 'Creating a completely new manufactured product.'}
                </div>
              </div>
              {!pnForm.isNewParent && (
                <div style={{ padding: '8px 12px', borderRadius: 6, background: theme.yellow + '12', border: `1px solid ${theme.yellow}33`, marginBottom: 16, fontSize: 11, color: theme.yellow, fontWeight: 600 }}>
                  ⚠ Adding a new suffix may require up-revving all parts under the parent. The QM will determine this at final approval.
                </div>
              )}
              {!pnForm.isNewParent && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                  <div><Lbl>Existing Parent Number</Lbl><input value={pnForm.existingParent} onChange={e => setPnForm(p => ({...p, existingParent: e.target.value}))}
                    onBlur={async e => {
                      const parent = e.target.value.trim();
                      if (!parent) return;
                      try {
                        const res = await fetch('/api/quality-docs/pn-lookup/?parent=' + encodeURIComponent(parent), { credentials: 'same-origin' });
                        if (res.ok) {
                          const data = await res.json();
                          if (data.found) {
                            setPnForm(p => ({
                              ...p,
                              partDescription: p.partDescription || data.part_description || '',
                              costingLot: p.costingLot || data.costing_lot || '',
                              uomInventory: p.uomInventory || data.uom_inventory || '',
                              uomSales: p.uomSales || data.uom_sales || '',
                              uomPurchasing: p.uomPurchasing || data.uom_purchasing || '',
                              productGroup: p.productGroup || data.product_group || '',
                              productClass: p.productClass || data.product_class || '',
                              mfgDateTracking: data.mfg_date_tracking || false,
                              shelfLifeDays: String(data.shelf_life_days || '0'),
                              countryOfOrigin: p.countryOfOrigin || data.country_of_origin || '',
                            }));
                          }
                        }
                      } catch (err) {}
                    }}
                    placeholder="e.g. 80233" style={inputStyle} /></div>
                  <div><Lbl>New Suffix (no dash)</Lbl><input value={pnForm.newSuffix} onChange={e => setPnForm(p => ({...p, newSuffix: e.target.value}))} placeholder="e.g. 003 or sam" style={inputStyle} /></div>
                </div>
              )}
              {pnForm.isNewParent && (
                <div style={{ marginBottom: 12 }}><Lbl>Desired Suffix (default -001)</Lbl><input value={pnForm.newSuffix} onChange={e => setPnForm(p => ({...p, newSuffix: e.target.value}))} placeholder="001" style={inputStyle} /></div>
              )}
              <div style={{ marginBottom: 12 }}><Lbl>Reason for New Part</Lbl><textarea value={pnForm.reason} onChange={e => setPnForm(p => ({...p, reason: e.target.value}))} placeholder="Why is this new part number needed?" style={{ ...inputStyle, height: 60, resize: 'vertical' as const, width: '100%' }} /></div>
              {!pnForm.isPurchased && !pnForm.isNewParent && (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                  <div><Lbl>Similar Existing P/N</Lbl><input value={pnForm.similarPart} onChange={e => setPnForm(p => ({...p, similarPart: e.target.value}))} placeholder="e.g. 80566-001" style={inputStyle} /></div>
                  <div><Lbl>Changes from Similar P/N</Lbl><textarea value={pnForm.similarChanges} onChange={e => setPnForm(p => ({...p, similarChanges: e.target.value}))} placeholder="Describe differences..." style={{ ...inputStyle, height: 36, resize: 'vertical' as const, width: '100%' }} /></div>
                </div>
              )}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowNewPNModal(false)} style={{ padding: '7px 16px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>Cancel</button>
                <button onClick={() => setStep(2)} disabled={!pnForm.reason.trim() || (!pnForm.isNewParent && !pnForm.existingParent.trim())}
                  style={{ padding: '7px 20px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: theme.accent, color: '#fff', border: 'none', cursor: 'pointer', opacity: !pnForm.reason.trim() || (!pnForm.isNewParent && !pnForm.existingParent.trim()) ? 0.5 : 1 }}>
                  Next →
                </button>
              </div>
            </>)}

            {/* Step 2: Part Details */}
            {step === 2 && (<>
              <div style={{ marginBottom: 12 }}><Lbl>Part Description</Lbl><input value={pnForm.partDescription} onChange={e => setPnForm(p => ({...p, partDescription: e.target.value}))} placeholder="Material, Type, Heat Treatment, Other HT, Size/Dim" style={inputStyle} /></div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 12 }}>
                <div><Lbl>UoM - Inventory</Lbl><select value={pnForm.uomInventory} onChange={e => setPnForm(p => ({...p, uomInventory: e.target.value}))} style={inputStyle}><option value="">Select...</option>{getList('UoM').map((v:string) => <option key={v} value={v}>{v}</option>)}</select></div>
                <div><Lbl>UoM - Sales</Lbl><select value={pnForm.uomSales} onChange={e => setPnForm(p => ({...p, uomSales: e.target.value}))} style={inputStyle}><option value="">Select...</option>{getList('UoM').map((v:string) => <option key={v} value={v}>{v}</option>)}</select></div>
                <div><Lbl>UoM - Purchasing</Lbl><select value={pnForm.uomPurchasing} onChange={e => setPnForm(p => ({...p, uomPurchasing: e.target.value}))} style={inputStyle}><option value="">Select...</option>{getList('UoM').map((v:string) => <option key={v} value={v}>{v}</option>)}</select></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
                <div><Lbl>Product Group</Lbl><select value={pnForm.productGroup} onChange={e => setPnForm(p => ({...p, productGroup: e.target.value}))} style={inputStyle}><option value="">Select...</option>{getList('Group').map((v:string) => <option key={v} value={v}>{v}</option>)}</select></div>
                <div><Lbl>Product Class</Lbl><select value={pnForm.productClass} onChange={e => setPnForm(p => ({...p, productClass: e.target.value}))} style={inputStyle}><option value="">Select...</option>{getList('Class').map((v:string) => <option key={v} value={v}>{v}</option>)}</select></div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 12 }}>
                <div><Lbl>Costing Lot</Lbl><input value={pnForm.costingLot} onChange={e => setPnForm(p => ({...p, costingLot: e.target.value}))} placeholder={pnForm.isPurchased ? 'Unit buy size' : 'Qty per job'} style={inputStyle} /></div>
                <div><Lbl>Shelf Life (days)</Lbl><input type="number" value={pnForm.shelfLifeDays} onChange={e => setPnForm(p => ({...p, shelfLifeDays: e.target.value}))} style={inputStyle} /></div>
                <div><Lbl>Country of Origin</Lbl><input value={pnForm.countryOfOrigin} onChange={e => setPnForm(p => ({...p, countryOfOrigin: e.target.value}))} placeholder="e.g. USA" style={inputStyle} /></div>
              </div>
              <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: theme.text, cursor: 'pointer' }}>
                  <input type="checkbox" checked={pnForm.mfgDateTracking} onChange={e => setPnForm(p => ({...p, mfgDateTracking: e.target.checked}))} /> Mfg Date Tracking
                </label>
              </div>
              <div style={{ marginBottom: 12 }}>
                <Lbl>Upload Files</Lbl>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, fontSize: 11 }}>
                  <div><span style={{ color: theme.red, fontWeight: 600 }}>Specification (required):</span> <input type="file" id="pn-spec-file" style={{ fontSize: 11 }} /></div>
                  <div><span style={{ color: theme.textDim }}>BL-1200:</span> <input type="file" id="pn-bl1200-file" style={{ fontSize: 11 }} /></div>
                  {pnForm.isPurchased && <div><span style={{ color: theme.textDim }}>SDS:</span> <input type="file" id="pn-sds-file" style={{ fontSize: 11 }} /></div>}
                  {!pnForm.isPurchased && <div><span style={{ color: theme.textDim }}>BOM:</span> <input type="file" id="pn-bom-file" style={{ fontSize: 11 }} /></div>}
                  {!pnForm.isPurchased && <div><span style={{ color: theme.textDim }}>Route Sheet:</span> <input type="file" id="pn-rs-file" style={{ fontSize: 11 }} /></div>}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                <button onClick={() => setStep(1)} style={{ padding: '7px 16px', borderRadius: 8, fontSize: 12, background: 'transparent', color: theme.textMuted, border: `1px solid ${theme.border}`, cursor: 'pointer' }}>← Back</button>
                <button disabled={!pnForm.partDescription.trim() || submitting} onClick={async () => {
                  setSubmitting(true);
                  try {
                    const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                    const fd = new FormData();
                    fd.append('scenario', scenario);
                    fd.append('existing_parent_number', pnForm.existingParent);
                    fd.append('new_suffix', pnForm.newSuffix || '001');
                    fd.append('part_description', pnForm.partDescription);
                    fd.append('costing_lot', pnForm.costingLot);
                    fd.append('uom_inventory', pnForm.uomInventory);
                    fd.append('uom_sales', pnForm.uomSales);
                    fd.append('uom_purchasing', pnForm.uomPurchasing);
                    fd.append('product_group', pnForm.productGroup);
                    fd.append('product_class', pnForm.productClass);
                    fd.append('mfg_date_tracking', String(pnForm.mfgDateTracking));
                    fd.append('shelf_life_days', pnForm.shelfLifeDays);
                    fd.append('country_of_origin', pnForm.countryOfOrigin);
                    fd.append('reason', pnForm.reason);
                    fd.append('similar_part_number', pnForm.similarPart);
                    fd.append('similar_part_changes', pnForm.similarChanges);
                    // Files
                    const specF = (document.getElementById('pn-spec-file') as HTMLInputElement)?.files?.[0];
                    const blF = (document.getElementById('pn-bl1200-file') as HTMLInputElement)?.files?.[0];
                    const sdsF = (document.getElementById('pn-sds-file') as HTMLInputElement)?.files?.[0];
                    const bomF = (document.getElementById('pn-bom-file') as HTMLInputElement)?.files?.[0];
                    const rsF = (document.getElementById('pn-rs-file') as HTMLInputElement)?.files?.[0];
                    if (!specF) { alert('Specification file is required. Please upload a spec before submitting.'); setSubmitting(false); return; }
                    if (specF) fd.append('spec_file', specF);
                    if (blF) fd.append('bl1200_file', blF);
                    if (sdsF) fd.append('sds_file', sdsF);
                    if (bomF) fd.append('bom_file', bomF);
                    if (rsF) fd.append('route_sheet_file', rsF);

                    const res = await fetch('/api/quality-docs/pn-requests/', {
                      method: 'POST', credentials: 'same-origin',
                      headers: { 'X-CSRFToken': csrfToken }, body: fd,
                    });
                    if (res.ok) {
                      const data = await res.json();
                      setShowNewPNModal(false);
                      loadPending();
                      alert(`${data.tracking_number} submitted — Part: ${data.allocated_part_number}. QM has been notified.`);
                    } else {
                      const err = await res.json().catch(() => ({ detail: 'Failed' }));
                      alert(err.detail || 'Submission failed');
                    }
                  } catch (e: any) { alert('Error: ' + e.message); }
                  setSubmitting(false);
                }} style={{ padding: '7px 20px', borderRadius: 8, fontSize: 12, fontWeight: 600, background: theme.accent, color: '#fff', border: 'none', cursor: 'pointer', opacity: !pnForm.partDescription.trim() || submitting ? 0.5 : 1 }}>
                  {submitting ? 'Submitting...' : 'Submit Request'}
                </button>
              </div>
            </>)}
          </div>
        </div>
        );
      })()}
    </div>
  );
};


// ─── App Shell ──────────────────────────────────────────────────────────────
export default function App() {
  const [page, setPage] = useState("dashboard");
  const [modal, setModal] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [time, setTime] = useState(new Date());
  const [loggedIn, setLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [isDark, setIsDark] = useState(themeMode === 'dark');
  const [showNotifications, setShowNotifications] = useState(false);
  const [notifications, setNotifications] = useState<any[]>([]);
  const [notifPending, setNotifPending] = useState({ eo_signoffs: [], doc_reviews: [], archive_requests: [], total_pending: 0 });
  const [bellUsers, setBellUsers] = useState<any[]>([]);
  const [pendingNav, setPendingNav] = useState<any>(null);
  const [messagingUnread, setMessagingUnread] = useState(0);

  const toggleTheme = () => {
    const newMode = isDark ? 'light' : 'dark';
    themeMode = newMode;
    theme = newMode === 'light' ? lightTheme : darkTheme;
    (window as any).__ENGPORTAL_THEME = theme;
    try { localStorage.setItem('engportal-theme', newMode); } catch(e) {}
    try { document.documentElement.setAttribute('data-theme', newMode); } catch(e) {}
    setIsDark(!isDark);
  };

  useEffect(() => { const t = setInterval(() => setTime(new Date()), 60000); return () => clearInterval(t); }, []);

  // Fetch notifications and pending items periodically
  const loadNotifications = useCallback(() => {
    if (!loggedIn) return;
    // System notifications
    fetch('/api/notifications/', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : [])
      .then(d => setNotifications(Array.isArray(d) ? d : d.results || []))
      .catch(() => {});
    // Quality doc pending items
    fetch('/api/quality-docs/eo/my-pending/', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : { eo_signoffs: [], doc_reviews: [], total_pending: 0 })
      .then(setNotifPending)
      .catch(() => {});
  }, [loggedIn]);

  useEffect(() => {
    loadNotifications();
    const interval = setInterval(loadNotifications, 120000); // Refresh every 2 min
    return () => clearInterval(interval);
  }, [loadNotifications]);

  // Handle SSO callback (Keycloak redirects back with ?code=...)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    if (code && !loggedIn) {
      // Exchange auth code for token via backend
      const exchangeCode = async () => {
        try {
          const keycloakBase = window.location.origin + '/auth';
          const tokenUrl = keycloakBase + '/realms/engportal/protocol/openid-connect/token';
          const redirectUri = window.location.origin + '/';

          const body = new URLSearchParams({
            grant_type: 'authorization_code',
            code: code,
            client_id: 'engportal-frontend',
            redirect_uri: redirectUri,
          });

          const tokenRes = await fetch(tokenUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: body.toString(),
          });

          if (tokenRes.ok) {
            const tokens = await tokenRes.json();
            // Store the access token for API calls
            window._ssoToken = tokens.access_token;

            // Create a Django session using the token
            const csrfRes = await fetch('/api/auth/session-login/', { method: 'GET', credentials: 'same-origin' });
            const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';

            const sessionRes = await fetch('/api/auth/sso-session/', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken, 'Authorization': 'Bearer ' + tokens.access_token },
              body: JSON.stringify({ access_token: tokens.access_token }),
            });

            if (sessionRes.ok) {
              const user = await sessionRes.json();
              setLoggedIn(true);
              setCurrentUser(user);
            } else {
              // Fallback: at least the Bearer token works for API
              setLoggedIn(true);
              setCurrentUser({ username: 'SSO User', role: '' });
            }
          }
        } catch (e) {
          console.error('SSO token exchange failed:', e);
        }
        // Clean URL
        window.history.replaceState({}, '', window.location.pathname);
        setCheckingAuth(false);
      };
      exchangeCode();
      return; // Don't run the session check below
    }
  }, []);

  // Check for existing session on load
  useEffect(() => {
    if (loggedIn) return;
    const params = new URLSearchParams(window.location.search);
    if (params.get('code')) { return; } // SSO callback handles this
    fetch('/api/auth/session-login/', { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data && data.authenticated) { setLoggedIn(true); setCurrentUser(data); }
      })
      .catch(() => {})
      .finally(() => setCheckingAuth(false));
  }, []);

  if (checkingAuth) {
    return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: theme.bg, color: theme.textDim }}>Loading...</div>;
  }

  if (!loggedIn) {
    return (
      <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: theme.bg }}>
        <SecurityBanner />
        <div style={{ flex: 1, minHeight: 0 }}>
          <LoginPage onLogin={(user) => { setLoggedIn(true); setCurrentUser(user); }} />
        </div>
      </div>
    );
  }

  const renderPage = () => {
    switch (page) {
      case "dashboard": return <DashboardPage onNav={setPage} openModal={setModal} onAddSample={() => { setPage("inventory"); setPendingNav("new-trial"); }} />;
      case "programs": return <ProgramsPage />;
      case "sprint": return <SprintPage />;
      case "kanban": return <KanbanPage />;
      case "equipment": return <EquipmentPage openModal={setModal} />;
      case "inventory": return <InventoryPage openModal={setModal} pendingNav={pendingNav} clearPendingNav={() => setPendingNav(null)} />;
      case "workorders": return <WorkOrdersPage openModal={setModal} />;
      case "documents": return <DocumentsPage />;
      case "hr": return <HRPage currentUser={currentUser} />;
      case "quality-docs": return <QualityDocsPage currentUser={currentUser} pendingNav={pendingNav} clearPendingNav={() => setPendingNav(null)} />;
      case "messaging": return <MessagingPage currentUser={currentUser} onUnreadChange={setMessagingUnread} />;
      case "customers": return <CustomersPage currentUser={currentUser} />;
      case "sales": return <SalesPage currentUser={currentUser} />;
      case "team": return <TeamWinsPage />;
      case "metrics": return <MetricsPage />;
      case "import": return <ImportPage />;
      case "labels": return <LabelDesignerPage />;
      case "epicor": return <EpicorReportsPage />;
      case "operations": return <div style={{ height: "100%", minHeight: 520, display: "flex", flexDirection: "column" }}><OpsTrackerFrame /></div>;
      case "materials": return <MaterialTrackerPage />;
      case "cornhole": return <CornholePage />;
      default: {
        const nav = NAV.find(n => n.id === page);
        return <PlaceholderPage title={nav?.label || page} icon={nav?.icon || <Icons.Home size={48}/>} />;
      }
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: theme.bg, fontFamily: "'IBM Plex Sans', -apple-system, system-ui, sans-serif", color: theme.text }}>
      <SecurityBanner />
      <div style={{ display: "flex", flex: 1, minHeight: 0 }}>
      {/* Sidebar */}
      <aside style={{
        width: sidebarCollapsed ? 60 : 220, background: theme.surface, borderRight: `1px solid ${theme.border}`,
        display: "flex", flexDirection: "column", transition: "width 0.25s ease", overflow: "hidden", flexShrink: 0
      }}>
        {/* Brand */}
        <div style={{ padding: sidebarCollapsed ? "12px 8px" : "14px 16px", borderBottom: `1px solid ${theme.border}`, cursor: "pointer", display: "flex", alignItems: "center", gap: 10, minHeight: 56 }}
             onClick={() => setSidebarCollapsed(!sidebarCollapsed)}>
          {sidebarCollapsed ? (
            <img src="/img/logo-sidebar.png" alt="AvCarb" style={{ width: 36, height: "auto", objectFit: "contain", filter: "brightness(1.1)" }} />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <img src="/img/logo-sidebar.png" alt="AvCarb" style={{ width: 120, height: "auto", objectFit: "contain", filter: "brightness(1.1)" }} />
              <div style={{ fontSize: 10, color: theme.textDim, fontWeight: 500, letterSpacing: 1.5, textTransform: "uppercase", paddingLeft: 2 }}>Engineering Dashboard</div>
            </div>
          )}
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, padding: "12px 8px", overflowY: "auto" }}>
          {NAV.map(n => (
            <div key={n.id} onClick={() => setPage(n.id)} style={{
              display: "flex", alignItems: "center", gap: 12, padding: sidebarCollapsed ? "10px 12px" : "9px 14px",
              borderRadius: 8, marginBottom: 2, cursor: "pointer", transition: "all 0.15s",
              background: page === n.id ? theme.accentGlow : "transparent",
              color: page === n.id ? theme.accent : theme.textMuted,
              borderLeft: page === n.id ? `2px solid ${theme.accent}` : "2px solid transparent"
            }} onMouseEnter={e => { if (page !== n.id) { e.currentTarget.style.background = theme.surfaceHover; e.currentTarget.style.color = theme.text; }}}
               onMouseLeave={e => { if (page !== n.id) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = theme.textMuted; }}}>
              {n.icon}
              {(n as any).badge && messagingUnread > 0 && <span style={{ background: theme.red, color: "#fff", fontSize: 10, fontWeight: 700, padding: "1px 6px", borderRadius: 10, marginLeft: "auto", flexShrink: 0 }}>{messagingUnread}</span>}
              {!sidebarCollapsed && <span style={{ fontSize: 13, fontWeight: page === n.id ? 600 : 400 }}>{n.label}</span>}
            </div>
          ))}
        </nav>

        {/* User */}
        <div style={{ padding: sidebarCollapsed ? "12px 10px" : "12px 16px", borderTop: `1px solid ${theme.border}`, display: "flex", alignItems: "center", gap: 10 }}>
          <div onClick={() => setModal("profile")} title="View profile & change password" style={{ display: "flex", alignItems: "center", gap: 10, flex: 1, minWidth: 0, cursor: "pointer" }}>
            <div style={{ width: 32, height: 32, borderRadius: "50%", background: theme.accent, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, fontWeight: 700, color: "#fff", flexShrink: 0 }}>{(currentUser?.full_name || currentUser?.username || 'U').substring(0,2).toUpperCase()}</div>
            {!sidebarCollapsed && (
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 500, color: theme.text, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{currentUser?.full_name || currentUser?.username || 'User'}</div>
                <div style={{ fontSize: 10, color: theme.textDim }}>{currentUser?.role?.replace(/_/g,' ') || ''}</div>
              </div>
            )}
          </div>
          {!sidebarCollapsed && (
            <button onClick={() => {
              // Clear Django session
              fetch('/api/auth/session-login/', { method: 'DELETE', credentials: 'same-origin',
                headers: { 'X-CSRFToken': document.cookie.split('csrftoken=')[1]?.split(';')[0] || '' }
              }).catch(() => {});
              setLoggedIn(false); setCurrentUser(null);
            }} title="Sign Out" style={{ background: 'none', border: 'none', color: theme.textDim, cursor: 'pointer', padding: 4, fontSize: 16, lineHeight: 1 }}>
              ⏻
            </button>
          )}
        </div>
      </aside>

      {/* Main Area */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        {/* Top Bar */}
        <header style={{
          height: 50, background: theme.surface, borderBottom: `1px solid ${theme.border}`,
          display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 24px", flexShrink: 0
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ position: "relative" }}>
              <input placeholder="Search everything..." style={{
                background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8,
                padding: "7px 14px 7px 34px", color: theme.text, fontSize: 13, width: 260, outline: "none"
              }} />
              <Icons.Search size={14} color={theme.textDim} style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)" }} />
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <span style={{ color: theme.textDim, fontSize: 12 }}>{time.toLocaleDateString("en-US", { weekday: "long", month: "short", day: "numeric" })}</span>
            <button onClick={toggleTheme} title={isDark ? "Switch to Light Mode" : "Switch to Dark Mode"} style={{ background: "none", border: "none", cursor: "pointer", padding: 4, color: theme.textMuted }}>
              {isDark ? <Icons.Sun size={18}/> : <Icons.Moon size={18}/>}
            </button>
            <div style={{ position: "relative" }}>
              <button onClick={() => {
                setShowNotifications(!showNotifications);
                if (!showNotifications && !bellUsers.length) {
                  fetch('/api/quality-docs/users-with-tags/', { credentials: 'same-origin' }).then(r => r.ok ? r.json() : []).then(d => setBellUsers(Array.isArray(d) ? d : [])).catch(() => {});
                }
              }}
                style={{ background: "none", border: "none", cursor: "pointer", padding: 4, color: theme.textMuted, position: "relative" }}>
                <Icons.Bell size={18} color={theme.textMuted} />
                {(notifPending.total_pending > 0 || notifications.filter((n:any) => !n.read).length > 0) && (
                  <div style={{
                    position: "absolute", top: -2, right: -2, minWidth: 16, height: 16,
                    borderRadius: 8, background: theme.red, border: `2px solid ${theme.surface}`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 9, fontWeight: 700, color: "#fff", padding: "0 3px",
                  }}>
                    {notifPending.total_pending + notifications.filter((n:any) => !n.read).length}
                  </div>
                )}
              </button>

              {/* Notification Dropdown */}
              {showNotifications && (
                <div style={{
                  position: "absolute", top: "100%", right: 0, marginTop: 8,
                  width: 380, maxHeight: '80vh', background: theme.surface,
                  borderRadius: 12, border: `1px solid ${theme.border}`,
                  boxShadow: "0 12px 40px rgba(0,0,0,0.3)", zIndex: 9999,
                  display: "flex", flexDirection: "column", overflow: "hidden",
                }}>
                  <div style={{
                    padding: "12px 16px", borderBottom: `1px solid ${theme.border}`,
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                  }}>
                    <span style={{ fontSize: 14, fontWeight: 700, color: theme.text }}>Notifications</span>
                    {notifications.filter((n:any) => !n.read).length > 0 && (
                      <button onClick={async () => {
                        const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                        try {
                          const res = await fetch('/api/notifications/mark-all-read/', {
                            method: 'POST', credentials: 'same-origin',
                            headers: { 'X-CSRFToken': csrfToken },
                          });
                          if (!res.ok) throw new Error('HTTP ' + res.status);
                          loadNotifications();
                        } catch (err: any) {
                          alert('Could not mark all as read (' + (err.message || 'error') + '). Please try again.');
                        }
                      }} style={{
                        fontSize: 10, color: theme.accent, background: "none", border: "none",
                        cursor: "pointer", fontWeight: 600,
                      }}>Mark all read</button>
                    )}
                  </div>
                  <div style={{ overflow: "auto", flex: 1 }}>
                    {/* Pending EO Signoffs */}
                    {notifPending.eo_signoffs.length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>
                          EO Signoffs Required
                        </div>
                        {notifPending.eo_signoffs.map((s: any) => (
                          <div key={s.signoff_id} onClick={() => { setPage("quality-docs"); setShowNotifications(false); }}
                            style={{ padding: "10px 16px", cursor: "pointer", borderBottom: `1px solid ${theme.border}05` }}
                            onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: theme.yellow }}>{s.display_number || ('EO-' + s.eo_number)}</div>
                            <div style={{ fontSize: 11, color: theme.text }}>{s.document_title}</div>
                            <div style={{ fontSize: 10, color: theme.textDim }}>
                              From {s.created_by} · {s.submitted_at ? new Date(s.submitted_at).toLocaleDateString() : ""}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Pending Document Reviews */}
                    {notifPending.doc_reviews.length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>
                          Document Reviews Due
                        </div>
                        {notifPending.doc_reviews.map((d: any) => (
                          <div key={d.doc_id} onClick={() => {
                            setPage("quality-docs"); setShowNotifications(false);
                            setPendingNav({ tab: 'all', docId: d.doc_id });
                          }}
                            style={{ padding: "10px 16px", cursor: "pointer" }}
                            onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: d.days_until < 0 ? theme.red : theme.accent }}>{d.document_number || d.system_doc_number}</div>
                            <div style={{ fontSize: 11, color: theme.text }}>{d.description}</div>
                            <div style={{ fontSize: 10, color: d.days_until < 0 ? theme.red : theme.textDim }}>
                              {d.days_until < 0 ? `Overdue by ${Math.abs(d.days_until)} days` : `Due in ${d.days_until} days`}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Pending Change Review Votes */}
                    {(notifPending.change_review_votes || []).length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>
                          Document Reviews — Your Vote Needed
                        </div>
                        {(notifPending.change_review_votes || []).map((v: any, i: number) => (
                          <div key={i} onClick={() => {
                            setPage("quality-docs"); setShowNotifications(false);
                            setPendingNav({ tab: 'reviews', reviewId: v.review_id });
                          }}
                            style={{ padding: "10px 16px", cursor: "pointer" }}
                            onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: theme.accent }}>{v.tracking_number}</div>
                            <div style={{ fontSize: 11, color: theme.text }}>{v.document_number} — {v.description}</div>
                            <div style={{ fontSize: 10, color: theme.textDim }}>Round {v.review_round} · From {v.requested_by}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Change Reviews Awaiting QM */}
                    {(notifPending.change_reviews_pending_qm || []).length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>
                          Change Reviews — Assign Team
                        </div>
                        {(notifPending.change_reviews_pending_qm || []).map((cr: any, i: number) => (
                          <div key={i} onClick={() => {
                            setPage("quality-docs"); setShowNotifications(false);
                            setPendingNav({ tab: 'reviews', reviewId: cr.id });
                          }}
                            style={{ padding: "10px 16px", cursor: "pointer" }}
                            onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: theme.yellow }}>{cr.tracking_number}</div>
                            <div style={{ fontSize: 11, color: theme.text }}>{cr.document_number} — {cr.description}</div>
                            <div style={{ fontSize: 10, color: theme.textDim }}>From {cr.requested_by}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Pending Archive Requests (QM only) */}
                    {(notifPending.archive_requests || []).length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>
                          Archive Requests
                        </div>
                        {(notifPending.archive_requests || []).map((ar: any) => (
                          <div key={ar.id} style={{ padding: "10px 16px", borderBottom: `1px solid ${theme.border}08` }}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: theme.red }}>{ar.system_doc_number}</div>
                            <div style={{ fontSize: 11, color: theme.text }}>{ar.description}</div>
                            <div style={{ fontSize: 10, color: theme.textDim, marginBottom: 6 }}>
                              Requested by {ar.requested_by} — {ar.reason}
                            </div>
                            <div style={{ display: "flex", gap: 6 }}>
                              <button onClick={async () => {
                                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                const res = await fetch('/api/quality-docs/archive-requests/' + ar.id + '/respond/', {
                                  method: 'POST', credentials: 'same-origin',
                                  headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                  body: JSON.stringify({ action: 'approve' }),
                                });
                                if (res.ok) { loadNotifications(); } else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
                              }} style={{
                                padding: "3px 10px", borderRadius: 4, fontSize: 10, fontWeight: 600,
                                background: theme.green + "15", color: theme.green, border: `1px solid ${theme.green}33`, cursor: "pointer",
                              }}>Approve Archive</button>
                              <button onClick={async () => {
                                const reason = prompt('Reason for rejecting the archive request:');
                                if (reason === null) return;
                                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                const res = await fetch('/api/quality-docs/archive-requests/' + ar.id + '/respond/', {
                                  method: 'POST', credentials: 'same-origin',
                                  headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                  body: JSON.stringify({ action: 'reject', reason }),
                                });
                                if (res.ok) { loadNotifications(); } else { const err = await res.json().catch(() => ({ detail: 'Failed' })); alert(err.detail); }
                              }} style={{
                                padding: "3px 10px", borderRadius: 4, fontSize: 10, fontWeight: 600,
                                background: theme.red + "10", color: theme.red, border: `1px solid ${theme.red}33`, cursor: "pointer",
                              }}>Reject</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* New Document Requests (QM) */}
                    {(notifPending.new_doc_requests || []).length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>New Document Requests</div>
                        {(notifPending.new_doc_requests || []).map((nd: any) => (
                          <div key={nd.id} style={{ padding: "10px 16px" }}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: theme.green }}>{nd.document_number} ({nd.category})</div>
                            <div style={{ fontSize: 11, color: theme.text }}>{nd.title}</div>
                            <div style={{ fontSize: 10, color: theme.textDim, marginBottom: 6 }}>From {nd.requested_by}</div>
                            {/* Reviewer selection */}
                            <select id={`ndr-reviewers-${nd.id}`} multiple style={{ width: "100%", fontSize: 10, padding: 4, marginBottom: 6, background: theme.bg, color: theme.text, border: `1px solid ${theme.border}`, borderRadius: 6, height: 50 }}>
                              {bellUsers.map((u: any) => <option key={u.id} value={u.id}>{u.name || `${u.first_name} ${u.last_name}`}</option>)}
                            </select>
                            <div style={{ display: "flex", gap: 6 }}>
                              <button onClick={async () => {
                                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                await fetch('/api/quality-docs/new-doc-requests/' + nd.id + '/respond/', {
                                  method: 'POST', credentials: 'same-origin',
                                  headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                  body: JSON.stringify({ action: 'approve' }),
                                });
                                loadNotifications(); loadDocuments();
                              }} style={{ padding: "3px 10px", borderRadius: 4, fontSize: 10, fontWeight: 600, background: theme.green + "15", color: theme.green, border: `1px solid ${theme.green}33`, cursor: "pointer" }}>Approve (Active)</button>
                              <button onClick={async () => {
                                const sel = document.getElementById('ndr-reviewers-' + nd.id) as HTMLSelectElement;
                                const ids = Array.from(sel.selectedOptions).map(o => Number(o.value));
                                if (!ids.length) { alert('Select at least one reviewer.'); return; }
                                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                const res = await fetch('/api/quality-docs/new-doc-requests/' + nd.id + '/respond/', {
                                  method: 'POST', credentials: 'same-origin',
                                  headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                  body: JSON.stringify({ action: 'send_for_review', review_team: ids }),
                                });
                                if (res.ok) { loadNotifications(); loadChangeReviews({force:true}); alert('Sent for review.'); }
                                else { const err = await res.json().catch(() => ({detail:'Failed'})); alert(err.detail); }
                              }} style={{ padding: "3px 10px", borderRadius: 4, fontSize: 10, fontWeight: 600, background: theme.accent + "15", color: theme.accent, border: `1px solid ${theme.accent}33`, cursor: "pointer" }}>Send for Review</button>
                              <button onClick={async () => {
                                const reason = prompt('Reason for rejecting:');
                                if (reason === null) return;
                                const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                await fetch('/api/quality-docs/new-doc-requests/' + nd.id + '/respond/', {
                                  method: 'POST', credentials: 'same-origin',
                                  headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                  body: JSON.stringify({ action: 'reject', reason }),
                                });
                                loadNotifications(); loadDocuments();
                              }} style={{ padding: "3px 10px", borderRadius: 4, fontSize: 10, fontWeight: 600, background: theme.red + "10", color: theme.red, border: `1px solid ${theme.red}33`, cursor: "pointer" }}>Reject</button>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Part Number Requests (QM) */}
                    {(notifPending.part_number_requests || []).length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>Part Number Requests</div>
                        {(notifPending.part_number_requests || []).map((pn: any) => (
                          <div key={pn.id} onClick={() => {
                            setPage("quality-docs"); setShowNotifications(false);
                            setPendingNav({ tab: 'pn_requests', pnId: pn.id });
                          }} style={{ padding: "10px 16px", cursor: "pointer" }}
                            onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: theme.accent }}>{pn.tracking_number || pn.part_number}</div>
                            <div style={{ fontSize: 11, color: theme.text }}>{pn.description} — {pn.scenario}</div>
                            <div style={{ fontSize: 10, color: theme.textDim }}>From {pn.requested_by}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* System Notifications */}
                    {/* PN Review Cards — your cards to complete */}
                    {(notifPending.pn_review_cards || []).length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>
                          Part Number Review Cards
                        </div>
                        {(notifPending.pn_review_cards || []).map((card: any) => (
                          <div key={card.id} onClick={async () => {
                            setPage("quality-docs"); setShowNotifications(false);
                            setPendingNav({ tab: 'pn_requests', pnId: card.request_id });
                          }}
                            style={{ padding: "10px 16px", cursor: "pointer" }}
                            onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div style={{ fontSize: 12, fontWeight: 600, color: theme.yellow }}>{card.tracking_number}</div>
                            <div style={{ fontSize: 11, color: theme.text }}>{card.part_number} — {card.card_type}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {notifications.length > 0 && (
                      <div style={{ padding: "8px 0" }}>
                        <div style={{ padding: "4px 16px", fontSize: 9, fontWeight: 700, color: theme.textDim, textTransform: "uppercase", letterSpacing: 1 }}>
                          System
                        </div>
                        {notifications.slice(0, 15).map((n: any) => (
                          <div key={n.id}
                            title={n.read ? 'Read' : 'Click to mark as read'}
                            onClick={async () => {
                              if (!n.read) {
                                try {
                                  const csrfToken = document.cookie.split('csrftoken=')[1]?.split(';')[0] || '';
                                  const res = await fetch('/api/notifications/' + n.id + '/', {
                                    method: 'PATCH', credentials: 'same-origin',
                                    headers: { 'Content-Type': 'application/json', 'X-CSRFToken': csrfToken },
                                    body: JSON.stringify({ read: true }),
                                  });
                                  if (!res.ok) throw new Error('HTTP ' + res.status);
                                  loadNotifications();
                                } catch (err) {
                                  alert('Could not mark this notification as read. Please try again.');
                                }
                              }
                              if (n.url) {
                                const page = String(n.url).replace(/^\//, '').split('/')[0];
                                if (page) { setPage(page); setShowNotifications(false); }
                              }
                            }}
                            style={{
                              padding: "10px 16px", borderLeft: n.read ? "none" : `3px solid ${theme.accent}`,
                              cursor: "pointer", opacity: n.read ? 0.6 : 1,
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = theme.surfaceHover}
                            onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                            <div style={{ fontSize: 11, color: theme.text }}>{n.message || n.title || n.context}</div>
                            <div style={{ fontSize: 10, color: theme.textDim }}>{n.time || n.created_at ? new Date(n.created_at || n.time).toLocaleString() : ""}</div>
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Empty state */}
                    {notifPending.total_pending === 0 && notifications.length === 0 && (
                      <div style={{ padding: 30, textAlign: "center", color: theme.textDim, fontSize: 12 }}>
                        No notifications
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main onClick={() => showNotifications && setShowNotifications(false)} style={{ flex: 1, overflow: "auto", padding: 24 }}>
          {renderPage()}
        </main>
      </div>
      </div>

      {/* Modals */}
      <QuickInventoryForm open={modal === "inventory"} onClose={() => setModal(null)} />
      <QuickWorkOrderForm open={modal === "workorder"} onClose={() => setModal(null)} />
      <QuickBookingForm open={modal === "booking"} onClose={() => setModal(null)} />
      <QuickHelpForm open={modal === "help"} onClose={() => setModal(null)} />
      <QuickStandupForm open={modal === "standup"} onClose={() => setModal(null)} />
      <QuickTaskForm open={modal === "task"} onClose={() => setModal(null)} />
      <ProfileModal open={modal === "profile"} onClose={() => setModal(null)} currentUser={currentUser} />
    </div>
  );
}
